//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export module MdbsCore {
export class BaseClient {
    private readonly _baseUrl!: string;
    public static REFRESH_TOKEN_EXPIRED_MESSAGE: string = "refresh token expired";

    protected getBaseUrl(url: string) {
        return this._baseUrl;
    }

    protected constructor() {
        if (process.env.NODE_ENV === "development") {
            this._baseUrl = "https://" + window.location.hostname + ":5001";
        } else {
            this._baseUrl = window.location.origin;
        }
    }

    protected transformOptions = (options: AxiosRequestConfig): Promise < AxiosRequestConfig >  => {
        const isRefresh = options.url?.endsWith("/Auth/refreshLogin");
        const token = isRefresh ? sessionStorage.getItem("refreshToken") : sessionStorage.getItem("token");
        if (token != null) {
            options.headers = {
                ...options.headers,
                Authorization: 'Bearer ' + token,
            };
        }

        return Promise.resolve(options);
    }

    protected async transformResult(url : string, response: AxiosResponse, processor: (response: AxiosResponse) => Promise < any > ): Promise < any > {
        if (response.status === 401 && !url.endsWith("/Auth/refreshLogin")) {
            console.log("authentication expired... maybe...")
            try {
                response = await this.refreshLoginToken(response.config);
            } catch (error) {
                if (isAxiosError(error) && error.response) {
                    return error.response;
                } else {
                    throw error;
                }
            }
        }

        return processor(response);
    }

    private async refreshLoginToken(config: AxiosRequestConfig): Promise < any > {
        let refreshTokenResponse: TokenDto | undefined;
        try {
            refreshTokenResponse = await new AuthClient(this._baseUrl, axios).refreshLogin();

            sessionStorage.setItem('token', refreshTokenResponse?.token ?? "");
            sessionStorage.setItem('refreshToken', refreshTokenResponse?.refreshToken ?? "");

            config.headers.Authorization = "Bearer " + refreshTokenResponse?.token;

            return axios(config);
        } catch (e) {
            throwException(BaseClient.REFRESH_TOKEN_EXPIRED_MESSAGE, 401, "", []);
        }
    }
}

export class AkromegalieDataVisualizationClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param visualizationType (optional)
     * @return Request completed successfully
     */
    getVisualizationData(visualizationType: string | null | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/AkromegalieDataVisualization/get-visualization-data?";
        if (visualizationType !== undefined && visualizationType !== null)
            url_ += "visualizationType=" + encodeURIComponent("" + visualizationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVisualizationData(_response));
        });
    }

    protected processGetVisualizationData(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param visualizationType (optional)
     * @return Request completed successfully
     */
    getMytVisualizationData(visualizationType: string | null | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/AkromegalieDataVisualization/get-my_visualization-data?";
        if (visualizationType !== undefined && visualizationType !== null)
            url_ += "visualizationType=" + encodeURIComponent("" + visualizationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMytVisualizationData(_response));
        });
    }

    protected processGetMytVisualizationData(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class AkromegalieEventReportSendJobClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request successfully processed
     */
    forceEmailJob( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AkromegalieEventReportSendJob/forceemailjob";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForceEmailJob(_response));
        });
    }

    protected processForceEmailJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class AkromegalieExportClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getStatusExport(studyId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/AkromegalieExport/study/{studyId}/status-export";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStatusExport(_response));
        });
    }

    protected processGetStatusExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getStatusExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/AkromegalieExport/status-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStatusExportList(_response));
        });
    }

    protected processGetStatusExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getStatusExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/AkromegalieExport/status-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStatusExportFile(_response));
        });
    }

    protected processGetStatusExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AuditLogClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param identifiers (optional)
     * @param from (optional)
     * @param to (optional)
     * @param userId (optional)
     * @param action (optional)
     * @return Request completed successfully
     */
    exportAuditLog(identifiers: string[] | null | undefined, from: Date | null | undefined, to: Date | null | undefined, userId: string | null | undefined, action: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/AuditLog/GetAuditLogExport?";
        if (identifiers !== undefined && identifiers !== null)
            identifiers && identifiers.forEach(item => { url_ += "Identifiers=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (action !== undefined && action !== null)
            url_ += "Action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportAuditLog(_response));
        });
    }

    protected processExportAuditLog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param skip (optional)
     * @param take (optional)
     * @param identifiers (optional)
     * @param from (optional)
     * @param to (optional)
     * @param userId (optional)
     * @param action (optional)
     * @return Request completed successfully
     */
    getAuditLogEntries(skip: number | undefined, take: number | undefined, identifiers: string[] | null | undefined, from: Date | null | undefined, to: Date | null | undefined, userId: string | null | undefined, action: string | null | undefined, cancelToken?: CancelToken): Promise<PagedResultDtoOfAuditLogEntryDto> {
        let url_ = this.baseUrl + "/api/v1/AuditLog/GetAuditLogEntries?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (identifiers !== undefined && identifiers !== null)
            identifiers && identifiers.forEach(item => { url_ += "Identifiers=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (action !== undefined && action !== null)
            url_ += "Action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAuditLogEntries(_response));
        });
    }

    protected processGetAuditLogEntries(response: AxiosResponse): Promise<PagedResultDtoOfAuditLogEntryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditLogEntryDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditLogEntryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditLogEntryDto>(null as any);
    }
}

export class AuditTrailClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getAll( cancelToken?: CancelToken): Promise<AuditEventDto[]> {
        let url_ = this.baseUrl + "/api/v1/AuditTrail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<AuditEventDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditEventDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    findAuditTrailEvent(id: number, cancelToken?: CancelToken): Promise<AuditEventDto> {
        let url_ = this.baseUrl + "/api/v1/AuditTrail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindAuditTrailEvent(_response));
        });
    }

    protected processFindAuditTrailEvent(response: AxiosResponse): Promise<AuditEventDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditEventDto.fromJS(resultData200);
            return Promise.resolve<AuditEventDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    count( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/AuditTrail/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCount(_response));
        });
    }

    protected processCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class AuthClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    login(loginDto: LoginDto, cancelToken?: CancelToken): Promise<TokenDto> {
        let url_ = this.baseUrl + "/api/v1/Auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<TokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenDto.fromJS(resultData200);
            return Promise.resolve<TokenDto>(result200);

        } else if (status === 202) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    refreshLogin( cancelToken?: CancelToken): Promise<TokenDto> {
        let url_ = this.baseUrl + "/api/v1/Auth/refreshLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshLogin(_response));
        });
    }

    protected processRefreshLogin(response: AxiosResponse): Promise<TokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenDto.fromJS(resultData200);
            return Promise.resolve<TokenDto>(result200);

        } else if (status === 202) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    logout(userId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Auth/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogout(_response));
        });
    }

    protected processLogout(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DataMigrationClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getAll( cancelToken?: CancelToken): Promise<DataMigrationStatusDto[]> {
        let url_ = this.baseUrl + "/api/v1/DataMigration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DataMigrationStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataMigrationStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataMigrationStatusDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    runAll( cancelToken?: CancelToken): Promise<DataMigrationReportDto> {
        let url_ = this.baseUrl + "/api/v1/DataMigration/run";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRunAll(_response));
        });
    }

    protected processRunAll(response: AxiosResponse): Promise<DataMigrationReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataMigrationReportDto.fromJS(resultData200);
            return Promise.resolve<DataMigrationReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataMigrationReportDto>(null as any);
    }

    /**
     * @param force (optional)
     * @return Request completed successfully
     */
    run(migrationId: string, force: boolean | undefined, cancelToken?: CancelToken): Promise<DataMigrationReportDto> {
        let url_ = this.baseUrl + "/api/v1/DataMigration/{migrationId}/run?";
        if (migrationId === undefined || migrationId === null)
            throw new Error("The parameter 'migrationId' must be defined.");
        url_ = url_.replace("{migrationId}", encodeURIComponent("" + migrationId));
        if (force === null)
            throw new Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRun(_response));
        });
    }

    protected processRun(response: AxiosResponse): Promise<DataMigrationReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataMigrationReportDto.fromJS(resultData200);
            return Promise.resolve<DataMigrationReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataMigrationReportDto>(null as any);
    }
}

export class DocumentClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAll(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<DocumentShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Document?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DocumentShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param identifier (optional)
     * @param title (optional)
     * @param description (optional)
     * @param order (optional)
     * @param tags (optional)
     * @param fileData (optional)
     * @return Object created successfully
     */
    create(identifier: string | null | undefined, title: string | null | undefined, description: string | null | undefined, order: number | undefined, tags: string | null | undefined, fileData: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<DocumentShortDto> {
        let url_ = this.baseUrl + "/api/v1/Document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (identifier !== null && identifier !== undefined)
            content_.append("Identifier", identifier.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (order === null || order === undefined)
            throw new Error("The parameter 'order' cannot be null.");
        else
            content_.append("Order", order.toString());
        if (tags !== null && tags !== undefined)
            content_.append("Tags", tags.toString());
        if (fileData !== null && fileData !== undefined)
            content_.append("FileData", fileData.data, fileData.fileName ? fileData.fileName : "FileData");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DocumentShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = DocumentShortDto.fromJS(resultData201);
            return Promise.resolve<DocumentShortDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param documentId (optional)
     * @param identifier (optional)
     * @param title (optional)
     * @param description (optional)
     * @param order (optional)
     * @param tags (optional)
     * @param fileData (optional)
     * @return Request successfully processed
     */
    updateWithContent(documentId: string | undefined, identifier: string | null | undefined, title: string | null | undefined, description: string | null | undefined, order: number | undefined, tags: string | null | undefined, fileData: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Document?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (identifier !== null && identifier !== undefined)
            content_.append("Identifier", identifier.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (order === null || order === undefined)
            throw new Error("The parameter 'order' cannot be null.");
        else
            content_.append("Order", order.toString());
        if (tags !== null && tags !== undefined)
            content_.append("Tags", tags.toString());
        if (fileData !== null && fileData !== undefined)
            content_.append("FileData", fileData.data, fileData.fileName ? fileData.fileName : "FileData");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateWithContent(_response));
        });
    }

    protected processUpdateWithContent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    get(documentId: string, cancelToken?: CancelToken): Promise<DocumentShortDto> {
        let url_ = this.baseUrl + "/api/v1/Document/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<DocumentShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentShortDto.fromJS(resultData200);
            return Promise.resolve<DocumentShortDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(documentId: string, documentUpdateDto: DocumentUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Document/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(documentId: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/Document/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getByIdentifier(identifier: string, cancelToken?: CancelToken): Promise<DocumentShortDto> {
        let url_ = this.baseUrl + "/api/v1/Document/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByIdentifier(_response));
        });
    }

    protected processGetByIdentifier(response: AxiosResponse): Promise<DocumentShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentShortDto.fromJS(resultData200);
            return Promise.resolve<DocumentShortDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param download (optional)
     * @return Request completed successfully
     */
    downloadVersion(documentId: string, docVersion: number, download: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Document/{documentId}/content/{docVersion}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (docVersion === undefined || docVersion === null)
            throw new Error("The parameter 'docVersion' must be defined.");
        url_ = url_.replace("{docVersion}", encodeURIComponent("" + docVersion));
        if (download === null)
            throw new Error("The parameter 'download' cannot be null.");
        else if (download !== undefined)
            url_ += "download=" + encodeURIComponent("" + download) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadVersion(_response));
        });
    }

    protected processDownloadVersion(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param download (optional)
     * @return Request completed successfully
     */
    downloadLatestVersion(documentId: string, download: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Document/{documentId}/content/latest?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (download === null)
            throw new Error("The parameter 'download' cannot be null.");
        else if (download !== undefined)
            url_ += "download=" + encodeURIComponent("" + download) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadLatestVersion(_response));
        });
    }

    protected processDownloadLatestVersion(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class IdProviderClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    checkConnectivity( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/system/idprovider/connectivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckConnectivity(_response));
        });
    }

    protected processCheckConnectivity(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    sendUsers( cancelToken?: CancelToken): Promise<IdProviderUserSyncResultDto> {
        let url_ = this.baseUrl + "/api/v1/system/idprovider/user/send";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendUsers(_response));
        });
    }

    protected processSendUsers(response: AxiosResponse): Promise<IdProviderUserSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdProviderUserSyncResultDto.fromJS(resultData200);
            return Promise.resolve<IdProviderUserSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdProviderUserSyncResultDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    sendPatients( cancelToken?: CancelToken): Promise<IdProviderPatientSyncResultDto> {
        let url_ = this.baseUrl + "/api/v1/system/idprovider/patient/send";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendPatients(_response));
        });
    }

    protected processSendPatients(response: AxiosResponse): Promise<IdProviderPatientSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdProviderPatientSyncResultDto.fromJS(resultData200);
            return Promise.resolve<IdProviderPatientSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdProviderPatientSyncResultDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    sendInstitutes( cancelToken?: CancelToken): Promise<IdProviderInstituteSyncResultDto> {
        let url_ = this.baseUrl + "/api/v1/system/idprovider/institute/send";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendInstitutes(_response));
        });
    }

    protected processSendInstitutes(response: AxiosResponse): Promise<IdProviderInstituteSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdProviderInstituteSyncResultDto.fromJS(resultData200);
            return Promise.resolve<IdProviderInstituteSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdProviderInstituteSyncResultDto>(null as any);
    }
}

export class InstituteAssignmentClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request successfully processed
     */
    updateUsersToInstituteAssignments(instituteId: string, usersToInstituteAssignmentDto: UsersToInstituteAssignmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InstituteAssignment/usersToInstitute/{instituteId}";
        if (instituteId === undefined || instituteId === null)
            throw new Error("The parameter 'instituteId' must be defined.");
        url_ = url_.replace("{instituteId}", encodeURIComponent("" + instituteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(usersToInstituteAssignmentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUsersToInstituteAssignments(_response));
        });
    }

    protected processUpdateUsersToInstituteAssignments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    updateUserToInstitutesAssignments(userId: string, userToInstitutesAssignmentDto: UserToInstitutesAssignmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InstituteAssignment/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userToInstitutesAssignmentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUserToInstitutesAssignments(_response));
        });
    }

    protected processUpdateUserToInstitutesAssignments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    updatePatientsToInstituteAssignments(instituteId: string, patientsToInstituteAssignmentDto: PatientsToInstituteAssignmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InstituteAssignment/patientsToInstitute/{instituteId}";
        if (instituteId === undefined || instituteId === null)
            throw new Error("The parameter 'instituteId' must be defined.");
        url_ = url_.replace("{instituteId}", encodeURIComponent("" + instituteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientsToInstituteAssignmentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePatientsToInstituteAssignments(_response));
        });
    }

    protected processUpdatePatientsToInstituteAssignments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    updatePatientToInstitutesAssignments(patientId: string, patientToInstitutesAssignmentDto: PatientToInstitutesAssignmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InstituteAssignment/patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientToInstitutesAssignmentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePatientToInstitutesAssignments(_response));
        });
    }

    protected processUpdatePatientToInstitutesAssignments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class InstituteClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMy(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<InstituteShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Institute/my?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMy(_response));
        });
    }

    protected processGetMy(response: AxiosResponse): Promise<InstituteShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstituteShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InstituteShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMyComplete(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<InstituteCompleteDto[]> {
        let url_ = this.baseUrl + "/api/v1/Institute/my/complete?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyComplete(_response));
        });
    }

    protected processGetMyComplete(response: AxiosResponse): Promise<InstituteCompleteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstituteCompleteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InstituteCompleteDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAll(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<InstituteShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Institute?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<InstituteShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstituteShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InstituteShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(instituteDto: InstituteCreateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Institute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instituteDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllComplete(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<InstituteCompleteDto[]> {
        let url_ = this.baseUrl + "/api/v1/Institute/complete?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllComplete(_response));
        });
    }

    protected processGetAllComplete(response: AxiosResponse): Promise<InstituteCompleteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstituteCompleteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InstituteCompleteDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getInstitute(instituteId: string, cancelToken?: CancelToken): Promise<InstituteDto> {
        let url_ = this.baseUrl + "/api/v1/Institute/{instituteId}";
        if (instituteId === undefined || instituteId === null)
            throw new Error("The parameter 'instituteId' must be defined.");
        url_ = url_.replace("{instituteId}", encodeURIComponent("" + instituteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInstitute(_response));
        });
    }

    protected processGetInstitute(response: AxiosResponse): Promise<InstituteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstituteDto.fromJS(resultData200);
            return Promise.resolve<InstituteDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(instituteId: string, instituteUpdateDto: InstituteUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Institute/{instituteId}";
        if (instituteId === undefined || instituteId === null)
            throw new Error("The parameter 'instituteId' must be defined.");
        url_ = url_.replace("{instituteId}", encodeURIComponent("" + instituteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instituteUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(instituteId: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/Institute/{instituteId}";
        if (instituteId === undefined || instituteId === null)
            throw new Error("The parameter 'instituteId' must be defined.");
        url_ = url_.replace("{instituteId}", encodeURIComponent("" + instituteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    activate(instituteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Institute/{instituteId}/activate";
        if (instituteId === undefined || instituteId === null)
            throw new Error("The parameter 'instituteId' must be defined.");
        url_ = url_.replace("{instituteId}", encodeURIComponent("" + instituteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processActivate(_response));
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    deactivate(instituteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Institute/{instituteId}/deactivate";
        if (instituteId === undefined || instituteId === null)
            throw new Error("The parameter 'instituteId' must be defined.");
        url_ = url_.replace("{instituteId}", encodeURIComponent("" + instituteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    count(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Institute/count?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCount(_response));
        });
    }

    protected processCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class PatientClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAll(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<PatientDto[]> {
        let url_ = this.baseUrl + "/api/v1/Patient?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PatientDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(patientDto: PatientCreateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMy(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<PatientDto[]> {
        let url_ = this.baseUrl + "/api/v1/Patient/my?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMy(_response));
        });
    }

    protected processGetMy(response: AxiosResponse): Promise<PatientDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    findPatient(patientId: string, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/v1/Patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindPatient(_response));
        });
    }

    protected processFindPatient(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(patientId: string, patientUpdateDto: PatientUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(patientId: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/Patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    linkLoginUser(patientId: string, userId: string, cancelToken?: CancelToken): Promise<PatientDto> {
        let url_ = this.baseUrl + "/api/v1/Patient/{patientId}/linkuser/{userId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLinkLoginUser(_response));
        });
    }

    protected processLinkLoginUser(response: AxiosResponse): Promise<PatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDto.fromJS(resultData200);
            return Promise.resolve<PatientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDto>(null as any);
    }
}

export class RightClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    findRightByName(rightName: string, cancelToken?: CancelToken): Promise<RightDto> {
        let url_ = this.baseUrl + "/api/v1/Right/{rightName}";
        if (rightName === undefined || rightName === null)
            throw new Error("The parameter 'rightName' must be defined.");
        url_ = url_.replace("{rightName}", encodeURIComponent("" + rightName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindRightByName(_response));
        });
    }

    protected processFindRightByName(response: AxiosResponse): Promise<RightDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RightDto.fromJS(resultData200);
            return Promise.resolve<RightDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    findRight(rightId: string, cancelToken?: CancelToken): Promise<RightDto> {
        let url_ = this.baseUrl + "/api/v1/Right/{rightId}";
        if (rightId === undefined || rightId === null)
            throw new Error("The parameter 'rightId' must be defined.");
        url_ = url_.replace("{rightId}", encodeURIComponent("" + rightId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindRight(_response));
        });
    }

    protected processFindRight(response: AxiosResponse): Promise<RightDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RightDto.fromJS(resultData200);
            return Promise.resolve<RightDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(rightId: string, rightUpdateDto: RightUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Right/{rightId}";
        if (rightId === undefined || rightId === null)
            throw new Error("The parameter 'rightId' must be defined.");
        url_ = url_.replace("{rightId}", encodeURIComponent("" + rightId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rightUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllRights(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<RightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Right?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllRights(_response));
        });
    }

    protected processGetAllRights(response: AxiosResponse): Promise<RightDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RightDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RightDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(rightCreateDto: RightCreateDto, cancelToken?: CancelToken): Promise<RightDto> {
        let url_ = this.baseUrl + "/api/v1/Right";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rightCreateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RightDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = RightDto.fromJS(resultData201);
            return Promise.resolve<RightDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getAllRightsForCurrentUser( cancelToken?: CancelToken): Promise<RightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Right/currentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllRightsForCurrentUser(_response));
        });
    }

    protected processGetAllRightsForCurrentUser(response: AxiosResponse): Promise<RightDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RightDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RightDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class RoleClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    findRoleByName(roleName: string, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/Role/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindRoleByName(_response));
        });
    }

    protected processFindRoleByName(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    findRole(roleId: string, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/Role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindRole(_response));
        });
    }

    protected processFindRole(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(roleId: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/Role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(roleId: string, roleUpdateDto: RoleUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllRoles(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/v1/Role?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllRoles(_response));
        });
    }

    protected processGetAllRoles(response: AxiosResponse): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(roleCreateDto: RoleCreateDto, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleCreateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = RoleDto.fromJS(resultData201);
            return Promise.resolve<RoleDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    count(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Role/count?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCount(_response));
        });
    }

    protected processCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class SyncClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    sendPatients( cancelToken?: CancelToken): Promise<PatientSyncResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/system/sync/patient/send";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendPatients(_response));
        });
    }

    protected processSendPatients(response: AxiosResponse): Promise<PatientSyncResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSyncResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSyncResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSyncResultDto[]>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    receivePatients(content: PatientSyncContentDto, cancelToken?: CancelToken): Promise<PatientSyncResultDto> {
        let url_ = this.baseUrl + "/api/v1/system/sync/patient/receive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(content);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReceivePatients(_response));
        });
    }

    protected processReceivePatients(response: AxiosResponse): Promise<PatientSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientSyncResultDto.fromJS(resultData200);
            return Promise.resolve<PatientSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSyncResultDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    sendInstitutes( cancelToken?: CancelToken): Promise<InstituteSyncResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/system/sync/institute/send";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendInstitutes(_response));
        });
    }

    protected processSendInstitutes(response: AxiosResponse): Promise<InstituteSyncResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstituteSyncResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InstituteSyncResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstituteSyncResultDto[]>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    receiveInstitutes(content: InstituteSyncContentDto, cancelToken?: CancelToken): Promise<InstituteSyncResultDto> {
        let url_ = this.baseUrl + "/api/v1/system/sync/institute/receive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(content);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReceiveInstitutes(_response));
        });
    }

    protected processReceiveInstitutes(response: AxiosResponse): Promise<InstituteSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstituteSyncResultDto.fromJS(resultData200);
            return Promise.resolve<InstituteSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstituteSyncResultDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    sendUsers( cancelToken?: CancelToken): Promise<UserSyncResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/system/sync/user/send";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendUsers(_response));
        });
    }

    protected processSendUsers(response: AxiosResponse): Promise<UserSyncResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSyncResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserSyncResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSyncResultDto[]>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    receiveUsers(content: UserSyncContentDto, cancelToken?: CancelToken): Promise<UserSyncResultDto> {
        let url_ = this.baseUrl + "/api/v1/system/sync/user/receive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(content);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReceiveUsers(_response));
        });
    }

    protected processReceiveUsers(response: AxiosResponse): Promise<UserSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSyncResultDto.fromJS(resultData200);
            return Promise.resolve<UserSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSyncResultDto>(null as any);
    }
}

export class UserClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAll(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<ShortUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/User?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ShortUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShortUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShortUserDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(userCreateDto: UserCreateDto, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCreateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = UserDto.fromJS(resultData201);
            return Promise.resolve<UserDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getCurrentUser( cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/User/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentUser(_response));
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    findUser(userId: string, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindUser(_response));
        });
    }

    protected processFindUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(userId: string, userUpdateDto: UserUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(userId: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    findUserComplete(userId: string, cancelToken?: CancelToken): Promise<UserCompleteDto> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}/complete";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindUserComplete(_response));
        });
    }

    protected processFindUserComplete(response: AxiosResponse): Promise<UserCompleteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserCompleteDto.fromJS(resultData200);
            return Promise.resolve<UserCompleteDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    findUserByName(name: string, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/User/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindUserByName(_response));
        });
    }

    protected processFindUserByName(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    restore(userId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}/restore";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRestore(_response));
        });
    }

    protected processRestore(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request successfully processed
     */
    deactivate(userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}/deactivate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    activate(userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}/activate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processActivate(_response));
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    updatePasswordForCurrentUser(userPasswordChangeDto: UserPasswordChangeForCurrentUserDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userPasswordChangeDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePasswordForCurrentUser(_response));
        });
    }

    protected processUpdatePasswordForCurrentUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    resetPassword(passwordResetDto: UserPasswordResetDto, cancelToken?: CancelToken): Promise<UserPasswordResetResultDto> {
        let url_ = this.baseUrl + "/api/v1/User/passwordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(passwordResetDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<UserPasswordResetResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserPasswordResetResultDto.fromJS(resultData200);
            return Promise.resolve<UserPasswordResetResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPasswordResetResultDto>(null as any);
    }

    /**
     * @return Request successfully processed
     */
    updatePassword(userId: string, userPasswordChangeDto: UserPasswordChangeDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/{userId}/password";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userPasswordChangeDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePassword(_response));
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    count(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/User/count?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCount(_response));
        });
    }

    protected processCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Resource was not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param emailAddress (optional)
     * @return Request completed successfully
     */
    sendPasswordRecoveryEmail(emailAddress: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/sendPasswordRecoveryEmail?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendPasswordRecoveryEmail(_response));
        });
    }

    protected processSendPasswordRecoveryEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UtilityClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getPassword( cancelToken?: CancelToken): Promise<PasswordDto> {
        let url_ = this.baseUrl + "/api/v1/Utility/password";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPassword(_response));
        });
    }

    protected processGetPassword(response: AxiosResponse): Promise<PasswordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PasswordDto.fromJS(resultData200);
            return Promise.resolve<PasswordDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getEnvironment( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Utility/environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnvironment(_response));
        });
    }

    protected processGetEnvironment(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    checkConnectivity( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Utility/connectivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckConnectivity(_response));
        });
    }

    protected processCheckConnectivity(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getAssemblies( cancelToken?: CancelToken): Promise<AssembliesDto> {
        let url_ = this.baseUrl + "/api/v1/Utility/assemblies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAssemblies(_response));
        });
    }

    protected processGetAssemblies(response: AxiosResponse): Promise<AssembliesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssembliesDto.fromJS(resultData200);
            return Promise.resolve<AssembliesDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class SystemVisitClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param patientIdentifier (optional)
     * @return Request completed successfully
     */
    getVisitStructureForPatient(patientIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<VisitDateDto[]> {
        let url_ = this.baseUrl + "/api/v1/system/visit/visitDates?";
        if (patientIdentifier !== undefined && patientIdentifier !== null)
            url_ += "patientIdentifier=" + encodeURIComponent("" + patientIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVisitStructureForPatient(_response));
        });
    }

    protected processGetVisitStructureForPatient(response: AxiosResponse): Promise<VisitDateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitDateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitDateDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getBaselineDatesForAllPatients( cancelToken?: CancelToken): Promise<BaselineDateDto[]> {
        let url_ = this.baseUrl + "/api/v1/system/visit/baselineDatesForAllPatients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBaselineDatesForAllPatients(_response));
        });
    }

    protected processGetBaselineDatesForAllPatients(response: AxiosResponse): Promise<BaselineDateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaselineDateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BaselineDateDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getVisitTimelines( cancelToken?: CancelToken): Promise<VisitTimelineDto[]> {
        let url_ = this.baseUrl + "/api/v1/system/visit/visitTimelines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVisitTimelines(_response));
        });
    }

    protected processGetVisitTimelines(response: AxiosResponse): Promise<VisitTimelineDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitTimelineDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitTimelineDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitTimelineDto[]>(null as any);
    }
}

export class NtdInstituteClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllNtdInstitutes(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<NtdInstituteDto[]> {
        let url_ = this.baseUrl + "/api/v1/ntd/institute?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllNtdInstitutes(_response));
        });
    }

    protected processGetAllNtdInstitutes(response: AxiosResponse): Promise<NtdInstituteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NtdInstituteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NtdInstituteDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(ntdInstituteCreateDto: NtdInstituteCreateDto, cancelToken?: CancelToken): Promise<NtdInstituteShortDto> {
        let url_ = this.baseUrl + "/api/v1/ntd/institute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ntdInstituteCreateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<NtdInstituteShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = NtdInstituteShortDto.fromJS(resultData201);
            return Promise.resolve<NtdInstituteShortDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    update(instituteUpdateDto: NtdInstituteUpdateDto, cancelToken?: CancelToken): Promise<NtdInstituteShortDto> {
        let url_ = this.baseUrl + "/api/v1/ntd/institute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instituteUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<NtdInstituteShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NtdInstituteShortDto.fromJS(resultData200);
            return Promise.resolve<NtdInstituteShortDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NtdInstituteShortDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    delete(instituteDeleteDto: NtdInstituteDeleteDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ntd/institute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instituteDeleteDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMyNtdInstitutes(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<NtdInstituteDto[]> {
        let url_ = this.baseUrl + "/api/v1/ntd/institute/my?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyNtdInstitutes(_response));
        });
    }

    protected processGetMyNtdInstitutes(response: AxiosResponse): Promise<NtdInstituteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NtdInstituteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NtdInstituteDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class NtdPatientsClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param id (optional)
     * @return Request completed successfully
     */
    getNtdPatientForStudyPatient(id: string | undefined, cancelToken?: CancelToken): Promise<NtdPatientPuidDto> {
        let url_ = this.baseUrl + "/api/v1/ntd/patient?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNtdPatientForStudyPatient(_response));
        });
    }

    protected processGetNtdPatientForStudyPatient(response: AxiosResponse): Promise<NtdPatientPuidDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NtdPatientPuidDto.fromJS(resultData200);
            return Promise.resolve<NtdPatientPuidDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param studyPatientId (optional)
     * @param ntdPatientId (optional)
     * @return Request completed successfully
     */
    createNtdPatientForStudyPatient(studyPatientId: string | undefined, ntdPatientId: string | undefined, cancelToken?: CancelToken): Promise<NtdPatientPuidDto> {
        let url_ = this.baseUrl + "/api/v1/ntd/patient?";
        if (studyPatientId === null)
            throw new Error("The parameter 'studyPatientId' cannot be null.");
        else if (studyPatientId !== undefined)
            url_ += "studyPatientId=" + encodeURIComponent("" + studyPatientId) + "&";
        if (ntdPatientId === null)
            throw new Error("The parameter 'ntdPatientId' cannot be null.");
        else if (ntdPatientId !== undefined)
            url_ += "ntdPatientId=" + encodeURIComponent("" + ntdPatientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateNtdPatientForStudyPatient(_response));
        });
    }

    protected processCreateNtdPatientForStudyPatient(response: AxiosResponse): Promise<NtdPatientPuidDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NtdPatientPuidDto.fromJS(resultData200);
            return Promise.resolve<NtdPatientPuidDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NtdPatientPuidDto>(null as any);
    }
}

export class NtdClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getCurrentStatus( cancelToken?: CancelToken): Promise<NtdStatusResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ntd/isonline";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentStatus(_response));
        });
    }

    protected processGetCurrentStatus(response: AxiosResponse): Promise<NtdStatusResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NtdStatusResponseDto.fromJS(resultData200);
            return Promise.resolve<NtdStatusResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    syncUser(ntdUserCreateDto: NtdUserCreateDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ntd/authuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ntdUserCreateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSyncUser(_response));
        });
    }

    protected processSyncUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    registerPatient(ntdPatientDto: NtdPatientDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ntd/registerpatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ntdPatientDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterPatient(_response));
        });
    }

    protected processRegisterPatient(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class NtdUserClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllNtdUsers(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<NtdUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/ntd/user?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllNtdUsers(_response));
        });
    }

    protected processGetAllNtdUsers(response: AxiosResponse): Promise<NtdUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NtdUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NtdUserDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class ConstraintDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllConstraintDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<ConstraintDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/ConstraintDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllConstraintDefinitions(_response));
        });
    }

    protected processGetAllConstraintDefinitions(response: AxiosResponse): Promise<ConstraintDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConstraintDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConstraintDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: ConstraintDefinitionCreateDto, cancelToken?: CancelToken): Promise<ConstraintDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/ConstraintDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ConstraintDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ConstraintDefinitionDto.fromJS(resultData201);
            return Promise.resolve<ConstraintDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<ConstraintDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/ConstraintDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ConstraintDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConstraintDefinitionDto.fromJS(resultData200);
            return Promise.resolve<ConstraintDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: ConstraintDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ConstraintDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/ConstraintDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class DataFieldDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllDataFieldDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<DataFieldDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/DataFieldDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllDataFieldDefinitions(_response));
        });
    }

    protected processGetAllDataFieldDefinitions(response: AxiosResponse): Promise<DataFieldDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataFieldDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataFieldDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: DataFieldDefinitionCreateDto, cancelToken?: CancelToken): Promise<DataFieldDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/DataFieldDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DataFieldDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = DataFieldDefinitionDto.fromJS(resultData201);
            return Promise.resolve<DataFieldDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<DataFieldDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/DataFieldDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DataFieldDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataFieldDefinitionDto.fromJS(resultData200);
            return Promise.resolve<DataFieldDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: DataFieldDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DataFieldDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/DataFieldDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class DataQualityCheckClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getAll( cancelToken?: CancelToken): Promise<DataQualityCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/DataQualityCheck/checks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DataQualityCheckDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataQualityCheckDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataQualityCheckDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataQualityCheckDto[]>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    run(studyId: string, checkIdentifiers: string[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/DataQualityCheck/run/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkIdentifiers);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRun(_response));
        });
    }

    protected processRun(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DocumentationClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getFunctionalDesign(studyDefinitionId: string, languageIdentifier: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Documentation/{studyDefinitionId}/{languageIdentifier}/funcionalDesign";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        if (languageIdentifier === undefined || languageIdentifier === null)
            throw new Error("The parameter 'languageIdentifier' must be defined.");
        url_ = url_.replace("{languageIdentifier}", encodeURIComponent("" + languageIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFunctionalDesign(_response));
        });
    }

    protected processGetFunctionalDesign(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getAnnotatedEcrf(studyDefinitionId: string, languageIdentifier: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Documentation/{studyDefinitionId}/{languageIdentifier}/ecrf";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        if (languageIdentifier === undefined || languageIdentifier === null)
            throw new Error("The parameter 'languageIdentifier' must be defined.");
        url_ = url_.replace("{languageIdentifier}", encodeURIComponent("" + languageIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAnnotatedEcrf(_response));
        });
    }

    protected processGetAnnotatedEcrf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getAnnotatedEcrfView(studyDefinitionId: string, languageIdentifier: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Documentation/{studyDefinitionId}/{languageIdentifier}/ecrf-view";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        if (languageIdentifier === undefined || languageIdentifier === null)
            throw new Error("The parameter 'languageIdentifier' must be defined.");
        url_ = url_.replace("{languageIdentifier}", encodeURIComponent("" + languageIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAnnotatedEcrfView(_response));
        });
    }

    protected processGetAnnotatedEcrfView(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getComplete(studyDefinitionId: string, languageIdentifier: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Documentation/{studyDefinitionId}/{languageIdentifier}/complete";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        if (languageIdentifier === undefined || languageIdentifier === null)
            throw new Error("The parameter 'languageIdentifier' must be defined.");
        url_ = url_.replace("{languageIdentifier}", encodeURIComponent("" + languageIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetComplete(_response));
        });
    }

    protected processGetComplete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EcrfAuditTrailClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param languageIdentifier (optional)
     * @return Request completed successfully
     */
    getStudyPatientAuditTrail(studyPatientId: string, languageIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<AuditValueChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/EcrfAuditTrail/study-patient/{studyPatientId}?";
        if (studyPatientId === undefined || studyPatientId === null)
            throw new Error("The parameter 'studyPatientId' must be defined.");
        url_ = url_.replace("{studyPatientId}", encodeURIComponent("" + studyPatientId));
        if (languageIdentifier !== undefined && languageIdentifier !== null)
            url_ += "languageIdentifier=" + encodeURIComponent("" + languageIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyPatientAuditTrail(_response));
        });
    }

    protected processGetStudyPatientAuditTrail(response: AxiosResponse): Promise<AuditValueChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditValueChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditValueChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditValueChangeDto[]>(null as any);
    }

    /**
     * @param languageIdentifier (optional)
     * @return Request completed successfully
     */
    getVisitAuditTrail(visitId: string, languageIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<AuditValueChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/EcrfAuditTrail/visit/{visitId}?";
        if (visitId === undefined || visitId === null)
            throw new Error("The parameter 'visitId' must be defined.");
        url_ = url_.replace("{visitId}", encodeURIComponent("" + visitId));
        if (languageIdentifier !== undefined && languageIdentifier !== null)
            url_ += "languageIdentifier=" + encodeURIComponent("" + languageIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVisitAuditTrail(_response));
        });
    }

    protected processGetVisitAuditTrail(response: AxiosResponse): Promise<AuditValueChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditValueChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditValueChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditValueChangeDto[]>(null as any);
    }

    /**
     * @param languageIdentifier (optional)
     * @return Request completed successfully
     */
    getInstrumentAuditTrail(instrumentId: string, languageIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<AuditValueChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/EcrfAuditTrail/instrument/{instrumentId}?";
        if (instrumentId === undefined || instrumentId === null)
            throw new Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (languageIdentifier !== undefined && languageIdentifier !== null)
            url_ += "languageIdentifier=" + encodeURIComponent("" + languageIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInstrumentAuditTrail(_response));
        });
    }

    protected processGetInstrumentAuditTrail(response: AxiosResponse): Promise<AuditValueChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditValueChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditValueChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditValueChangeDto[]>(null as any);
    }

    /**
     * @param languageIdentifier (optional)
     * @return Request completed successfully
     */
    getQueryAuditTrail(queryId: string, languageIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<AuditValueChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/EcrfAuditTrail/query/{queryId}?";
        if (queryId === undefined || queryId === null)
            throw new Error("The parameter 'queryId' must be defined.");
        url_ = url_.replace("{queryId}", encodeURIComponent("" + queryId));
        if (languageIdentifier !== undefined && languageIdentifier !== null)
            url_ += "languageIdentifier=" + encodeURIComponent("" + languageIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueryAuditTrail(_response));
        });
    }

    protected processGetQueryAuditTrail(response: AxiosResponse): Promise<AuditValueChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditValueChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditValueChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditValueChangeDto[]>(null as any);
    }

    /**
     * @param languageIdentifier (optional)
     * @return Request completed successfully
     */
    getStudyInstituteAuditTrail(studyInstituteId: string, languageIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<AuditValueChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/EcrfAuditTrail/studyInstitute/{studyInstituteId}?";
        if (studyInstituteId === undefined || studyInstituteId === null)
            throw new Error("The parameter 'studyInstituteId' must be defined.");
        url_ = url_.replace("{studyInstituteId}", encodeURIComponent("" + studyInstituteId));
        if (languageIdentifier !== undefined && languageIdentifier !== null)
            url_ += "languageIdentifier=" + encodeURIComponent("" + languageIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyInstituteAuditTrail(_response));
        });
    }

    protected processGetStudyInstituteAuditTrail(response: AxiosResponse): Promise<AuditValueChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditValueChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditValueChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditValueChangeDto[]>(null as any);
    }

    /**
     * @param languageIdentifier (optional)
     * @return Request completed successfully
     */
    getUserAuditTrail(userId: string, languageIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<AuditValueChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/EcrfAuditTrail/user/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (languageIdentifier !== undefined && languageIdentifier !== null)
            url_ += "languageIdentifier=" + encodeURIComponent("" + languageIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserAuditTrail(_response));
        });
    }

    protected processGetUserAuditTrail(response: AxiosResponse): Promise<AuditValueChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditValueChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditValueChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditValueChangeDto[]>(null as any);
    }
}

export class ELearningDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getAll( cancelToken?: CancelToken): Promise<ELearningDefinitionResponseDto[]> {
        let url_ = this.baseUrl + "/api/v1/ELearningDefinition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ELearningDefinitionResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ELearningDefinitionResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ELearningDefinitionResponseDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: ELearningDefinitionCreateDto, cancelToken?: CancelToken): Promise<ELearningDefinitionResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ELearningDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ELearningDefinitionResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ELearningDefinitionResponseDto.fromJS(resultData201);
            return Promise.resolve<ELearningDefinitionResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<ELearningDefinitionResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ELearningDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ELearningDefinitionResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ELearningDefinitionResponseDto.fromJS(resultData200);
            return Promise.resolve<ELearningDefinitionResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/ELearningDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: ELearningDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ELearningDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getByStudyDefinitionId(studyDefinitionId: string, cancelToken?: CancelToken): Promise<ELearningDefinitionResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ELearningDefinition/studyDefinition/{studyDefinitionId}";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByStudyDefinitionId(_response));
        });
    }

    protected processGetByStudyDefinitionId(response: AxiosResponse): Promise<ELearningDefinitionResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ELearningDefinitionResponseDto.fromJS(resultData200);
            return Promise.resolve<ELearningDefinitionResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class ELearningResultClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getAll( cancelToken?: CancelToken): Promise<ELearningResultResponseDto[]> {
        let url_ = this.baseUrl + "/api/v1/ELearningResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ELearningResultResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ELearningResultResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ELearningResultResponseDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    submitForCurrentUser(dto: ELearningResultSubmitDto, cancelToken?: CancelToken): Promise<ELearningResultResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ELearningResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubmitForCurrentUser(_response));
        });
    }

    protected processSubmitForCurrentUser(response: AxiosResponse): Promise<ELearningResultResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ELearningResultResponseDto.fromJS(resultData201);
            return Promise.resolve<ELearningResultResponseDto>(result201);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<ELearningResultResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ELearningResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ELearningResultResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ELearningResultResponseDto.fromJS(resultData200);
            return Promise.resolve<ELearningResultResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getForCurrentUser(studyDefinitionId: string, cancelToken?: CancelToken): Promise<ELearningResultResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ELearningResult/studyDefinition/{studyDefinitionId}";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForCurrentUser(_response));
        });
    }

    protected processGetForCurrentUser(response: AxiosResponse): Promise<ELearningResultResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ELearningResultResponseDto.fromJS(resultData200);
            return Promise.resolve<ELearningResultResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getUserRequireELearning(studyDefinitionId: string, cancelToken?: CancelToken): Promise<ELearningRequireResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ELearningResult/studyDefinition/{studyDefinitionId}/require";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserRequireELearning(_response));
        });
    }

    protected processGetUserRequireELearning(response: AxiosResponse): Promise<ELearningRequireResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ELearningRequireResponseDto.fromJS(resultData200);
            return Promise.resolve<ELearningRequireResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class EnumValueSetClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllEnumValueSets(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<EnumValueSetShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/EnumValueSet?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllEnumValueSets(_response));
        });
    }

    protected processGetAllEnumValueSets(response: AxiosResponse): Promise<EnumValueSetShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumValueSetShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EnumValueSetShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: EnumValueSetCreateDto, cancelToken?: CancelToken): Promise<EnumValueSetDto> {
        let url_ = this.baseUrl + "/api/v1/EnumValueSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<EnumValueSetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = EnumValueSetDto.fromJS(resultData201);
            return Promise.resolve<EnumValueSetDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<EnumValueSetDto> {
        let url_ = this.baseUrl + "/api/v1/EnumValueSet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<EnumValueSetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnumValueSetDto.fromJS(resultData200);
            return Promise.resolve<EnumValueSetDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: EnumValueSetUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/EnumValueSet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/EnumValueSet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class EventReportClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    signEventReport(reportFieldId: string, dto: EventReportSignatureDto, cancelToken?: CancelToken): Promise<EventReportSignatureResultDto> {
        let url_ = this.baseUrl + "/api/v1/EventReport/{reportFieldId}/sign";
        if (reportFieldId === undefined || reportFieldId === null)
            throw new Error("The parameter 'reportFieldId' must be defined.");
        url_ = url_.replace("{reportFieldId}", encodeURIComponent("" + reportFieldId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSignEventReport(_response));
        });
    }

    protected processSignEventReport(response: AxiosResponse): Promise<EventReportSignatureResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EventReportSignatureResultDto.fromJS(resultData200);
            return Promise.resolve<EventReportSignatureResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EventReportSignatureResultDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    deactivateEventReport(reportFieldId: string, dto: EventReportDeactivationDto, cancelToken?: CancelToken): Promise<EventReportDeactivationResultDto> {
        let url_ = this.baseUrl + "/api/v1/EventReport/{reportFieldId}/deactivate";
        if (reportFieldId === undefined || reportFieldId === null)
            throw new Error("The parameter 'reportFieldId' must be defined.");
        url_ = url_.replace("{reportFieldId}", encodeURIComponent("" + reportFieldId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeactivateEventReport(_response));
        });
    }

    protected processDeactivateEventReport(response: AxiosResponse): Promise<EventReportDeactivationResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EventReportDeactivationResultDto.fromJS(resultData200);
            return Promise.resolve<EventReportDeactivationResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EventReportDeactivationResultDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getEventReportFields(reportId: string, cancelToken?: CancelToken): Promise<EventReportFieldDto[]> {
        let url_ = this.baseUrl + "/api/v1/EventReport/{reportId}/fields";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEventReportFields(_response));
        });
    }

    protected processGetEventReportFields(response: AxiosResponse): Promise<EventReportFieldDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventReportFieldDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EventReportFieldDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EventReportFieldDto[]>(null as any);
    }
}

export class ExportClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param exportEmptyTables (optional)
     * @param asXlsx (optional)
     * @param languageIdentifier (optional)
     * @return Request completed successfully
     */
    getStudyCsvExport(studyId: string, exportEmptyTables: boolean | undefined, asXlsx: boolean | undefined, languageIdentifier: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/csv-export?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (exportEmptyTables === null)
            throw new Error("The parameter 'exportEmptyTables' cannot be null.");
        else if (exportEmptyTables !== undefined)
            url_ += "exportEmptyTables=" + encodeURIComponent("" + exportEmptyTables) + "&";
        if (asXlsx === null)
            throw new Error("The parameter 'asXlsx' cannot be null.");
        else if (asXlsx !== undefined)
            url_ += "asXlsx=" + encodeURIComponent("" + asXlsx) + "&";
        if (languageIdentifier !== undefined && languageIdentifier !== null)
            url_ += "languageIdentifier=" + encodeURIComponent("" + languageIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyCsvExport(_response));
        });
    }

    protected processGetStudyCsvExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getStudyCsvExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/csv-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyCsvExportList(_response));
        });
    }

    protected processGetStudyCsvExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getStudyCsvExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/csv-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyCsvExportFile(_response));
        });
    }

    protected processGetStudyCsvExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Request completed successfully
     */
    getSafetyScreeningExport(studyId: string, fromDate: Date | undefined, toDate: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/screening-export?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSafetyScreeningExport(_response));
        });
    }

    protected processGetSafetyScreeningExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getSafetyScreeningExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/screening-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSafetyScreeningExportList(_response));
        });
    }

    protected processGetSafetyScreeningExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getSafetyScreeningExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/screening-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSafetyScreeningExportFile(_response));
        });
    }

    protected processGetSafetyScreeningExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Request completed successfully
     */
    getChangesExport(studyId: string, fromDate: Date | undefined, toDate: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/changes-export?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChangesExport(_response));
        });
    }

    protected processGetChangesExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getChangesExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/changes-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChangesExportList(_response));
        });
    }

    protected processGetChangesExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getChangesExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/changes-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChangesExportFile(_response));
        });
    }

    protected processGetChangesExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Request completed successfully
     */
    getFreeTextChangesExport(studyId: string, fromDate: Date | undefined, toDate: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/freetext-changes-export?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFreeTextChangesExport(_response));
        });
    }

    protected processGetFreeTextChangesExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getFreeTextChangesExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/freetext-changes-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFreeTextChangesExportList(_response));
        });
    }

    protected processGetFreeTextChangesExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getFreeTextChangesExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/freetext-changes-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFreeTextChangesExportFile(_response));
        });
    }

    protected processGetFreeTextChangesExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getQueriesExport(studyId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/queries-export";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueriesExport(_response));
        });
    }

    protected processGetQueriesExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getQueriesExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/queries-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueriesExportList(_response));
        });
    }

    protected processGetQueriesExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getQueriesExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/queries-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueriesExportFile(_response));
        });
    }

    protected processGetQueriesExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getUserQueriesExport(studyId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/user-queries-export";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserQueriesExport(_response));
        });
    }

    protected processGetUserQueriesExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getUserQueriesExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/user-queries-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserQueriesExportList(_response));
        });
    }

    protected processGetUserQueriesExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getUserQueriesExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/user-queries-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserQueriesExportFile(_response));
        });
    }

    protected processGetUserQueriesExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getQueriesOverviewExport(studyId: string, queries: QueryShortDto[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/queries-overview-export";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queries);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueriesOverviewExport(_response));
        });
    }

    protected processGetQueriesOverviewExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getQueriesOverviewExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/queries-overview-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueriesOverviewExportList(_response));
        });
    }

    protected processGetQueriesOverviewExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getQueriesOverviewExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/queries-overview-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueriesOverviewExportFile(_response));
        });
    }

    protected processGetQueriesOverviewExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param lastExportDate (optional)
     * @return Request completed successfully
     */
    createInterviewsExport(lastExportDate: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/interviewsstatus-export/create?";
        if (lastExportDate === null)
            throw new Error("The parameter 'lastExportDate' cannot be null.");
        else if (lastExportDate !== undefined)
            url_ += "lastExportDate=" + encodeURIComponent(lastExportDate ? "" + lastExportDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateInterviewsExport(_response));
        });
    }

    protected processCreateInterviewsExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getInterviewsStatusExportList( cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/interviewsstatus-export/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInterviewsStatusExportList(_response));
        });
    }

    protected processGetInterviewsStatusExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getInterviewsStatusExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/interviewsstatus-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInterviewsStatusExportFile(_response));
        });
    }

    protected processGetInterviewsStatusExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param lastExportDate (optional)
     * @return Request completed successfully
     */
    createPortalExport(lastExportDate: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/portalstatus-export/create?";
        if (lastExportDate === null)
            throw new Error("The parameter 'lastExportDate' cannot be null.");
        else if (lastExportDate !== undefined)
            url_ += "lastExportDate=" + encodeURIComponent(lastExportDate ? "" + lastExportDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreatePortalExport(_response));
        });
    }

    protected processCreatePortalExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getPortalStatusExportList( cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/portalstatus-export/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPortalStatusExportList(_response));
        });
    }

    protected processGetPortalStatusExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getPortalStatusExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/portalstatus-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPortalStatusExportFile(_response));
        });
    }

    protected processGetPortalStatusExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param exportEmptyTables (optional)
     * @return Request completed successfully
     */
    getSasExport(studyId: string, exportEmptyTables: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/sas-export?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (exportEmptyTables === null)
            throw new Error("The parameter 'exportEmptyTables' cannot be null.");
        else if (exportEmptyTables !== undefined)
            url_ += "exportEmptyTables=" + encodeURIComponent("" + exportEmptyTables) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSasExport(_response));
        });
    }

    protected processGetSasExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getSasExportList(fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<DataExchangeFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/Export/sas-export/list?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSasExportList(_response));
        });
    }

    protected processGetSasExportList(response: AxiosResponse): Promise<DataExchangeFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataExchangeFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataExchangeFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataExchangeFileDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    getSasExportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/sas-export/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSasExportFile(_response));
        });
    }

    protected processGetSasExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getFinalExport(studyId: string, dto: FinalExportRequestDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Export/study/{studyId}/final-export";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFinalExport(_response));
        });
    }

    protected processGetFinalExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class HtmlDocumentClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAll(includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<HtmlDocumentShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/HtmlDocument?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<HtmlDocumentShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HtmlDocumentShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HtmlDocumentShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(documentCreateDto: HtmlDocumentCreateDto, cancelToken?: CancelToken): Promise<HtmlDocumentShortDto> {
        let url_ = this.baseUrl + "/api/v1/HtmlDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentCreateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<HtmlDocumentShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = HtmlDocumentShortDto.fromJS(resultData201);
            return Promise.resolve<HtmlDocumentShortDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    get(documentId: string, cancelToken?: CancelToken): Promise<HtmlDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/HtmlDocument/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<HtmlDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HtmlDocumentDto.fromJS(resultData200);
            return Promise.resolve<HtmlDocumentDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(documentId: string, documentUpdateDto: HtmlDocumentUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/HtmlDocument/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentUpdateDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(documentId: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/HtmlDocument/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getByIdentifier(identifier: string, cancelToken?: CancelToken): Promise<HtmlDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/HtmlDocument/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByIdentifier(_response));
        });
    }

    protected processGetByIdentifier(response: AxiosResponse): Promise<HtmlDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HtmlDocumentDto.fromJS(resultData200);
            return Promise.resolve<HtmlDocumentDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class InstrumentClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getInstrumentsByStudyId(studyId: string, includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<InstrumentShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Instrument/study/{studyId}?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInstrumentsByStudyId(_response));
        });
    }

    protected processGetInstrumentsByStudyId(response: AxiosResponse): Promise<InstrumentShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InstrumentShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<InstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/Instrument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<InstrumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstrumentDto.fromJS(resultData200);
            return Promise.resolve<InstrumentDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    update(id: string, dto: InstrumentUpdateDto, cancelToken?: CancelToken): Promise<InstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/Instrument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<InstrumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstrumentDto.fromJS(resultData200);
            return Promise.resolve<InstrumentDto>(result200);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    delete(id: string, dto: InstrumentDeleteDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Instrument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Object created successfully
     */
    create(dto: InstrumentCreateDto, cancelToken?: CancelToken): Promise<InstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/Instrument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<InstrumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = InstrumentDto.fromJS(resultData201);
            return Promise.resolve<InstrumentDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param patientId (optional)
     * @param visitIdId (optional)
     * @param instrumentDefinitionId (optional)
     * @return Request completed successfully
     */
    getTemporaryInstrumentDataFields(patientId: string | undefined, visitIdId: string | null | undefined, instrumentDefinitionId: string | undefined, cancelToken?: CancelToken): Promise<TemporaryInstrumentResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Instrument/temporaryDataFields?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (visitIdId !== undefined && visitIdId !== null)
            url_ += "visitIdId=" + encodeURIComponent("" + visitIdId) + "&";
        if (instrumentDefinitionId === null)
            throw new Error("The parameter 'instrumentDefinitionId' cannot be null.");
        else if (instrumentDefinitionId !== undefined)
            url_ += "instrumentDefinitionId=" + encodeURIComponent("" + instrumentDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemporaryInstrumentDataFields(_response));
        });
    }

    protected processGetTemporaryInstrumentDataFields(response: AxiosResponse): Promise<TemporaryInstrumentResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemporaryInstrumentResponseDto.fromJS(resultData200);
            return Promise.resolve<TemporaryInstrumentResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemporaryInstrumentResponseDto>(null as any);
    }

    /**
     * @return Object created successfully
     */
    createDataField(dto: InstrumentDataFieldCreateDto, cancelToken?: CancelToken): Promise<InstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/Instrument/DataField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateDataField(_response));
        });
    }

    protected processCreateDataField(response: AxiosResponse): Promise<InstrumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = InstrumentDto.fromJS(resultData201);
            return Promise.resolve<InstrumentDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstrumentDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    updateDataField(id: string, dto: InstrumentDataFieldUpdateDto, cancelToken?: CancelToken): Promise<InstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/Instrument/DataField/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDataField(_response));
        });
    }

    protected processUpdateDataField(response: AxiosResponse): Promise<InstrumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstrumentDto.fromJS(resultData200);
            return Promise.resolve<InstrumentDto>(result200);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    deleteDataField(id: string, dto: InstrumentDataFieldDeleteDto, cancelToken?: CancelToken): Promise<InstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/Instrument/DataField/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDataField(_response));
        });
    }

    protected processDeleteDataField(response: AxiosResponse): Promise<InstrumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstrumentDto.fromJS(resultData200);
            return Promise.resolve<InstrumentDto>(result200);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class InstrumentDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllInstrumentDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<InstrumentDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/InstrumentDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllInstrumentDefinitions(_response));
        });
    }

    protected processGetAllInstrumentDefinitions(response: AxiosResponse): Promise<InstrumentDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InstrumentDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: InstrumentDefinitionCreateDto, cancelToken?: CancelToken): Promise<InstrumentDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/InstrumentDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<InstrumentDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = InstrumentDefinitionDto.fromJS(resultData201);
            return Promise.resolve<InstrumentDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<InstrumentDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/InstrumentDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<InstrumentDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstrumentDefinitionDto.fromJS(resultData200);
            return Promise.resolve<InstrumentDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: InstrumentDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InstrumentDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/InstrumentDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class LanguageClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllLanguages(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<LanguageShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Language?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllLanguages(_response));
        });
    }

    protected processGetAllLanguages(response: AxiosResponse): Promise<LanguageShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LanguageShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: LanguageCreateDto, cancelToken?: CancelToken): Promise<LanguageDto> {
        let url_ = this.baseUrl + "/api/v1/Language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<LanguageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = LanguageDto.fromJS(resultData201);
            return Promise.resolve<LanguageDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<LanguageDto> {
        let url_ = this.baseUrl + "/api/v1/Language/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<LanguageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LanguageDto.fromJS(resultData200);
            return Promise.resolve<LanguageDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: LanguageUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Language/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/Language/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class LanguageEntryClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllLanguageEntrys(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<LanguageEntryShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/LanguageEntry?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllLanguageEntrys(_response));
        });
    }

    protected processGetAllLanguageEntrys(response: AxiosResponse): Promise<LanguageEntryShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageEntryShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LanguageEntryShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: LanguageEntryCreateDto, cancelToken?: CancelToken): Promise<LanguageEntryDto> {
        let url_ = this.baseUrl + "/api/v1/LanguageEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<LanguageEntryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = LanguageEntryDto.fromJS(resultData201);
            return Promise.resolve<LanguageEntryDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<LanguageEntryDto> {
        let url_ = this.baseUrl + "/api/v1/LanguageEntry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<LanguageEntryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LanguageEntryDto.fromJS(resultData200);
            return Promise.resolve<LanguageEntryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: LanguageEntryUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/LanguageEntry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/LanguageEntry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class PatientDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllPatientDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<PatientDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/PatientDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllPatientDefinitions(_response));
        });
    }

    protected processGetAllPatientDefinitions(response: AxiosResponse): Promise<PatientDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<PatientDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/PatientDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<PatientDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDefinitionDto.fromJS(resultData200);
            return Promise.resolve<PatientDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: PatientDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/PatientDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class QueryClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param instrumentId (optional)
     * @return Request completed successfully
     */
    getAllForInstrument(instrumentId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/instrument/allFields?";
        if (instrumentId === null)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else if (instrumentId !== undefined)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllForInstrument(_response));
        });
    }

    protected processGetAllForInstrument(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @param instrumentId (optional)
     * @return Request completed successfully
     */
    getForInstrument(instrumentId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/instrument?";
        if (instrumentId === null)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else if (instrumentId !== undefined)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForInstrument(_response));
        });
    }

    protected processGetForInstrument(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    createForInstrument(dto: QueryCreateDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/instrument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateForInstrument(_response));
        });
    }

    protected processCreateForInstrument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param visitId (optional)
     * @return Request completed successfully
     */
    getAllForVisit(visitId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/visit/allFields?";
        if (visitId === null)
            throw new Error("The parameter 'visitId' cannot be null.");
        else if (visitId !== undefined)
            url_ += "visitId=" + encodeURIComponent("" + visitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllForVisit(_response));
        });
    }

    protected processGetAllForVisit(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @param visitId (optional)
     * @return Request completed successfully
     */
    getForVisit(visitId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/visit?";
        if (visitId === null)
            throw new Error("The parameter 'visitId' cannot be null.");
        else if (visitId !== undefined)
            url_ += "visitId=" + encodeURIComponent("" + visitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForVisit(_response));
        });
    }

    protected processGetForVisit(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    createForVisit(dto: QueryCreateDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/visit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateForVisit(_response));
        });
    }

    protected processCreateForVisit(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param studyPatientId (optional)
     * @return Request completed successfully
     */
    getVisitsQueryStates(studyPatientId: string | undefined, cancelToken?: CancelToken): Promise<VisitQueryStates[]> {
        let url_ = this.baseUrl + "/api/v1/Query/visits/states?";
        if (studyPatientId === null)
            throw new Error("The parameter 'studyPatientId' cannot be null.");
        else if (studyPatientId !== undefined)
            url_ += "studyPatientId=" + encodeURIComponent("" + studyPatientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVisitsQueryStates(_response));
        });
    }

    protected processGetVisitsQueryStates(response: AxiosResponse): Promise<VisitQueryStates[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitQueryStates.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitQueryStates[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitQueryStates[]>(null as any);
    }

    /**
     * @param patientId (optional)
     * @return Request completed successfully
     */
    getAllForPatient(patientId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/patient/allFields?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllForPatient(_response));
        });
    }

    protected processGetAllForPatient(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @param patientId (optional)
     * @return Request completed successfully
     */
    getMyForPatient(patientId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/patient/my?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyForPatient(_response));
        });
    }

    protected processGetMyForPatient(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @param patientId (optional)
     * @return Request completed successfully
     */
    getForPatient(patientId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/patient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForPatient(_response));
        });
    }

    protected processGetForPatient(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    createForPatient(dto: QueryCreateDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateForPatient(_response));
        });
    }

    protected processCreateForPatient(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param instituteId (optional)
     * @return Request completed successfully
     */
    getForInstitute(instituteId: string | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/institute?";
        if (instituteId === null)
            throw new Error("The parameter 'instituteId' cannot be null.");
        else if (instituteId !== undefined)
            url_ += "instituteId=" + encodeURIComponent("" + instituteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForInstitute(_response));
        });
    }

    protected processGetForInstitute(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    createForInstitute(dto: QueryCreateDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/institute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateForInstitute(_response));
        });
    }

    protected processCreateForInstitute(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<QueryDto> {
        let url_ = this.baseUrl + "/api/v1/Query/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<QueryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryDto.fromJS(resultData200);
            return Promise.resolve<QueryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    edit(id: string, dto: QueryEditDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEdit(_response));
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param latestCount (optional)
     * @return Request completed successfully
     */
    getMy(latestCount: number | undefined, cancelToken?: CancelToken): Promise<QueryListResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/my?";
        if (latestCount === null)
            throw new Error("The parameter 'latestCount' cannot be null.");
        else if (latestCount !== undefined)
            url_ += "latestCount=" + encodeURIComponent("" + latestCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMy(_response));
        });
    }

    protected processGetMy(response: AxiosResponse): Promise<QueryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryListResponse.fromJS(resultData200);
            return Promise.resolve<QueryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryListResponse>(null as any);
    }

    /**
     * @param page (optional)
     * @param itemsPerPage (optional)
     * @param sortBy (optional)
     * @param sortDesc (optional)
     * @param studyPatientId (optional)
     * @param studyInstituteId (optional)
     * @param searchText (optional)
     * @return Request completed successfully
     */
    getOverview(page: number | undefined, itemsPerPage: number | undefined, sortBy: string[] | null | undefined, sortDesc: boolean[] | null | undefined, studyPatientId: string | null | undefined, studyInstituteId: string | null | undefined, searchText: string | null | undefined, cancelToken?: CancelToken): Promise<QueryOverviewResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/overview?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "ItemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        if (sortBy !== undefined && sortBy !== null)
            sortBy && sortBy.forEach(item => { url_ += "SortBy=" + encodeURIComponent("" + item) + "&"; });
        if (sortDesc !== undefined && sortDesc !== null)
            sortDesc && sortDesc.forEach(item => { url_ += "SortDesc=" + encodeURIComponent("" + item) + "&"; });
        if (studyPatientId !== undefined && studyPatientId !== null)
            url_ += "StudyPatientId=" + encodeURIComponent("" + studyPatientId) + "&";
        if (studyInstituteId !== undefined && studyInstituteId !== null)
            url_ += "StudyInstituteId=" + encodeURIComponent("" + studyInstituteId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOverview(_response));
        });
    }

    protected processGetOverview(response: AxiosResponse): Promise<QueryOverviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryOverviewResponse.fromJS(resultData200);
            return Promise.resolve<QueryOverviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryOverviewResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    createForField(dto: QueryCreateDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/field";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateForField(_response));
        });
    }

    protected processCreateForField(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    answer(id: string, dto: QueryAnswerDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/{id}/answer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAnswer(_response));
        });
    }

    protected processAnswer(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    revoke(id: string, dto: QueryRevokeDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/{id}/revoke";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRevoke(_response));
        });
    }

    protected processRevoke(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    accept(id: string, dto: QueryAcceptDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/{id}/accept";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAccept(_response));
        });
    }

    protected processAccept(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    solve(id: string, dto: QuerySolveDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/{id}/solve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSolve(_response));
        });
    }

    protected processSolve(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    defer(id: string, dto: QueryDeferDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Query/{id}/defer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDefer(_response));
        });
    }

    protected processDefer(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class QueryTypeDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllQueryTypeDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<QueryTypeDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/QueryTypeDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllQueryTypeDefinitions(_response));
        });
    }

    protected processGetAllQueryTypeDefinitions(response: AxiosResponse): Promise<QueryTypeDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryTypeDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryTypeDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: QueryTypeDefinitionCreateDto, cancelToken?: CancelToken): Promise<QueryTypeDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/QueryTypeDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<QueryTypeDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = QueryTypeDefinitionDto.fromJS(resultData201);
            return Promise.resolve<QueryTypeDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<QueryTypeDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/QueryTypeDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<QueryTypeDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryTypeDefinitionDto.fromJS(resultData200);
            return Promise.resolve<QueryTypeDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: QueryTypeDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/QueryTypeDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/QueryTypeDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class RuleDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllRuleDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<RuleDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/RuleDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllRuleDefinitions(_response));
        });
    }

    protected processGetAllRuleDefinitions(response: AxiosResponse): Promise<RuleDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RuleDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: RuleDefinitionCreateDto, cancelToken?: CancelToken): Promise<RuleDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/RuleDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RuleDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = RuleDefinitionDto.fromJS(resultData201);
            return Promise.resolve<RuleDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<RuleDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/RuleDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<RuleDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleDefinitionDto.fromJS(resultData200);
            return Promise.resolve<RuleDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: RuleDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/RuleDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/RuleDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class SafetyClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param fromDate (optional)
     * @return Request completed successfully
     */
    getSafetyReportForStudy(studyId: string, fromDate: Date | undefined, cancelToken?: CancelToken): Promise<SafetyReportResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Safety/study/{studyId}/freetext-report?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSafetyReportForStudy(_response));
        });
    }

    protected processGetSafetyReportForStudy(response: AxiosResponse): Promise<SafetyReportResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SafetyReportResponseDto.fromJS(resultData200);
            return Promise.resolve<SafetyReportResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyReportResponseDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getSafetyReportConfiguration(studyId: string, cancelToken?: CancelToken): Promise<SafetyReportConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/Safety/study/{studyId}/screening-configuration";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSafetyReportConfiguration(_response));
        });
    }

    protected processGetSafetyReportConfiguration(response: AxiosResponse): Promise<SafetyReportConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SafetyReportConfigurationDto.fromJS(resultData200);
            return Promise.resolve<SafetyReportConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyReportConfigurationDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    putSafetyReportConfiguration(studyId: string, configuration: SafetyReportConfigurationUpdateDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Safety/study/{studyId}/screening-configuration";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuration);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutSafetyReportConfiguration(_response));
        });
    }

    protected processPutSafetyReportConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @return Request completed successfully
     */
    getSafetyScreeningReportForStudy(studyId: string, fromDate: Date | undefined, toDate: Date | undefined, cancelToken?: CancelToken): Promise<SafetyReportResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Safety/study/{studyId}/screening-report?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSafetyScreeningReportForStudy(_response));
        });
    }

    protected processGetSafetyScreeningReportForStudy(response: AxiosResponse): Promise<SafetyReportResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SafetyReportResponseDto.fromJS(resultData200);
            return Promise.resolve<SafetyReportResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyReportResponseDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getEventReportOverviewForStudy(studyId: string, cancelToken?: CancelToken): Promise<EventReportOverviewDto> {
        let url_ = this.baseUrl + "/api/v1/Safety/study/{studyId}/eventreport-overview";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEventReportOverviewForStudy(_response));
        });
    }

    protected processGetEventReportOverviewForStudy(response: AxiosResponse): Promise<EventReportOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EventReportOverviewDto.fromJS(resultData200);
            return Promise.resolve<EventReportOverviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EventReportOverviewDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getSignatureById(id: string, cancelToken?: CancelToken): Promise<SignatureDataDto> {
        let url_ = this.baseUrl + "/api/v1/Safety/signature/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSignatureById(_response));
        });
    }

    protected processGetSignatureById(response: AxiosResponse): Promise<SignatureDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignatureDataDto.fromJS(resultData200);
            return Promise.resolve<SignatureDataDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getSignatureByReferenceId(referenceId: string, cancelToken?: CancelToken): Promise<SignatureDataDto> {
        let url_ = this.baseUrl + "/api/v1/Safety/signature/byReference/{referenceId}";
        if (referenceId === undefined || referenceId === null)
            throw new Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{referenceId}", encodeURIComponent("" + referenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSignatureByReferenceId(_response));
        });
    }

    protected processGetSignatureByReferenceId(response: AxiosResponse): Promise<SignatureDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignatureDataDto.fromJS(resultData200);
            return Promise.resolve<SignatureDataDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class StudyClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllStudys(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Study?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllStudys(_response));
        });
    }

    protected processGetAllStudys(response: AxiosResponse): Promise<StudyShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: StudyCreateDto, cancelToken?: CancelToken): Promise<StudyDto> {
        let url_ = this.baseUrl + "/api/v1/Study";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<StudyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = StudyDto.fromJS(resultData201);
            return Promise.resolve<StudyDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMyStudys(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Study/my?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyStudys(_response));
        });
    }

    protected processGetMyStudys(response: AxiosResponse): Promise<StudyShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<StudyDto> {
        let url_ = this.baseUrl + "/api/v1/Study/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<StudyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyDto.fromJS(resultData200);
            return Promise.resolve<StudyDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: StudyUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Study/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/Study/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class StudyDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllStudyDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllStudyDefinitions(_response));
        });
    }

    protected processGetAllStudyDefinitions(response: AxiosResponse): Promise<StudyDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: StudyDefinitionCreateDto, cancelToken?: CancelToken): Promise<StudyDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<StudyDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = StudyDefinitionDto.fromJS(resultData201);
            return Promise.resolve<StudyDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<StudyDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<StudyDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyDefinitionDto.fromJS(resultData200);
            return Promise.resolve<StudyDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: StudyDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    updateDates(id: string, dto: StudyDefinitionDatesUpdateDto, cancelToken?: CancelToken): Promise<StudyDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/{id}/dates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDates(_response));
        });
    }

    protected processUpdateDates(response: AxiosResponse): Promise<StudyDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyDefinitionDto.fromJS(resultData200);
            return Promise.resolve<StudyDefinitionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyDefinitionDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    exportStudyDefinition(studyDefinitionId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/{studyDefinitionId}/export";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportStudyDefinition(_response));
        });
    }

    protected processExportStudyDefinition(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    exportStudySeederDefinition(studyDefinitionId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/{studyDefinitionId}/study-seeder-export";
        if (studyDefinitionId === undefined || studyDefinitionId === null)
            throw new Error("The parameter 'studyDefinitionId' must be defined.");
        url_ = url_.replace("{studyDefinitionId}", encodeURIComponent("" + studyDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportStudySeederDefinition(_response));
        });
    }

    protected processExportStudySeederDefinition(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param testRun (optional)
     * @param zipFile (optional)
     * @return Request completed successfully
     */
    importStudyDefinition(testRun: boolean | undefined, zipFile: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<StudyDefinitionImportReportDto> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/import?";
        if (testRun === null)
            throw new Error("The parameter 'testRun' cannot be null.");
        else if (testRun !== undefined)
            url_ += "testRun=" + encodeURIComponent("" + testRun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (zipFile !== null && zipFile !== undefined)
            content_.append("zipFile", zipFile.data, zipFile.fileName ? zipFile.fileName : "zipFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportStudyDefinition(_response));
        });
    }

    protected processImportStudyDefinition(response: AxiosResponse): Promise<StudyDefinitionImportReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyDefinitionImportReportDto.fromJS(resultData200);
            return Promise.resolve<StudyDefinitionImportReportDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyDefinitionImportReportDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getSeededVersions( cancelToken?: CancelToken): Promise<SeededStudyDefinitionVersionDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/seeded-versions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSeededVersions(_response));
        });
    }

    protected processGetSeededVersions(response: AxiosResponse): Promise<SeededStudyDefinitionVersionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeededStudyDefinitionVersionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SeededStudyDefinitionVersionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SeededStudyDefinitionVersionDto[]>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getImportHistory( cancelToken?: CancelToken): Promise<StudyDefinitionHistoryEntryDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/history/entries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetImportHistory(_response));
        });
    }

    protected processGetImportHistory(response: AxiosResponse): Promise<StudyDefinitionHistoryEntryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyDefinitionHistoryEntryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyDefinitionHistoryEntryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyDefinitionHistoryEntryDto[]>(null as any);
    }

    /**
     * @param fileName (optional)
     * @return Request completed successfully
     */
    downloadImportReportFile(fileName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/StudyDefinition/history/files/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadImportReportFile(_response));
        });
    }

    protected processDownloadImportReportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StudyDefinitionSystemClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    importStudyDefinition(request: StudyDefinitionImportRequestDto, cancelToken?: CancelToken): Promise<StudyDefinitionImportReportDto> {
        let url_ = this.baseUrl + "/api/v1/system/studyDefinition/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportStudyDefinition(_response));
        });
    }

    protected processImportStudyDefinition(response: AxiosResponse): Promise<StudyDefinitionImportReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyDefinitionImportReportDto.fromJS(resultData200);
            return Promise.resolve<StudyDefinitionImportReportDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyDefinitionImportReportDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getStudyDefinition(studyDefinitionIdentifier: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/system/studyDefinition/{studyDefinitionIdentifier}";
        if (studyDefinitionIdentifier === undefined || studyDefinitionIdentifier === null)
            throw new Error("The parameter 'studyDefinitionIdentifier' must be defined.");
        url_ = url_.replace("{studyDefinitionIdentifier}", encodeURIComponent("" + studyDefinitionIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyDefinition(_response));
        });
    }

    protected processGetStudyDefinition(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StudyInstituteClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllStudyInstitutes(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyInstituteShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllStudyInstitutes(_response));
        });
    }

    protected processGetAllStudyInstitutes(response: AxiosResponse): Promise<StudyInstituteShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyInstituteShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyInstituteShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: StudyInstituteCreateDto, cancelToken?: CancelToken): Promise<StudyInstituteDto> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<StudyInstituteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = StudyInstituteDto.fromJS(resultData201);
            return Promise.resolve<StudyInstituteDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMyStudyInstitutes(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyInstituteShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute/my?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyStudyInstitutes(_response));
        });
    }

    protected processGetMyStudyInstitutes(response: AxiosResponse): Promise<StudyInstituteShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyInstituteShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyInstituteShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getStudyInstituteOverview( cancelToken?: CancelToken): Promise<StudyInstituteOverviewDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyInstituteOverview(_response));
        });
    }

    protected processGetStudyInstituteOverview(response: AxiosResponse): Promise<StudyInstituteOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyInstituteOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyInstituteOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyInstituteOverviewDto[]>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getMyStudyInstituteOverview( cancelToken?: CancelToken): Promise<StudyInstituteOverviewDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute/overview/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyStudyInstituteOverview(_response));
        });
    }

    protected processGetMyStudyInstituteOverview(response: AxiosResponse): Promise<StudyInstituteOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyInstituteOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyInstituteOverviewDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getStudyInstitutesByStudyId(studyId: string, includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyInstituteShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute/study/{studyId}?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyInstitutesByStudyId(_response));
        });
    }

    protected processGetStudyInstitutesByStudyId(response: AxiosResponse): Promise<StudyInstituteShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyInstituteShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyInstituteShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<StudyInstituteDto> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<StudyInstituteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyInstituteDto.fromJS(resultData200);
            return Promise.resolve<StudyInstituteDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: StudyInstituteUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/StudyInstitute/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class StudyPatientClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllStudyPatients(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyPatientShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllStudyPatients(_response));
        });
    }

    protected processGetAllStudyPatients(response: AxiosResponse): Promise<StudyPatientShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyPatientShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyPatientShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: StudyPatientCreateDto, cancelToken?: CancelToken): Promise<StudyPatientDto> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<StudyPatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = StudyPatientDto.fromJS(resultData201);
            return Promise.resolve<StudyPatientDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMyStudyPatients(studyId: string, includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyPatientShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient/study/{studyId}/my?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyStudyPatients(_response));
        });
    }

    protected processGetMyStudyPatients(response: AxiosResponse): Promise<StudyPatientShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyPatientShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyPatientShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getStudyPatientsByStudyId(studyId: string, includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<StudyPatientShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient/study/{studyId}?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyPatientsByStudyId(_response));
        });
    }

    protected processGetStudyPatientsByStudyId(response: AxiosResponse): Promise<StudyPatientShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyPatientShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyPatientShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<StudyPatientDto> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<StudyPatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyPatientDto.fromJS(resultData200);
            return Promise.resolve<StudyPatientDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    update(id: string, dto: StudyPatientUpdateDto, cancelToken?: CancelToken): Promise<StudyPatientDto> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<StudyPatientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyPatientDto.fromJS(resultData200);
            return Promise.resolve<StudyPatientDto>(result200);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    delete(id: string, dto: StudyPatientDeleteDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getContextById(id: string, cancelToken?: CancelToken): Promise<StudyPatientContextDto> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient/{id}/context";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContextById(_response));
        });
    }

    protected processGetContextById(response: AxiosResponse): Promise<StudyPatientContextDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyPatientContextDto.fromJS(resultData200);
            return Promise.resolve<StudyPatientContextDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    registerPatient(id: string, dto: StudyPatientRegisterPortalDto, cancelToken?: CancelToken): Promise<IdProviderSystemRegisterPatientResultDto> {
        let url_ = this.baseUrl + "/api/v1/StudyPatient/registerForPortal/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterPatient(_response));
        });
    }

    protected processRegisterPatient(response: AxiosResponse): Promise<IdProviderSystemRegisterPatientResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdProviderSystemRegisterPatientResultDto.fromJS(resultData200);
            return Promise.resolve<IdProviderSystemRegisterPatientResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdProviderSystemRegisterPatientResultDto>(null as any);
    }
}

export class SynQuestSystemApiClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    userLogin(dto: SynQuestSystemAuthLoginUserDto, cancelToken?: CancelToken): Promise<SynQuestLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/SynQuestSystemApi/userLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserLogin(_response));
        });
    }

    protected processUserLogin(response: AxiosResponse): Promise<SynQuestLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SynQuestLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<SynQuestLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SynQuestLoginResponseDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    patientLogin(dto: SynQuestSystemAuthLoginPatientDto, cancelToken?: CancelToken): Promise<SynQuestLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/SynQuestSystemApi/patientLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPatientLogin(_response));
        });
    }

    protected processPatientLogin(response: AxiosResponse): Promise<SynQuestLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SynQuestLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<SynQuestLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SynQuestLoginResponseDto>(null as any);
    }

    /**
     * @param instrumentId (optional)
     * @param isPaperInterview (optional)
     * @return Request completed successfully
     */
    getInterview(instrumentId: string | undefined, isPaperInterview: boolean | undefined, cancelToken?: CancelToken): Promise<SynQuestSystemShortInterviewDto> {
        let url_ = this.baseUrl + "/api/v1/SynQuestSystemApi/interview?";
        if (instrumentId === null)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else if (instrumentId !== undefined)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (isPaperInterview === null)
            throw new Error("The parameter 'isPaperInterview' cannot be null.");
        else if (isPaperInterview !== undefined)
            url_ += "isPaperInterview=" + encodeURIComponent("" + isPaperInterview) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInterview(_response));
        });
    }

    protected processGetInterview(response: AxiosResponse): Promise<SynQuestSystemShortInterviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SynQuestSystemShortInterviewDto.fromJS(resultData200);
            return Promise.resolve<SynQuestSystemShortInterviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SynQuestSystemShortInterviewDto>(null as any);
    }
}

export class UserActivityLogClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param identifier (optional)
     * @return Request completed successfully
     */
    getById(identifier: string | null | undefined, cancelToken?: CancelToken): Promise<UserActivityLogDto[]> {
        let url_ = this.baseUrl + "/api/v1/UserActivityLog/userActivityLog?";
        if (identifier !== undefined && identifier !== null)
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserActivityLogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivityLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserActivityLogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserActivityLogDto[]>(null as any);
    }
}

export class VerificationFlagClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<VerificationFlagDto> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VerificationFlagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerificationFlagDto.fromJS(resultData200);
            return Promise.resolve<VerificationFlagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerificationFlagDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    update(id: string, dto: VerificationFlagUpdateDto, cancelToken?: CancelToken): Promise<VerificationFlagDto> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VerificationFlagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerificationFlagDto.fromJS(resultData200);
            return Promise.resolve<VerificationFlagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerificationFlagDto>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    getForStudyPatient(patientId: string, cancelToken?: CancelToken): Promise<VerificationFlagDto[]> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlag/studyPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForStudyPatient(_response));
        });
    }

    protected processGetForStudyPatient(response: AxiosResponse): Promise<VerificationFlagDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VerificationFlagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VerificationFlagDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerificationFlagDto[]>(null as any);
    }

    /**
     * @return Request completed successfully
     */
    set(dto: VerificationFlagSetDto, cancelToken?: CancelToken): Promise<VerificationFlagShortDto> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSet(_response));
        });
    }

    protected processSet(response: AxiosResponse): Promise<VerificationFlagShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerificationFlagShortDto.fromJS(resultData200);
            return Promise.resolve<VerificationFlagShortDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerificationFlagShortDto>(null as any);
    }
}

export class VerificationFlagTypeDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllVerificationFlagTypeDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<VerificationFlagTypeDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlagTypeDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllVerificationFlagTypeDefinitions(_response));
        });
    }

    protected processGetAllVerificationFlagTypeDefinitions(response: AxiosResponse): Promise<VerificationFlagTypeDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VerificationFlagTypeDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VerificationFlagTypeDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: VerificationFlagTypeDefinitionCreateDto, cancelToken?: CancelToken): Promise<VerificationFlagTypeDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlagTypeDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VerificationFlagTypeDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = VerificationFlagTypeDefinitionDto.fromJS(resultData201);
            return Promise.resolve<VerificationFlagTypeDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<VerificationFlagTypeDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlagTypeDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VerificationFlagTypeDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerificationFlagTypeDefinitionDto.fromJS(resultData200);
            return Promise.resolve<VerificationFlagTypeDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: VerificationFlagTypeDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlagTypeDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/VerificationFlagTypeDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class VisitClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllVisits(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<VisitShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Visit?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllVisits(_response));
        });
    }

    protected processGetAllVisits(response: AxiosResponse): Promise<VisitShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: VisitCreateDto, cancelToken?: CancelToken): Promise<VisitDto> {
        let url_ = this.baseUrl + "/api/v1/Visit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VisitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = VisitDto.fromJS(resultData201);
            return Promise.resolve<VisitDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getMyVisits(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<VisitShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Visit/my?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMyVisits(_response));
        });
    }

    protected processGetMyVisits(response: AxiosResponse): Promise<VisitShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getVisitsByStudyId(studyId: string, includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<VisitShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/Visit/study/{studyId}?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVisitsByStudyId(_response));
        });
    }

    protected processGetVisitsByStudyId(response: AxiosResponse): Promise<VisitShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<VisitDto> {
        let url_ = this.baseUrl + "/api/v1/Visit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VisitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VisitDto.fromJS(resultData200);
            return Promise.resolve<VisitDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    update(id: string, dto: VisitUpdateDto, cancelToken?: CancelToken): Promise<VisitDto> {
        let url_ = this.baseUrl + "/api/v1/Visit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VisitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VisitDto.fromJS(resultData200);
            return Promise.resolve<VisitDto>(result200);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/Visit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    sign(id: string, dto: VisitSignatureDto, cancelToken?: CancelToken): Promise<VisitSignatureResult> {
        let url_ = this.baseUrl + "/api/v1/Visit/{id}/sign";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSign(_response));
        });
    }

    protected processSign(response: AxiosResponse): Promise<VisitSignatureResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VisitSignatureResult.fromJS(resultData200);
            return Promise.resolve<VisitSignatureResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitSignatureResult>(null as any);
    }
}

export class VisitDefinitionClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param includeDeleted (optional)
     * @return Request completed successfully
     */
    getAllVisitDefinitions(includeDeleted: boolean | null | undefined, cancelToken?: CancelToken): Promise<VisitDefinitionShortDto[]> {
        let url_ = this.baseUrl + "/api/v1/VisitDefinition?";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllVisitDefinitions(_response));
        });
    }

    protected processGetAllVisitDefinitions(response: AxiosResponse): Promise<VisitDefinitionShortDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitDefinitionShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitDefinitionShortDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Object created successfully
     */
    create(dto: VisitDefinitionCreateDto, cancelToken?: CancelToken): Promise<VisitDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/VisitDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VisitDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = VisitDefinitionDto.fromJS(resultData201);
            return Promise.resolve<VisitDefinitionDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request completed successfully
     */
    getById(id: string, cancelToken?: CancelToken): Promise<VisitDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/VisitDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VisitDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VisitDefinitionDto.fromJS(resultData200);
            return Promise.resolve<VisitDefinitionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @return Request successfully processed
     */
    update(id: string, dto: VisitDefinitionUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/VisitDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized request", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v1/VisitDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ProblemDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden Request", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("An internal error occured", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return Promise.resolve<ProblemDetails>(resultdefault);

        }
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class DataExchangeFileDto implements IDataExchangeFileDto {
    fileName?: string | undefined;
    fileCreationDate?: Date;

    constructor(data?: IDataExchangeFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileCreationDate = _data["fileCreationDate"] ? new Date(_data["fileCreationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DataExchangeFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataExchangeFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileCreationDate"] = this.fileCreationDate ? this.fileCreationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DataExchangeFileDto {
        const json = this.toJSON();
        let result = new DataExchangeFileDto();
        result.init(json);
        return result;
    }
}

export interface IDataExchangeFileDto {
    fileName?: string | undefined;
    fileCreationDate?: Date;
}

export class PagedResultDtoOfAuditLogEntryDto implements IPagedResultDtoOfAuditLogEntryDto {
    items?: AuditLogEntryDto[] | undefined;
    totalCount?: number;
    skip?: number;
    take?: number;

    constructor(data?: IPagedResultDtoOfAuditLogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }

    clone(): PagedResultDtoOfAuditLogEntryDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditLogEntryDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditLogEntryDto {
    items?: AuditLogEntryDto[] | undefined;
    totalCount?: number;
    skip?: number;
    take?: number;
}

export class AuditLogEntryDto implements IAuditLogEntryDto {
    id?: number;
    identifier?: string | undefined;
    action?: string | undefined;
    timeStamp?: Date;
    userId?: string;
    user?: ShortUserDto | undefined;
    message?: string | undefined;
    formattedMessage?: string | undefined;
    parameters?: any | undefined;
    tags?: any | undefined;

    constructor(data?: IAuditLogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.action = _data["action"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? ShortUserDto.fromJS(_data["user"]) : <any>undefined;
            this.message = _data["message"];
            this.formattedMessage = _data["formattedMessage"];
            this.parameters = _data["parameters"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): AuditLogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["action"] = this.action;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["formattedMessage"] = this.formattedMessage;
        data["parameters"] = this.parameters;
        data["tags"] = this.tags;
        return data;
    }

    clone(): AuditLogEntryDto {
        const json = this.toJSON();
        let result = new AuditLogEntryDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogEntryDto {
    id?: number;
    identifier?: string | undefined;
    action?: string | undefined;
    timeStamp?: Date;
    userId?: string;
    user?: ShortUserDto | undefined;
    message?: string | undefined;
    formattedMessage?: string | undefined;
    parameters?: any | undefined;
    tags?: any | undefined;
}

export abstract class BaseIdDto implements IBaseIdDto {
    id!: string;

    constructor(data?: IBaseIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BaseIdDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseIdDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): BaseIdDto {
        throw new Error("The abstract class 'BaseIdDto' cannot be instantiated.");
    }
}

export interface IBaseIdDto {
    id: string;
}

export abstract class BaseDto extends BaseIdDto implements IBaseDto {
    isDeleted?: boolean;

    constructor(data?: IBaseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): BaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }

    clone(): BaseDto {
        throw new Error("The abstract class 'BaseDto' cannot be instantiated.");
    }
}

export interface IBaseDto extends IBaseIdDto {
    isDeleted?: boolean;
}

export class ShortUserDto extends BaseDto implements IShortUserDto {
    userName?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    role?: ShortRoleDto | undefined;
    isDeactivated?: boolean;
    tags?: any | undefined;

    constructor(data?: IShortUserDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.role = _data["role"] ? ShortRoleDto.fromJS(_data["role"]) : <any>undefined;
            this.isDeactivated = _data["isDeactivated"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): ShortUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShortUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["isDeactivated"] = this.isDeactivated;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): ShortUserDto {
        const json = this.toJSON();
        let result = new ShortUserDto();
        result.init(json);
        return result;
    }
}

export interface IShortUserDto extends IBaseDto {
    userName?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    role?: ShortRoleDto | undefined;
    isDeactivated?: boolean;
    tags?: any | undefined;
}

export class ShortRoleDto extends BaseIdDto implements IShortRoleDto {
    identifier?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IShortRoleDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ShortRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShortRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): ShortRoleDto {
        const json = this.toJSON();
        let result = new ShortRoleDto();
        result.init(json);
        return result;
    }
}

export interface IShortRoleDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
}

export class AuditEventDto implements IAuditEventDto {
    id?: number;
    action?: string | undefined;
    userId?: string;
    timeStamp?: Date;
    reasonOfChange?: string | undefined;
    appUser?: ShortUserDto | undefined;
    changes?: AuditChangeDto[] | undefined;
    previousHash?: string | undefined;
    hash?: string | undefined;

    constructor(data?: IAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.userId = _data["userId"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.reasonOfChange = _data["reasonOfChange"];
            this.appUser = _data["appUser"] ? ShortUserDto.fromJS(_data["appUser"]) : <any>undefined;
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(AuditChangeDto.fromJS(item));
            }
            this.previousHash = _data["previousHash"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): AuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["userId"] = this.userId;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["reasonOfChange"] = this.reasonOfChange;
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>undefined;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        data["previousHash"] = this.previousHash;
        data["hash"] = this.hash;
        return data;
    }

    clone(): AuditEventDto {
        const json = this.toJSON();
        let result = new AuditEventDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDto {
    id?: number;
    action?: string | undefined;
    userId?: string;
    timeStamp?: Date;
    reasonOfChange?: string | undefined;
    appUser?: ShortUserDto | undefined;
    changes?: AuditChangeDto[] | undefined;
    previousHash?: string | undefined;
    hash?: string | undefined;
}

export class AuditChangeDto implements IAuditChangeDto {
    id?: number;
    auditEventId?: number;
    tableName?: string | undefined;
    operation?: string | undefined;
    keyValues?: any | undefined;
    oldValues?: any | undefined;
    newValues?: any | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    previousHash?: string | undefined;
    hash?: string | undefined;

    constructor(data?: IAuditChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditEventId = _data["auditEventId"];
            this.tableName = _data["tableName"];
            this.operation = _data["operation"];
            this.keyValues = _data["keyValues"];
            this.oldValues = _data["oldValues"];
            this.newValues = _data["newValues"];
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
            this.previousHash = _data["previousHash"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): AuditChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditEventId"] = this.auditEventId;
        data["tableName"] = this.tableName;
        data["operation"] = this.operation;
        data["keyValues"] = this.keyValues;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        data["previousHash"] = this.previousHash;
        data["hash"] = this.hash;
        return data;
    }

    clone(): AuditChangeDto {
        const json = this.toJSON();
        let result = new AuditChangeDto();
        result.init(json);
        return result;
    }
}

export interface IAuditChangeDto {
    id?: number;
    auditEventId?: number;
    tableName?: string | undefined;
    operation?: string | undefined;
    keyValues?: any | undefined;
    oldValues?: any | undefined;
    newValues?: any | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    previousHash?: string | undefined;
    hash?: string | undefined;
}

export class AuditReasonOfChangeDto implements IAuditReasonOfChangeDto {
    objectReason?: string | undefined;
    propertyReasons?: { [key: string]: string; } | undefined;

    constructor(data?: IAuditReasonOfChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectReason = _data["objectReason"];
            if (_data["propertyReasons"]) {
                this.propertyReasons = {} as any;
                for (let key in _data["propertyReasons"]) {
                    if (_data["propertyReasons"].hasOwnProperty(key))
                        (<any>this.propertyReasons)![key] = _data["propertyReasons"][key];
                }
            }
        }
    }

    static fromJS(data: any): AuditReasonOfChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditReasonOfChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectReason"] = this.objectReason;
        if (this.propertyReasons) {
            data["propertyReasons"] = {};
            for (let key in this.propertyReasons) {
                if (this.propertyReasons.hasOwnProperty(key))
                    (<any>data["propertyReasons"])[key] = (<any>this.propertyReasons)[key];
            }
        }
        return data;
    }

    clone(): AuditReasonOfChangeDto {
        const json = this.toJSON();
        let result = new AuditReasonOfChangeDto();
        result.init(json);
        return result;
    }
}

export interface IAuditReasonOfChangeDto {
    objectReason?: string | undefined;
    propertyReasons?: { [key: string]: string; } | undefined;
}

export class TokenDto implements ITokenDto {
    token?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpirationDate?: Date;

    constructor(data?: ITokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpirationDate = _data["refreshTokenExpirationDate"] ? new Date(_data["refreshTokenExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpirationDate"] = this.refreshTokenExpirationDate ? this.refreshTokenExpirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): TokenDto {
        const json = this.toJSON();
        let result = new TokenDto();
        result.init(json);
        return result;
    }
}

export interface ITokenDto {
    token?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpirationDate?: Date;
}

export class LoginDto implements ILoginDto {
    userName!: string;
    password!: string;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }

    clone(): LoginDto {
        const json = this.toJSON();
        let result = new LoginDto();
        result.init(json);
        return result;
    }
}

export interface ILoginDto {
    userName: string;
    password: string;
}

export class DataMigrationStatusDto implements IDataMigrationStatusDto {
    order?: number;
    migrationId?: string | undefined;
    description?: string | undefined;
    completed?: boolean;
    executionDate?: Date | undefined;
    rerunAllowed?: boolean;

    constructor(data?: IDataMigrationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.migrationId = _data["migrationId"];
            this.description = _data["description"];
            this.completed = _data["completed"];
            this.executionDate = _data["executionDate"] ? new Date(_data["executionDate"].toString()) : <any>undefined;
            this.rerunAllowed = _data["rerunAllowed"];
        }
    }

    static fromJS(data: any): DataMigrationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataMigrationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["migrationId"] = this.migrationId;
        data["description"] = this.description;
        data["completed"] = this.completed;
        data["executionDate"] = this.executionDate ? this.executionDate.toISOString() : <any>undefined;
        data["rerunAllowed"] = this.rerunAllowed;
        return data;
    }

    clone(): DataMigrationStatusDto {
        const json = this.toJSON();
        let result = new DataMigrationStatusDto();
        result.init(json);
        return result;
    }
}

export interface IDataMigrationStatusDto {
    order?: number;
    migrationId?: string | undefined;
    description?: string | undefined;
    completed?: boolean;
    executionDate?: Date | undefined;
    rerunAllowed?: boolean;
}

export class DataMigrationReportDto implements IDataMigrationReportDto {
    success?: boolean;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    results?: DataMigrationResultDto[] | undefined;

    constructor(data?: IDataMigrationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DataMigrationResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataMigrationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataMigrationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }

    clone(): DataMigrationReportDto {
        const json = this.toJSON();
        let result = new DataMigrationReportDto();
        result.init(json);
        return result;
    }
}

export interface IDataMigrationReportDto {
    success?: boolean;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    results?: DataMigrationResultDto[] | undefined;
}

export class DataMigrationResultDto implements IDataMigrationResultDto {
    migrationId?: string | undefined;
    outcome?: string | undefined;
    error?: string | undefined;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;

    constructor(data?: IDataMigrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.migrationId = _data["migrationId"];
            this.outcome = _data["outcome"];
            this.error = _data["error"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DataMigrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataMigrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["migrationId"] = this.migrationId;
        data["outcome"] = this.outcome;
        data["error"] = this.error;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): DataMigrationResultDto {
        const json = this.toJSON();
        let result = new DataMigrationResultDto();
        result.init(json);
        return result;
    }
}

export interface IDataMigrationResultDto {
    migrationId?: string | undefined;
    outcome?: string | undefined;
    error?: string | undefined;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
}

export class DocumentShortDto extends BaseDto implements IDocumentShortDto {
    identifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    order?: number;
    currentVersion?: number;
    contentVersions?: DocumentContentShortDto[] | undefined;
    tags?: any | undefined;

    constructor(data?: IDocumentShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.currentVersion = _data["currentVersion"];
            if (Array.isArray(_data["contentVersions"])) {
                this.contentVersions = [] as any;
                for (let item of _data["contentVersions"])
                    this.contentVersions!.push(DocumentContentShortDto.fromJS(item));
            }
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): DocumentShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["description"] = this.description;
        data["order"] = this.order;
        data["currentVersion"] = this.currentVersion;
        if (Array.isArray(this.contentVersions)) {
            data["contentVersions"] = [];
            for (let item of this.contentVersions)
                data["contentVersions"].push(item.toJSON());
        }
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentShortDto {
        const json = this.toJSON();
        let result = new DocumentShortDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentShortDto extends IBaseDto {
    identifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    order?: number;
    currentVersion?: number;
    contentVersions?: DocumentContentShortDto[] | undefined;
    tags?: any | undefined;
}

export class DocumentContentShortDto implements IDocumentContentShortDto {
    version?: number;
    size?: number;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    uploadedOn?: Date;
    comment?: string | undefined;

    constructor(data?: IDocumentContentShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.size = _data["size"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.uploadedOn = _data["uploadedOn"] ? new Date(_data["uploadedOn"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): DocumentContentShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentContentShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["size"] = this.size;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["uploadedOn"] = this.uploadedOn ? this.uploadedOn.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): DocumentContentShortDto {
        const json = this.toJSON();
        let result = new DocumentContentShortDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentContentShortDto {
    version?: number;
    size?: number;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    uploadedOn?: Date;
    comment?: string | undefined;
}

export class DocumentUpdateDto extends BaseIdDto implements IDocumentUpdateDto {
    identifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    order?: number;
    tags?: any | undefined;

    constructor(data?: IDocumentUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): DocumentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["description"] = this.description;
        data["order"] = this.order;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentUpdateDto {
        const json = this.toJSON();
        let result = new DocumentUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    order?: number;
    tags?: any | undefined;
}

export class BaseSyncResultDto implements IBaseSyncResultDto {
    system?: string | undefined;

    constructor(data?: IBaseSyncResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): BaseSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        return data;
    }

    clone(): BaseSyncResultDto {
        const json = this.toJSON();
        let result = new BaseSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface IBaseSyncResultDto {
    system?: string | undefined;
}

export class IdProviderUserSyncResultDto extends BaseSyncResultDto implements IIdProviderUserSyncResultDto {
    createdUserCount?: number;
    updatedUserCount?: number;
    deletedUserCount?: number;

    constructor(data?: IIdProviderUserSyncResultDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdUserCount = _data["createdUserCount"];
            this.updatedUserCount = _data["updatedUserCount"];
            this.deletedUserCount = _data["deletedUserCount"];
        }
    }

    static fromJS(data: any): IdProviderUserSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdProviderUserSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdUserCount"] = this.createdUserCount;
        data["updatedUserCount"] = this.updatedUserCount;
        data["deletedUserCount"] = this.deletedUserCount;
        super.toJSON(data);
        return data;
    }

    clone(): IdProviderUserSyncResultDto {
        const json = this.toJSON();
        let result = new IdProviderUserSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface IIdProviderUserSyncResultDto extends IBaseSyncResultDto {
    createdUserCount?: number;
    updatedUserCount?: number;
    deletedUserCount?: number;
}

export abstract class BaseSyncContentDto implements IBaseSyncContentDto {
    sourceSystem?: string;

    constructor(data?: IBaseSyncContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSystem = _data["sourceSystem"];
        }
    }

    static fromJS(data: any): BaseSyncContentDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSyncContentDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSystem"] = this.sourceSystem;
        return data;
    }

    clone(): BaseSyncContentDto {
        throw new Error("The abstract class 'BaseSyncContentDto' cannot be instantiated.");
    }
}

export interface IBaseSyncContentDto {
    sourceSystem?: string;
}

export class IdProviderPatientSyncResultDto extends BaseSyncContentDto implements IIdProviderPatientSyncResultDto {
    createdPatientsCount?: number;
    updatedPatientsCount?: number;
    deletedPatientsCount?: number;

    constructor(data?: IIdProviderPatientSyncResultDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdPatientsCount = _data["createdPatientsCount"];
            this.updatedPatientsCount = _data["updatedPatientsCount"];
            this.deletedPatientsCount = _data["deletedPatientsCount"];
        }
    }

    static fromJS(data: any): IdProviderPatientSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdProviderPatientSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdPatientsCount"] = this.createdPatientsCount;
        data["updatedPatientsCount"] = this.updatedPatientsCount;
        data["deletedPatientsCount"] = this.deletedPatientsCount;
        super.toJSON(data);
        return data;
    }

    clone(): IdProviderPatientSyncResultDto {
        const json = this.toJSON();
        let result = new IdProviderPatientSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface IIdProviderPatientSyncResultDto extends IBaseSyncContentDto {
    createdPatientsCount?: number;
    updatedPatientsCount?: number;
    deletedPatientsCount?: number;
}

export class IdProviderInstituteSyncResultDto implements IIdProviderInstituteSyncResultDto {
    createdInstitutesCount?: number;
    updatedInstitutesCount?: number;
    deletedInstitutesCount?: number;
    patientAssignmentsAddedCount?: number;
    patientAssignmentsRemovedCount?: number;
    userAssignmentsAddedCount?: number;
    userAssignmentsRemovedCount?: number;

    constructor(data?: IIdProviderInstituteSyncResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdInstitutesCount = _data["createdInstitutesCount"];
            this.updatedInstitutesCount = _data["updatedInstitutesCount"];
            this.deletedInstitutesCount = _data["deletedInstitutesCount"];
            this.patientAssignmentsAddedCount = _data["patientAssignmentsAddedCount"];
            this.patientAssignmentsRemovedCount = _data["patientAssignmentsRemovedCount"];
            this.userAssignmentsAddedCount = _data["userAssignmentsAddedCount"];
            this.userAssignmentsRemovedCount = _data["userAssignmentsRemovedCount"];
        }
    }

    static fromJS(data: any): IdProviderInstituteSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdProviderInstituteSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdInstitutesCount"] = this.createdInstitutesCount;
        data["updatedInstitutesCount"] = this.updatedInstitutesCount;
        data["deletedInstitutesCount"] = this.deletedInstitutesCount;
        data["patientAssignmentsAddedCount"] = this.patientAssignmentsAddedCount;
        data["patientAssignmentsRemovedCount"] = this.patientAssignmentsRemovedCount;
        data["userAssignmentsAddedCount"] = this.userAssignmentsAddedCount;
        data["userAssignmentsRemovedCount"] = this.userAssignmentsRemovedCount;
        return data;
    }

    clone(): IdProviderInstituteSyncResultDto {
        const json = this.toJSON();
        let result = new IdProviderInstituteSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface IIdProviderInstituteSyncResultDto {
    createdInstitutesCount?: number;
    updatedInstitutesCount?: number;
    deletedInstitutesCount?: number;
    patientAssignmentsAddedCount?: number;
    patientAssignmentsRemovedCount?: number;
    userAssignmentsAddedCount?: number;
    userAssignmentsRemovedCount?: number;
}

export class UsersToInstituteAssignmentDto extends BaseIdDto implements IUsersToInstituteAssignmentDto {
    userIds!: string[];

    constructor(data?: IUsersToInstituteAssignmentDto) {
        super(data);
        if (!data) {
            this.userIds = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UsersToInstituteAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToInstituteAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): UsersToInstituteAssignmentDto {
        const json = this.toJSON();
        let result = new UsersToInstituteAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IUsersToInstituteAssignmentDto extends IBaseIdDto {
    userIds: string[];
}

export class UserToInstitutesAssignmentDto extends BaseIdDto implements IUserToInstitutesAssignmentDto {
    instituteIds!: string[];

    constructor(data?: IUserToInstitutesAssignmentDto) {
        super(data);
        if (!data) {
            this.instituteIds = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["instituteIds"])) {
                this.instituteIds = [] as any;
                for (let item of _data["instituteIds"])
                    this.instituteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserToInstitutesAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserToInstitutesAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instituteIds)) {
            data["instituteIds"] = [];
            for (let item of this.instituteIds)
                data["instituteIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): UserToInstitutesAssignmentDto {
        const json = this.toJSON();
        let result = new UserToInstitutesAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IUserToInstitutesAssignmentDto extends IBaseIdDto {
    instituteIds: string[];
}

export class PatientsToInstituteAssignmentDto extends BaseIdDto implements IPatientsToInstituteAssignmentDto {
    patientIds!: string[];

    constructor(data?: IPatientsToInstituteAssignmentDto) {
        super(data);
        if (!data) {
            this.patientIds = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["patientIds"])) {
                this.patientIds = [] as any;
                for (let item of _data["patientIds"])
                    this.patientIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PatientsToInstituteAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientsToInstituteAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patientIds)) {
            data["patientIds"] = [];
            for (let item of this.patientIds)
                data["patientIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PatientsToInstituteAssignmentDto {
        const json = this.toJSON();
        let result = new PatientsToInstituteAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IPatientsToInstituteAssignmentDto extends IBaseIdDto {
    patientIds: string[];
}

export class PatientToInstitutesAssignmentDto extends BaseIdDto implements IPatientToInstitutesAssignmentDto {
    instituteIds!: string[];

    constructor(data?: IPatientToInstitutesAssignmentDto) {
        super(data);
        if (!data) {
            this.instituteIds = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["instituteIds"])) {
                this.instituteIds = [] as any;
                for (let item of _data["instituteIds"])
                    this.instituteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PatientToInstitutesAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientToInstitutesAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instituteIds)) {
            data["instituteIds"] = [];
            for (let item of this.instituteIds)
                data["instituteIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PatientToInstitutesAssignmentDto {
        const json = this.toJSON();
        let result = new PatientToInstitutesAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IPatientToInstitutesAssignmentDto extends IBaseIdDto {
    instituteIds: string[];
}

export class InstituteShortDto extends BaseDto implements IInstituteShortDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    isDeactivated?: boolean;
    tags?: any | undefined;

    constructor(data?: IInstituteShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.isDeactivated = _data["isDeactivated"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): InstituteShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["isDeactivated"] = this.isDeactivated;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): InstituteShortDto {
        const json = this.toJSON();
        let result = new InstituteShortDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    isDeactivated?: boolean;
    tags?: any | undefined;
}

export class InstituteCompleteDto extends InstituteShortDto implements IInstituteCompleteDto {
    users?: string[] | undefined;
    patients?: string[] | undefined;

    constructor(data?: IInstituteCompleteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(item);
            }
        }
    }

    static fromJS(data: any): InstituteCompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteCompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): InstituteCompleteDto {
        const json = this.toJSON();
        let result = new InstituteCompleteDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteCompleteDto extends IInstituteShortDto {
    users?: string[] | undefined;
    patients?: string[] | undefined;
}

export class InstituteDto extends BaseDto implements IInstituteDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    users?: string[] | undefined;
    patients?: string[] | undefined;
    isDeactivated?: boolean;
    tags?: any | undefined;

    constructor(data?: IInstituteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(item);
            }
            this.isDeactivated = _data["isDeactivated"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): InstituteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item);
        }
        data["isDeactivated"] = this.isDeactivated;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): InstituteDto {
        const json = this.toJSON();
        let result = new InstituteDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteDto extends IBaseDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    users?: string[] | undefined;
    patients?: string[] | undefined;
    isDeactivated?: boolean;
    tags?: any | undefined;
}

export class InstituteCreateDto implements IInstituteCreateDto {
    identifier!: string;
    displayName!: string;
    tags?: any | undefined;

    constructor(data?: IInstituteCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): InstituteCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["tags"] = this.tags;
        return data;
    }

    clone(): InstituteCreateDto {
        const json = this.toJSON();
        let result = new InstituteCreateDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteCreateDto {
    identifier: string;
    displayName: string;
    tags?: any | undefined;
}

export class InstituteUpdateDto extends BaseIdDto implements IInstituteUpdateDto {
    identifier!: string;
    displayName!: string;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    tags?: any | undefined;

    constructor(data?: IInstituteUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): InstituteUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): InstituteUpdateDto {
        const json = this.toJSON();
        let result = new InstituteUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteUpdateDto extends IBaseIdDto {
    identifier: string;
    displayName: string;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    tags?: any | undefined;
}

export class PatientDto extends BaseDto implements IPatientDto {
    identifier?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;
    birthYear?: number | undefined;
    registrationDate?: Date | undefined;
    tags?: any | undefined;

    constructor(data?: IPatientDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthYear = _data["birthYear"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthYear"] = this.birthYear;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): PatientDto {
        const json = this.toJSON();
        let result = new PatientDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDto extends IBaseDto {
    identifier?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;
    birthYear?: number | undefined;
    registrationDate?: Date | undefined;
    tags?: any | undefined;
}

export class PatientCreateDto implements IPatientCreateDto {
    identifier!: string;
    name!: string;
    gender!: string;
    birthYear?: number | undefined;
    registrationDate?: Date | undefined;
    tags?: any | undefined;

    constructor(data?: IPatientCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthYear = _data["birthYear"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): PatientCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthYear"] = this.birthYear;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        return data;
    }

    clone(): PatientCreateDto {
        const json = this.toJSON();
        let result = new PatientCreateDto();
        result.init(json);
        return result;
    }
}

export interface IPatientCreateDto {
    identifier: string;
    name: string;
    gender: string;
    birthYear?: number | undefined;
    registrationDate?: Date | undefined;
    tags?: any | undefined;
}

export class PatientUpdateDto extends BaseIdDto implements IPatientUpdateDto {
    identifier?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;
    birthYear?: number | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    tags?: any | undefined;

    constructor(data?: IPatientUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthYear = _data["birthYear"];
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): PatientUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthYear"] = this.birthYear;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): PatientUpdateDto {
        const json = this.toJSON();
        let result = new PatientUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IPatientUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;
    birthYear?: number | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    tags?: any | undefined;
}

export class RightDto extends BaseDto implements IRightDto {
    identifier?: string | undefined;
    displayName?: Rights | undefined;

    constructor(data?: IRightDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RightDto {
        data = typeof data === 'object' ? data : {};
        let result = new RightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): RightDto {
        const json = this.toJSON();
        let result = new RightDto();
        result.init(json);
        return result;
    }
}

export interface IRightDto extends IBaseDto {
    identifier?: string | undefined;
    displayName?: Rights | undefined;
}

export class RightCreateDto implements IRightCreateDto {
    identifier!: string;
    displayName!: string;

    constructor(data?: IRightCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RightCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RightCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): RightCreateDto {
        const json = this.toJSON();
        let result = new RightCreateDto();
        result.init(json);
        return result;
    }
}

export interface IRightCreateDto {
    identifier: string;
    displayName: string;
}

export class RightUpdateDto extends BaseIdDto implements IRightUpdateDto {
    identifier?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IRightUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RightUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RightUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): RightUpdateDto {
        const json = this.toJSON();
        let result = new RightUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IRightUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
}

export class RoleDto extends BaseDto implements IRoleDto {
    displayName?: string | undefined;
    identifier?: string | undefined;
    rights?: RightDto[] | undefined;

    constructor(data?: IRoleDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["displayName"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["rights"])) {
                this.rights = [] as any;
                for (let item of _data["rights"])
                    this.rights!.push(RightDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.rights)) {
            data["rights"] = [];
            for (let item of this.rights)
                data["rights"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto extends IBaseDto {
    displayName?: string | undefined;
    identifier?: string | undefined;
    rights?: RightDto[] | undefined;
}

export class RoleCreateDto implements IRoleCreateDto {
    identifier!: string;
    displayName!: string;
    rightsIds?: string[] | undefined;

    constructor(data?: IRoleCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["rightsIds"])) {
                this.rightsIds = [] as any;
                for (let item of _data["rightsIds"])
                    this.rightsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.rightsIds)) {
            data["rightsIds"] = [];
            for (let item of this.rightsIds)
                data["rightsIds"].push(item);
        }
        return data;
    }

    clone(): RoleCreateDto {
        const json = this.toJSON();
        let result = new RoleCreateDto();
        result.init(json);
        return result;
    }
}

export interface IRoleCreateDto {
    identifier: string;
    displayName: string;
    rightsIds?: string[] | undefined;
}

export class RoleUpdateDto extends BaseIdDto implements IRoleUpdateDto {
    identifier!: string;
    displayName!: string;
    rightsIds?: string[] | undefined;

    constructor(data?: IRoleUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["rightsIds"])) {
                this.rightsIds = [] as any;
                for (let item of _data["rightsIds"])
                    this.rightsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.rightsIds)) {
            data["rightsIds"] = [];
            for (let item of this.rightsIds)
                data["rightsIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): RoleUpdateDto {
        const json = this.toJSON();
        let result = new RoleUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IRoleUpdateDto extends IBaseIdDto {
    identifier: string;
    displayName: string;
    rightsIds?: string[] | undefined;
}

export class PatientSyncResultDto extends BaseSyncResultDto implements IPatientSyncResultDto {
    createdPatientsCount?: number;
    updatedPatientsCount?: number;
    deletedPatientsCount?: number;

    constructor(data?: IPatientSyncResultDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdPatientsCount = _data["createdPatientsCount"];
            this.updatedPatientsCount = _data["updatedPatientsCount"];
            this.deletedPatientsCount = _data["deletedPatientsCount"];
        }
    }

    static fromJS(data: any): PatientSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdPatientsCount"] = this.createdPatientsCount;
        data["updatedPatientsCount"] = this.updatedPatientsCount;
        data["deletedPatientsCount"] = this.deletedPatientsCount;
        super.toJSON(data);
        return data;
    }

    clone(): PatientSyncResultDto {
        const json = this.toJSON();
        let result = new PatientSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientSyncResultDto extends IBaseSyncResultDto {
    createdPatientsCount?: number;
    updatedPatientsCount?: number;
    deletedPatientsCount?: number;
}

export class PatientSyncContentDto extends BaseSyncContentDto implements IPatientSyncContentDto {
    patients?: PatientSyncDto[] | undefined;

    constructor(data?: IPatientSyncContentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientSyncContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSyncContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): PatientSyncContentDto {
        const json = this.toJSON();
        let result = new PatientSyncContentDto();
        result.init(json);
        return result;
    }
}

export interface IPatientSyncContentDto extends IBaseSyncContentDto {
    patients?: PatientSyncDto[] | undefined;
}

export abstract class BaseSyncDto implements IBaseSyncDto {
    id!: string;
    isDeleted?: boolean;

    constructor(data?: IBaseSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): BaseSyncDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSyncDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): BaseSyncDto {
        throw new Error("The abstract class 'BaseSyncDto' cannot be instantiated.");
    }
}

export interface IBaseSyncDto {
    id: string;
    isDeleted?: boolean;
}

export class PatientSyncDto extends BaseSyncDto implements IPatientSyncDto {
    identifier?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;
    birthYear?: number | undefined;
    tags?: any | undefined;
    registrationDate?: Date | undefined;

    constructor(data?: IPatientSyncDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthYear = _data["birthYear"];
            this.tags = _data["tags"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthYear"] = this.birthYear;
        data["tags"] = this.tags;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): PatientSyncDto {
        const json = this.toJSON();
        let result = new PatientSyncDto();
        result.init(json);
        return result;
    }
}

export interface IPatientSyncDto extends IBaseSyncDto {
    identifier?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;
    birthYear?: number | undefined;
    tags?: any | undefined;
    registrationDate?: Date | undefined;
}

export class InstituteSyncResultDto extends BaseSyncResultDto implements IInstituteSyncResultDto {
    createdInstitutesCount?: number;
    updatedInstitutesCount?: number;
    deletedInstitutesCount?: number;
    patientAssignmentsAddedCount?: number;
    patientAssignmentsRemovedCount?: number;
    userAssignmentsAddedCount?: number;
    userAssignmentsRemovedCount?: number;

    constructor(data?: IInstituteSyncResultDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdInstitutesCount = _data["createdInstitutesCount"];
            this.updatedInstitutesCount = _data["updatedInstitutesCount"];
            this.deletedInstitutesCount = _data["deletedInstitutesCount"];
            this.patientAssignmentsAddedCount = _data["patientAssignmentsAddedCount"];
            this.patientAssignmentsRemovedCount = _data["patientAssignmentsRemovedCount"];
            this.userAssignmentsAddedCount = _data["userAssignmentsAddedCount"];
            this.userAssignmentsRemovedCount = _data["userAssignmentsRemovedCount"];
        }
    }

    static fromJS(data: any): InstituteSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdInstitutesCount"] = this.createdInstitutesCount;
        data["updatedInstitutesCount"] = this.updatedInstitutesCount;
        data["deletedInstitutesCount"] = this.deletedInstitutesCount;
        data["patientAssignmentsAddedCount"] = this.patientAssignmentsAddedCount;
        data["patientAssignmentsRemovedCount"] = this.patientAssignmentsRemovedCount;
        data["userAssignmentsAddedCount"] = this.userAssignmentsAddedCount;
        data["userAssignmentsRemovedCount"] = this.userAssignmentsRemovedCount;
        super.toJSON(data);
        return data;
    }

    clone(): InstituteSyncResultDto {
        const json = this.toJSON();
        let result = new InstituteSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteSyncResultDto extends IBaseSyncResultDto {
    createdInstitutesCount?: number;
    updatedInstitutesCount?: number;
    deletedInstitutesCount?: number;
    patientAssignmentsAddedCount?: number;
    patientAssignmentsRemovedCount?: number;
    userAssignmentsAddedCount?: number;
    userAssignmentsRemovedCount?: number;
}

export class InstituteSyncContentDto extends BaseSyncContentDto implements IInstituteSyncContentDto {
    institutes?: InstituteSyncDto[] | undefined;

    constructor(data?: IInstituteSyncContentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["institutes"])) {
                this.institutes = [] as any;
                for (let item of _data["institutes"])
                    this.institutes!.push(InstituteSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstituteSyncContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteSyncContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.institutes)) {
            data["institutes"] = [];
            for (let item of this.institutes)
                data["institutes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): InstituteSyncContentDto {
        const json = this.toJSON();
        let result = new InstituteSyncContentDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteSyncContentDto extends IBaseSyncContentDto {
    institutes?: InstituteSyncDto[] | undefined;
}

export class InstituteSyncDto extends BaseSyncDto implements IInstituteSyncDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    users?: string[] | undefined;
    patients?: string[] | undefined;

    constructor(data?: IInstituteSyncDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(item);
            }
        }
    }

    static fromJS(data: any): InstituteSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): InstituteSyncDto {
        const json = this.toJSON();
        let result = new InstituteSyncDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteSyncDto extends IBaseSyncDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    users?: string[] | undefined;
    patients?: string[] | undefined;
}

export class UserSyncResultDto extends BaseSyncResultDto implements IUserSyncResultDto {
    createdUserCount?: number;
    updatedUserCount?: number;
    deletedUserCount?: number;

    constructor(data?: IUserSyncResultDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdUserCount = _data["createdUserCount"];
            this.updatedUserCount = _data["updatedUserCount"];
            this.deletedUserCount = _data["deletedUserCount"];
        }
    }

    static fromJS(data: any): UserSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdUserCount"] = this.createdUserCount;
        data["updatedUserCount"] = this.updatedUserCount;
        data["deletedUserCount"] = this.deletedUserCount;
        super.toJSON(data);
        return data;
    }

    clone(): UserSyncResultDto {
        const json = this.toJSON();
        let result = new UserSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserSyncResultDto extends IBaseSyncResultDto {
    createdUserCount?: number;
    updatedUserCount?: number;
    deletedUserCount?: number;
}

export class UserSyncContentDto extends BaseSyncContentDto implements IUserSyncContentDto {
    users?: UserSyncDto[] | undefined;

    constructor(data?: IUserSyncContentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSyncContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSyncContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): UserSyncContentDto {
        const json = this.toJSON();
        let result = new UserSyncContentDto();
        result.init(json);
        return result;
    }
}

export interface IUserSyncContentDto extends IBaseSyncContentDto {
    users?: UserSyncDto[] | undefined;
}

export class UserSyncDto extends BaseSyncDto implements IUserSyncDto {
    userName?: string | undefined;
    displayName?: string | undefined;
    passwordHash?: string | undefined;
    passwordChangeDate?: Date | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    isDeactivated?: boolean;
    roleIdentifier?: string | undefined;
    personData?: PersonDataSyncDto | undefined;
    tags?: any | undefined;

    constructor(data?: IUserSyncDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.displayName = _data["displayName"];
            this.passwordHash = _data["passwordHash"];
            this.passwordChangeDate = _data["passwordChangeDate"] ? new Date(_data["passwordChangeDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.isDeactivated = _data["isDeactivated"];
            this.roleIdentifier = _data["roleIdentifier"];
            this.personData = _data["personData"] ? PersonDataSyncDto.fromJS(_data["personData"]) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): UserSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["displayName"] = this.displayName;
        data["passwordHash"] = this.passwordHash;
        data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["isDeactivated"] = this.isDeactivated;
        data["roleIdentifier"] = this.roleIdentifier;
        data["personData"] = this.personData ? this.personData.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): UserSyncDto {
        const json = this.toJSON();
        let result = new UserSyncDto();
        result.init(json);
        return result;
    }
}

export interface IUserSyncDto extends IBaseSyncDto {
    userName?: string | undefined;
    displayName?: string | undefined;
    passwordHash?: string | undefined;
    passwordChangeDate?: Date | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    isDeactivated?: boolean;
    roleIdentifier?: string | undefined;
    personData?: PersonDataSyncDto | undefined;
    tags?: any | undefined;
}

export class PersonDataSyncDto extends BaseSyncDto implements IPersonDataSyncDto {
    title?: string | undefined;
    giveName?: string | undefined;
    familyName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IPersonDataSyncDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.giveName = _data["giveName"];
            this.familyName = _data["familyName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): PersonDataSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDataSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["giveName"] = this.giveName;
        data["familyName"] = this.familyName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        super.toJSON(data);
        return data;
    }

    clone(): PersonDataSyncDto {
        const json = this.toJSON();
        let result = new PersonDataSyncDto();
        result.init(json);
        return result;
    }
}

export interface IPersonDataSyncDto extends IBaseSyncDto {
    title?: string | undefined;
    giveName?: string | undefined;
    familyName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
}

export class UserDto extends ShortUserDto implements IUserDto {
    passwordChangeDate?: Date | undefined;
    emailConfirmed?: boolean;
    noLogin?: boolean;

    constructor(data?: IUserDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.passwordChangeDate = _data["passwordChangeDate"] ? new Date(_data["passwordChangeDate"].toString()) : <any>undefined;
            this.emailConfirmed = _data["emailConfirmed"];
            this.noLogin = _data["noLogin"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
        data["emailConfirmed"] = this.emailConfirmed;
        data["noLogin"] = this.noLogin;
        super.toJSON(data);
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto extends IShortUserDto {
    passwordChangeDate?: Date | undefined;
    emailConfirmed?: boolean;
    noLogin?: boolean;
}

export class UserCompleteDto extends ShortUserDto implements IUserCompleteDto {
    passwordChangeDate?: Date | undefined;
    emailConfirmed?: boolean;
    noLogin?: boolean;
    personData?: PersonDataDto | undefined;

    constructor(data?: IUserCompleteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.passwordChangeDate = _data["passwordChangeDate"] ? new Date(_data["passwordChangeDate"].toString()) : <any>undefined;
            this.emailConfirmed = _data["emailConfirmed"];
            this.noLogin = _data["noLogin"];
            this.personData = _data["personData"] ? PersonDataDto.fromJS(_data["personData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
        data["emailConfirmed"] = this.emailConfirmed;
        data["noLogin"] = this.noLogin;
        data["personData"] = this.personData ? this.personData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): UserCompleteDto {
        const json = this.toJSON();
        let result = new UserCompleteDto();
        result.init(json);
        return result;
    }
}

export interface IUserCompleteDto extends IShortUserDto {
    passwordChangeDate?: Date | undefined;
    emailConfirmed?: boolean;
    noLogin?: boolean;
    personData?: PersonDataDto | undefined;
}

export class PersonDataDto extends BaseDto implements IPersonDataDto {
    title?: string | undefined;
    giveName?: string | undefined;
    familyName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IPersonDataDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.giveName = _data["giveName"];
            this.familyName = _data["familyName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): PersonDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["giveName"] = this.giveName;
        data["familyName"] = this.familyName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        super.toJSON(data);
        return data;
    }

    clone(): PersonDataDto {
        const json = this.toJSON();
        let result = new PersonDataDto();
        result.init(json);
        return result;
    }
}

export interface IPersonDataDto extends IBaseDto {
    title?: string | undefined;
    giveName?: string | undefined;
    familyName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
}

export class UserCreateDto implements IUserCreateDto {
    id?: string | undefined;
    userName!: string;
    displayName!: string;
    email!: string;
    emailConfirmed?: boolean;
    roleId!: string;
    isDeleted?: boolean;
    passwordString!: string;
    noLogin?: boolean;
    personData?: PersonDataDto | undefined;
    tags?: any | undefined;

    constructor(data?: IUserCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.roleId = _data["roleId"];
            this.isDeleted = _data["isDeleted"];
            this.passwordString = _data["passwordString"];
            this.noLogin = _data["noLogin"];
            this.personData = _data["personData"] ? PersonDataDto.fromJS(_data["personData"]) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): UserCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["roleId"] = this.roleId;
        data["isDeleted"] = this.isDeleted;
        data["passwordString"] = this.passwordString;
        data["noLogin"] = this.noLogin;
        data["personData"] = this.personData ? this.personData.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        return data;
    }

    clone(): UserCreateDto {
        const json = this.toJSON();
        let result = new UserCreateDto();
        result.init(json);
        return result;
    }
}

export interface IUserCreateDto {
    id?: string | undefined;
    userName: string;
    displayName: string;
    email: string;
    emailConfirmed?: boolean;
    roleId: string;
    isDeleted?: boolean;
    passwordString: string;
    noLogin?: boolean;
    personData?: PersonDataDto | undefined;
    tags?: any | undefined;
}

export class UserUpdateDto extends BaseIdDto implements IUserUpdateDto {
    userName!: string;
    displayName!: string;
    email!: string;
    emailConfirmed?: boolean;
    roleId!: string;
    isDeleted?: boolean;
    noLogin?: boolean;
    personData?: PersonDataDto | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    tags?: any | undefined;

    constructor(data?: IUserUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.roleId = _data["roleId"];
            this.isDeleted = _data["isDeleted"];
            this.noLogin = _data["noLogin"];
            this.personData = _data["personData"] ? PersonDataDto.fromJS(_data["personData"]) : <any>undefined;
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): UserUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["roleId"] = this.roleId;
        data["isDeleted"] = this.isDeleted;
        data["noLogin"] = this.noLogin;
        data["personData"] = this.personData ? this.personData.toJSON() : <any>undefined;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): UserUpdateDto {
        const json = this.toJSON();
        let result = new UserUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IUserUpdateDto extends IBaseIdDto {
    userName: string;
    displayName: string;
    email: string;
    emailConfirmed?: boolean;
    roleId: string;
    isDeleted?: boolean;
    noLogin?: boolean;
    personData?: PersonDataDto | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
    tags?: any | undefined;
}

export class UserPasswordChangeDto extends BaseIdDto implements IUserPasswordChangeDto {
    newPasswordString!: string;

    constructor(data?: IUserPasswordChangeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newPasswordString = _data["newPasswordString"];
        }
    }

    static fromJS(data: any): UserPasswordChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPasswordString"] = this.newPasswordString;
        super.toJSON(data);
        return data;
    }

    clone(): UserPasswordChangeDto {
        const json = this.toJSON();
        let result = new UserPasswordChangeDto();
        result.init(json);
        return result;
    }
}

export interface IUserPasswordChangeDto extends IBaseIdDto {
    newPasswordString: string;
}

export class UserPasswordChangeForCurrentUserDto extends UserPasswordChangeDto implements IUserPasswordChangeForCurrentUserDto {
    oldPasswordString!: string;

    constructor(data?: IUserPasswordChangeForCurrentUserDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldPasswordString = _data["oldPasswordString"];
        }
    }

    static fromJS(data: any): UserPasswordChangeForCurrentUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordChangeForCurrentUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPasswordString"] = this.oldPasswordString;
        super.toJSON(data);
        return data;
    }

    clone(): UserPasswordChangeForCurrentUserDto {
        const json = this.toJSON();
        let result = new UserPasswordChangeForCurrentUserDto();
        result.init(json);
        return result;
    }
}

export interface IUserPasswordChangeForCurrentUserDto extends IUserPasswordChangeDto {
    oldPasswordString: string;
}

export class UserPasswordResetResultDto implements IUserPasswordResetResultDto {
    user?: UserDto | undefined;
    passwortResetSuccessful?: boolean;
    reasonForFailure?: string | undefined;

    constructor(data?: IUserPasswordResetResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.passwortResetSuccessful = _data["passwortResetSuccessful"];
            this.reasonForFailure = _data["reasonForFailure"];
        }
    }

    static fromJS(data: any): UserPasswordResetResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordResetResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["passwortResetSuccessful"] = this.passwortResetSuccessful;
        data["reasonForFailure"] = this.reasonForFailure;
        return data;
    }

    clone(): UserPasswordResetResultDto {
        const json = this.toJSON();
        let result = new UserPasswordResetResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserPasswordResetResultDto {
    user?: UserDto | undefined;
    passwortResetSuccessful?: boolean;
    reasonForFailure?: string | undefined;
}

export class UserPasswordResetDto extends BaseIdDto implements IUserPasswordResetDto {
    newPasswordString!: string;

    constructor(data?: IUserPasswordResetDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newPasswordString = _data["newPasswordString"];
        }
    }

    static fromJS(data: any): UserPasswordResetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordResetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPasswordString"] = this.newPasswordString;
        super.toJSON(data);
        return data;
    }

    clone(): UserPasswordResetDto {
        const json = this.toJSON();
        let result = new UserPasswordResetDto();
        result.init(json);
        return result;
    }
}

export interface IUserPasswordResetDto extends IBaseIdDto {
    newPasswordString: string;
}

export class PasswordDto implements IPasswordDto {
    passwordString!: string;

    constructor(data?: IPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordString = _data["passwordString"];
        }
    }

    static fromJS(data: any): PasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordString"] = this.passwordString;
        return data;
    }

    clone(): PasswordDto {
        const json = this.toJSON();
        let result = new PasswordDto();
        result.init(json);
        return result;
    }
}

export interface IPasswordDto {
    passwordString: string;
}

export class AssembliesDto implements IAssembliesDto {
    assemblies?: AssemblyEntry[] | undefined;

    constructor(data?: IAssembliesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assemblies"])) {
                this.assemblies = [] as any;
                for (let item of _data["assemblies"])
                    this.assemblies!.push(AssemblyEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssembliesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssembliesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assemblies)) {
            data["assemblies"] = [];
            for (let item of this.assemblies)
                data["assemblies"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssembliesDto {
        const json = this.toJSON();
        let result = new AssembliesDto();
        result.init(json);
        return result;
    }
}

export interface IAssembliesDto {
    assemblies?: AssemblyEntry[] | undefined;
}

export class AssemblyEntry implements IAssemblyEntry {
    name?: string | undefined;
    version?: string | undefined;
    location?: string | undefined;

    constructor(data?: IAssemblyEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.version = _data["version"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): AssemblyEntry {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["version"] = this.version;
        data["location"] = this.location;
        return data;
    }

    clone(): AssemblyEntry {
        const json = this.toJSON();
        let result = new AssemblyEntry();
        result.init(json);
        return result;
    }
}

export interface IAssemblyEntry {
    name?: string | undefined;
    version?: string | undefined;
    location?: string | undefined;
}

export class VisitDateDto implements IVisitDateDto {
    identifier?: string | undefined;
    visitDate?: Date | undefined;

    constructor(data?: IVisitDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.visitDate = _data["visitDate"] ? new Date(_data["visitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VisitDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): VisitDateDto {
        const json = this.toJSON();
        let result = new VisitDateDto();
        result.init(json);
        return result;
    }
}

export interface IVisitDateDto {
    identifier?: string | undefined;
    visitDate?: Date | undefined;
}

export class BaselineDateDto implements IBaselineDateDto {
    patientId?: string;
    baselineDate?: Date;

    constructor(data?: IBaselineDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.baselineDate = _data["baselineDate"] ? new Date(_data["baselineDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaselineDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaselineDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["baselineDate"] = this.baselineDate ? this.baselineDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): BaselineDateDto {
        const json = this.toJSON();
        let result = new BaselineDateDto();
        result.init(json);
        return result;
    }
}

export interface IBaselineDateDto {
    patientId?: string;
    baselineDate?: Date;
}

export class VisitTimelineDto implements IVisitTimelineDto {
    patientIdentifier?: string | undefined;
    baseLineVisitDate?: Date | undefined;
    visitRules?: VisitRulesDto[] | undefined;

    constructor(data?: IVisitTimelineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientIdentifier = _data["patientIdentifier"];
            this.baseLineVisitDate = _data["baseLineVisitDate"] ? new Date(_data["baseLineVisitDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["visitRules"])) {
                this.visitRules = [] as any;
                for (let item of _data["visitRules"])
                    this.visitRules!.push(VisitRulesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisitTimelineDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitTimelineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientIdentifier"] = this.patientIdentifier;
        data["baseLineVisitDate"] = this.baseLineVisitDate ? this.baseLineVisitDate.toISOString() : <any>undefined;
        if (Array.isArray(this.visitRules)) {
            data["visitRules"] = [];
            for (let item of this.visitRules)
                data["visitRules"].push(item.toJSON());
        }
        return data;
    }

    clone(): VisitTimelineDto {
        const json = this.toJSON();
        let result = new VisitTimelineDto();
        result.init(json);
        return result;
    }
}

export interface IVisitTimelineDto {
    patientIdentifier?: string | undefined;
    baseLineVisitDate?: Date | undefined;
    visitRules?: VisitRulesDto[] | undefined;
}

export class VisitRulesDto implements IVisitRulesDto {
    visitIdentifier?: string | undefined;
    beforeDays?: number | undefined;
    beforeMonths?: number | undefined;
    afterDays?: number | undefined;
    afterMonths?: number | undefined;

    constructor(data?: IVisitRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitIdentifier = _data["visitIdentifier"];
            this.beforeDays = _data["beforeDays"];
            this.beforeMonths = _data["beforeMonths"];
            this.afterDays = _data["afterDays"];
            this.afterMonths = _data["afterMonths"];
        }
    }

    static fromJS(data: any): VisitRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitIdentifier"] = this.visitIdentifier;
        data["beforeDays"] = this.beforeDays;
        data["beforeMonths"] = this.beforeMonths;
        data["afterDays"] = this.afterDays;
        data["afterMonths"] = this.afterMonths;
        return data;
    }

    clone(): VisitRulesDto {
        const json = this.toJSON();
        let result = new VisitRulesDto();
        result.init(json);
        return result;
    }
}

export interface IVisitRulesDto {
    visitIdentifier?: string | undefined;
    beforeDays?: number | undefined;
    beforeMonths?: number | undefined;
    afterDays?: number | undefined;
    afterMonths?: number | undefined;
}

export class NtdInstituteShortDto implements INtdInstituteShortDto {
    id?: string;
    studyInstituteId?: string;
    isNtdInstitute?: boolean;

    constructor(data?: INtdInstituteShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyInstituteId = _data["studyInstituteId"];
            this.isNtdInstitute = _data["isNtdInstitute"];
        }
    }

    static fromJS(data: any): NtdInstituteShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdInstituteShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyInstituteId"] = this.studyInstituteId;
        data["isNtdInstitute"] = this.isNtdInstitute;
        return data;
    }

    clone(): NtdInstituteShortDto {
        const json = this.toJSON();
        let result = new NtdInstituteShortDto();
        result.init(json);
        return result;
    }
}

export interface INtdInstituteShortDto {
    id?: string;
    studyInstituteId?: string;
    isNtdInstitute?: boolean;
}

export class NtdInstituteDto extends NtdInstituteShortDto implements INtdInstituteDto {
    studyInstitute?: StudyInstituteShortDto | undefined;

    constructor(data?: INtdInstituteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyInstitute = _data["studyInstitute"] ? StudyInstituteShortDto.fromJS(_data["studyInstitute"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NtdInstituteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdInstituteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyInstitute"] = this.studyInstitute ? this.studyInstitute.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): NtdInstituteDto {
        const json = this.toJSON();
        let result = new NtdInstituteDto();
        result.init(json);
        return result;
    }
}

export interface INtdInstituteDto extends INtdInstituteShortDto {
    studyInstitute?: StudyInstituteShortDto | undefined;
}

export class StudyInstituteShortDto extends BaseDto implements IStudyInstituteShortDto {
    instituteId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    locked?: boolean;
    investigatorName?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    eMail?: string | undefined;
    additionalInfo?: any | undefined;

    constructor(data?: IStudyInstituteShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instituteId = _data["instituteId"];
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.maxPatientsCount = _data["maxPatientsCount"];
            this.locked = _data["locked"];
            this.investigatorName = _data["investigatorName"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.eMail = _data["eMail"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): StudyInstituteShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyInstituteShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instituteId"] = this.instituteId;
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["maxPatientsCount"] = this.maxPatientsCount;
        data["locked"] = this.locked;
        data["investigatorName"] = this.investigatorName;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["eMail"] = this.eMail;
        data["additionalInfo"] = this.additionalInfo;
        super.toJSON(data);
        return data;
    }

    clone(): StudyInstituteShortDto {
        const json = this.toJSON();
        let result = new StudyInstituteShortDto();
        result.init(json);
        return result;
    }
}

export interface IStudyInstituteShortDto extends IBaseDto {
    instituteId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    locked?: boolean;
    investigatorName?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    eMail?: string | undefined;
    additionalInfo?: any | undefined;
}

export class NtdInstituteCreateDto implements INtdInstituteCreateDto {
    studyInstituteId?: string;

    constructor(data?: INtdInstituteCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyInstituteId = _data["studyInstituteId"];
        }
    }

    static fromJS(data: any): NtdInstituteCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdInstituteCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyInstituteId"] = this.studyInstituteId;
        return data;
    }

    clone(): NtdInstituteCreateDto {
        const json = this.toJSON();
        let result = new NtdInstituteCreateDto();
        result.init(json);
        return result;
    }
}

export interface INtdInstituteCreateDto {
    studyInstituteId?: string;
}

export class NtdInstituteUpdateDto extends NtdInstituteShortDto implements INtdInstituteUpdateDto {

    constructor(data?: INtdInstituteUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): NtdInstituteUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdInstituteUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): NtdInstituteUpdateDto {
        const json = this.toJSON();
        let result = new NtdInstituteUpdateDto();
        result.init(json);
        return result;
    }
}

export interface INtdInstituteUpdateDto extends INtdInstituteShortDto {
}

export class NtdInstituteDeleteDto extends NtdInstituteShortDto implements INtdInstituteDeleteDto {

    constructor(data?: INtdInstituteDeleteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): NtdInstituteDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdInstituteDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): NtdInstituteDeleteDto {
        const json = this.toJSON();
        let result = new NtdInstituteDeleteDto();
        result.init(json);
        return result;
    }
}

export interface INtdInstituteDeleteDto extends INtdInstituteShortDto {
}

export class NtdPatientPuidDto implements INtdPatientPuidDto {
    puid?: string;

    constructor(data?: INtdPatientPuidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.puid = _data["puid"];
        }
    }

    static fromJS(data: any): NtdPatientPuidDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdPatientPuidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["puid"] = this.puid;
        return data;
    }

    clone(): NtdPatientPuidDto {
        const json = this.toJSON();
        let result = new NtdPatientPuidDto();
        result.init(json);
        return result;
    }
}

export interface INtdPatientPuidDto {
    puid?: string;
}

export class NtdStatusResponseDto implements INtdStatusResponseDto {
    message?: string | undefined;
    ts?: Date;

    constructor(data?: INtdStatusResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.ts = _data["ts"] ? new Date(_data["ts"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NtdStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        return data;
    }

    clone(): NtdStatusResponseDto {
        const json = this.toJSON();
        let result = new NtdStatusResponseDto();
        result.init(json);
        return result;
    }
}

export interface INtdStatusResponseDto {
    message?: string | undefined;
    ts?: Date;
}

export class NtdUserCreateDto implements INtdUserCreateDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    siteId?: string | undefined;
    email?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: INtdUserCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.siteId = _data["siteId"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): NtdUserCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdUserCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["siteId"] = this.siteId;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }

    clone(): NtdUserCreateDto {
        const json = this.toJSON();
        let result = new NtdUserCreateDto();
        result.init(json);
        return result;
    }
}

export interface INtdUserCreateDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    siteId?: string | undefined;
    email?: string | undefined;
    roles?: string[] | undefined;
}

export class NtdPatientDto implements INtdPatientDto {
    puid?: string;
    gender?: string | undefined;
    bornOn?: string | undefined;
    initials?: string | undefined;

    constructor(data?: INtdPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.puid = _data["puid"];
            this.gender = _data["gender"];
            this.bornOn = _data["bornOn"];
            this.initials = _data["initials"];
        }
    }

    static fromJS(data: any): NtdPatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdPatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["puid"] = this.puid;
        data["gender"] = this.gender;
        data["bornOn"] = this.bornOn;
        data["initials"] = this.initials;
        return data;
    }

    clone(): NtdPatientDto {
        const json = this.toJSON();
        let result = new NtdPatientDto();
        result.init(json);
        return result;
    }
}

export interface INtdPatientDto {
    puid?: string;
    gender?: string | undefined;
    bornOn?: string | undefined;
    initials?: string | undefined;
}

export class NtdUserDto implements INtdUserDto {
    id?: string;
    user?: ShortUserDto | undefined;

    constructor(data?: INtdUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? ShortUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NtdUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new NtdUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): NtdUserDto {
        const json = this.toJSON();
        let result = new NtdUserDto();
        result.init(json);
        return result;
    }
}

export interface INtdUserDto {
    id?: string;
    user?: ShortUserDto | undefined;
}

export class ConstraintDefinitionShortDto extends BaseDto implements IConstraintDefinitionShortDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;

    constructor(data?: IConstraintDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.definitionType = _data["definitionType"];
        }
    }

    static fromJS(data: any): ConstraintDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstraintDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["definitionType"] = this.definitionType;
        super.toJSON(data);
        return data;
    }

    clone(): ConstraintDefinitionShortDto {
        const json = this.toJSON();
        let result = new ConstraintDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IConstraintDefinitionShortDto extends IBaseDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;
}

export class ConstraintDefinitionDto extends BaseDto implements IConstraintDefinitionDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IConstraintDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ConstraintDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstraintDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): ConstraintDefinitionDto {
        const json = this.toJSON();
        let result = new ConstraintDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IConstraintDefinitionDto extends IBaseDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class ConstraintDefinitionCreateDto implements IConstraintDefinitionCreateDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IConstraintDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ConstraintDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstraintDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        return data;
    }

    clone(): ConstraintDefinitionCreateDto {
        const json = this.toJSON();
        let result = new ConstraintDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IConstraintDefinitionCreateDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class ConstraintDefinitionUpdateDto extends BaseIdDto implements IConstraintDefinitionUpdateDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IConstraintDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ConstraintDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstraintDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): ConstraintDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new ConstraintDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IConstraintDefinitionUpdateDto extends IBaseIdDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class DataFieldDefinitionShortDto extends BaseDto implements IDataFieldDefinitionShortDto {
    referenceType?: string | undefined;
    referenceId?: string;
    parentFieldDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;

    constructor(data?: IDataFieldDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.parentFieldDefinitionId = _data["parentFieldDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
        }
    }

    static fromJS(data: any): DataFieldDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["parentFieldDefinitionId"] = this.parentFieldDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        super.toJSON(data);
        return data;
    }

    clone(): DataFieldDefinitionShortDto {
        const json = this.toJSON();
        let result = new DataFieldDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldDefinitionShortDto extends IBaseDto {
    referenceType?: string | undefined;
    referenceId?: string;
    parentFieldDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
}

export class DataFieldDefinitionDto extends BaseDto implements IDataFieldDefinitionDto {
    referenceType?: string | undefined;
    referenceId?: string;
    parentFieldDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IDataFieldDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.parentFieldDefinitionId = _data["parentFieldDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionDto.fromJS(item));
            }
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): DataFieldDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["parentFieldDefinitionId"] = this.parentFieldDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): DataFieldDefinitionDto {
        const json = this.toJSON();
        let result = new DataFieldDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldDefinitionDto extends IBaseDto {
    referenceType?: string | undefined;
    referenceId?: string;
    parentFieldDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class RuleDefinitionDto extends BaseDto implements IRuleDefinitionDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    constraintExpression?: ConstraintExpression | undefined;
    order?: number;

    constructor(data?: IRuleDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            this.constraintExpression = _data["constraintExpression"] ? ConstraintExpression.fromJS(_data["constraintExpression"]) : <any>undefined;
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): RuleDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        data["constraintExpression"] = this.constraintExpression ? this.constraintExpression.toJSON() : <any>undefined;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): RuleDefinitionDto {
        const json = this.toJSON();
        let result = new RuleDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IRuleDefinitionDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    constraintExpression?: ConstraintExpression | undefined;
    order?: number;
}

export class ConstraintExpression implements IConstraintExpression {
    operator?: ConstrainOperator;
    constraintDefinitionId?: string | undefined;
    expressions?: ConstraintExpression[] | undefined;

    constructor(data?: IConstraintExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.constraintDefinitionId = _data["constraintDefinitionId"];
            if (Array.isArray(_data["expressions"])) {
                this.expressions = [] as any;
                for (let item of _data["expressions"])
                    this.expressions!.push(ConstraintExpression.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstraintExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ConstraintExpression();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["constraintDefinitionId"] = this.constraintDefinitionId;
        if (Array.isArray(this.expressions)) {
            data["expressions"] = [];
            for (let item of this.expressions)
                data["expressions"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstraintExpression {
        const json = this.toJSON();
        let result = new ConstraintExpression();
        result.init(json);
        return result;
    }
}

export interface IConstraintExpression {
    operator?: ConstrainOperator;
    constraintDefinitionId?: string | undefined;
    expressions?: ConstraintExpression[] | undefined;
}

export enum ConstrainOperator {
    AND = "AND",
    OR = "OR",
    NOT = "NOT",
    EVAL = "EVAL",
}

export class DataFieldDefinitionCreateDto implements IDataFieldDefinitionCreateDto {
    referenceType?: string | undefined;
    referenceId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    rules?: RuleDefinitionCreateDto[] | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IDataFieldDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionCreateDto.fromJS(item));
            }
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): DataFieldDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        return data;
    }

    clone(): DataFieldDefinitionCreateDto {
        const json = this.toJSON();
        let result = new DataFieldDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldDefinitionCreateDto {
    referenceType?: string | undefined;
    referenceId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    rules?: RuleDefinitionCreateDto[] | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class RuleDefinitionCreateDto implements IRuleDefinitionCreateDto {
    identifier!: string;
    displayKey!: string;
    referenceType!: string;
    referenceId!: string;
    studyDefinitionId!: string;
    definitionType!: string;
    definition?: any | undefined;
    constraintExpression?: ConstraintExpression | undefined;
    order?: number;

    constructor(data?: IRuleDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            this.constraintExpression = _data["constraintExpression"] ? ConstraintExpression.fromJS(_data["constraintExpression"]) : <any>undefined;
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): RuleDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        data["constraintExpression"] = this.constraintExpression ? this.constraintExpression.toJSON() : <any>undefined;
        data["order"] = this.order;
        return data;
    }

    clone(): RuleDefinitionCreateDto {
        const json = this.toJSON();
        let result = new RuleDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IRuleDefinitionCreateDto {
    identifier: string;
    displayKey: string;
    referenceType: string;
    referenceId: string;
    studyDefinitionId: string;
    definitionType: string;
    definition?: any | undefined;
    constraintExpression?: ConstraintExpression | undefined;
    order?: number;
}

export class DataFieldDefinitionUpdateDto extends BaseIdDto implements IDataFieldDefinitionUpdateDto {
    referenceType?: string | undefined;
    referenceId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IDataFieldDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionDto.fromJS(item));
            }
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): DataFieldDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): DataFieldDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new DataFieldDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldDefinitionUpdateDto extends IBaseIdDto {
    referenceType?: string | undefined;
    referenceId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class DataQualityCheckDto implements IDataQualityCheckDto {
    identifier?: string | undefined;
    description?: string | undefined;

    constructor(data?: IDataQualityCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DataQualityCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataQualityCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["description"] = this.description;
        return data;
    }

    clone(): DataQualityCheckDto {
        const json = this.toJSON();
        let result = new DataQualityCheckDto();
        result.init(json);
        return result;
    }
}

export interface IDataQualityCheckDto {
    identifier?: string | undefined;
    description?: string | undefined;
}

export class AuditValueChangeDto implements IAuditValueChangeDto {
    auditEventId?: number;
    auditChangeId?: number;
    user?: AuditUserDto | undefined;
    timeStamp?: Date;
    eventName?: string | undefined;
    action?: string | undefined;
    objectId?: string | undefined;
    objectName?: string | undefined;
    valuePath?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    reasonsOfChange?: AuditReasonOfChangeDto2[] | undefined;

    constructor(data?: IAuditValueChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditEventId = _data["auditEventId"];
            this.auditChangeId = _data["auditChangeId"];
            this.user = _data["user"] ? AuditUserDto.fromJS(_data["user"]) : <any>undefined;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.eventName = _data["eventName"];
            this.action = _data["action"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
            this.valuePath = _data["valuePath"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            if (Array.isArray(_data["reasonsOfChange"])) {
                this.reasonsOfChange = [] as any;
                for (let item of _data["reasonsOfChange"])
                    this.reasonsOfChange!.push(AuditReasonOfChangeDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditValueChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditValueChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditEventId"] = this.auditEventId;
        data["auditChangeId"] = this.auditChangeId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["eventName"] = this.eventName;
        data["action"] = this.action;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        data["valuePath"] = this.valuePath;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        if (Array.isArray(this.reasonsOfChange)) {
            data["reasonsOfChange"] = [];
            for (let item of this.reasonsOfChange)
                data["reasonsOfChange"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditValueChangeDto {
        const json = this.toJSON();
        let result = new AuditValueChangeDto();
        result.init(json);
        return result;
    }
}

export interface IAuditValueChangeDto {
    auditEventId?: number;
    auditChangeId?: number;
    user?: AuditUserDto | undefined;
    timeStamp?: Date;
    eventName?: string | undefined;
    action?: string | undefined;
    objectId?: string | undefined;
    objectName?: string | undefined;
    valuePath?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    reasonsOfChange?: AuditReasonOfChangeDto2[] | undefined;
}

export class AuditUserDto implements IAuditUserDto {
    id?: string;
    userName?: string | undefined;
    userDisplayName?: string | undefined;
    roleIdentifier?: string | undefined;
    roleDisplayName?: string | undefined;

    constructor(data?: IAuditUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.userDisplayName = _data["userDisplayName"];
            this.roleIdentifier = _data["roleIdentifier"];
            this.roleDisplayName = _data["roleDisplayName"];
        }
    }

    static fromJS(data: any): AuditUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["userDisplayName"] = this.userDisplayName;
        data["roleIdentifier"] = this.roleIdentifier;
        data["roleDisplayName"] = this.roleDisplayName;
        return data;
    }

    clone(): AuditUserDto {
        const json = this.toJSON();
        let result = new AuditUserDto();
        result.init(json);
        return result;
    }
}

export interface IAuditUserDto {
    id?: string;
    userName?: string | undefined;
    userDisplayName?: string | undefined;
    roleIdentifier?: string | undefined;
    roleDisplayName?: string | undefined;
}

export class AuditReasonOfChangeDto2 implements IAuditReasonOfChangeDto2 {
    level?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IAuditReasonOfChangeDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AuditReasonOfChangeDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AuditReasonOfChangeDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["reason"] = this.reason;
        return data;
    }

    clone(): AuditReasonOfChangeDto2 {
        const json = this.toJSON();
        let result = new AuditReasonOfChangeDto2();
        result.init(json);
        return result;
    }
}

export interface IAuditReasonOfChangeDto2 {
    level?: string | undefined;
    reason?: string | undefined;
}

export class ELearningDefinitionResponseDto extends BaseDto implements IELearningDefinitionResponseDto {
    definition?: any | undefined;

    constructor(data?: IELearningDefinitionResponseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ELearningDefinitionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ELearningDefinitionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): ELearningDefinitionResponseDto {
        const json = this.toJSON();
        let result = new ELearningDefinitionResponseDto();
        result.init(json);
        return result;
    }
}

export interface IELearningDefinitionResponseDto extends IBaseDto {
    definition?: any | undefined;
}

export class ELearningDefinitionCreateDto implements IELearningDefinitionCreateDto {
    studyDefinitionId?: string;
    definition?: any | undefined;

    constructor(data?: IELearningDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ELearningDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ELearningDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definition"] = this.definition;
        return data;
    }

    clone(): ELearningDefinitionCreateDto {
        const json = this.toJSON();
        let result = new ELearningDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IELearningDefinitionCreateDto {
    studyDefinitionId?: string;
    definition?: any | undefined;
}

export class ELearningDefinitionUpdateDto implements IELearningDefinitionUpdateDto {
    definition?: any | undefined;

    constructor(data?: IELearningDefinitionUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ELearningDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ELearningDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definition"] = this.definition;
        return data;
    }

    clone(): ELearningDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new ELearningDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IELearningDefinitionUpdateDto {
    definition?: any | undefined;
}

export class ELearningResultResponseDto extends BaseDto implements IELearningResultResponseDto {
    result?: any | undefined;
    passed?: boolean;
    eLearningDefinitionId?: string;
    userId?: string;

    constructor(data?: IELearningResultResponseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"];
            this.passed = _data["passed"];
            this.eLearningDefinitionId = _data["eLearningDefinitionId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ELearningResultResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ELearningResultResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["passed"] = this.passed;
        data["eLearningDefinitionId"] = this.eLearningDefinitionId;
        data["userId"] = this.userId;
        super.toJSON(data);
        return data;
    }

    clone(): ELearningResultResponseDto {
        const json = this.toJSON();
        let result = new ELearningResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface IELearningResultResponseDto extends IBaseDto {
    result?: any | undefined;
    passed?: boolean;
    eLearningDefinitionId?: string;
    userId?: string;
}

export class ELearningRequireResponseDto implements IELearningRequireResponseDto {
    require?: boolean;
    userId?: string;

    constructor(data?: IELearningRequireResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.require = _data["require"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ELearningRequireResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ELearningRequireResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["require"] = this.require;
        data["userId"] = this.userId;
        return data;
    }

    clone(): ELearningRequireResponseDto {
        const json = this.toJSON();
        let result = new ELearningRequireResponseDto();
        result.init(json);
        return result;
    }
}

export interface IELearningRequireResponseDto {
    require?: boolean;
    userId?: string;
}

export class ELearningResultSubmitDto implements IELearningResultSubmitDto {
    eLearningDefinitionId?: string;
    result?: any | undefined;

    constructor(data?: IELearningResultSubmitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eLearningDefinitionId = _data["eLearningDefinitionId"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): ELearningResultSubmitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ELearningResultSubmitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eLearningDefinitionId"] = this.eLearningDefinitionId;
        data["result"] = this.result;
        return data;
    }

    clone(): ELearningResultSubmitDto {
        const json = this.toJSON();
        let result = new ELearningResultSubmitDto();
        result.init(json);
        return result;
    }
}

export interface IELearningResultSubmitDto {
    eLearningDefinitionId?: string;
    result?: any | undefined;
}

export class EnumValueSetShortDto extends BaseDto implements IEnumValueSetShortDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    values?: EnumValueDefinitionDto[] | undefined;
    isObsolete?: boolean;

    constructor(data?: IEnumValueSetShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(EnumValueDefinitionDto.fromJS(item));
            }
            this.isObsolete = _data["isObsolete"];
        }
    }

    static fromJS(data: any): EnumValueSetShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueSetShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["isObsolete"] = this.isObsolete;
        super.toJSON(data);
        return data;
    }

    clone(): EnumValueSetShortDto {
        const json = this.toJSON();
        let result = new EnumValueSetShortDto();
        result.init(json);
        return result;
    }
}

export interface IEnumValueSetShortDto extends IBaseDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    values?: EnumValueDefinitionDto[] | undefined;
    isObsolete?: boolean;
}

export class EnumValueDefinitionDto extends BaseIdDto implements IEnumValueDefinitionDto {
    enumValueSetId?: string;
    code?: string | undefined;
    displayKey?: string | undefined;
    isObsolete?: boolean;
    order?: number;

    constructor(data?: IEnumValueDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumValueSetId = _data["enumValueSetId"];
            this.code = _data["code"];
            this.displayKey = _data["displayKey"];
            this.isObsolete = _data["isObsolete"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): EnumValueDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumValueSetId"] = this.enumValueSetId;
        data["code"] = this.code;
        data["displayKey"] = this.displayKey;
        data["isObsolete"] = this.isObsolete;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): EnumValueDefinitionDto {
        const json = this.toJSON();
        let result = new EnumValueDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IEnumValueDefinitionDto extends IBaseIdDto {
    enumValueSetId?: string;
    code?: string | undefined;
    displayKey?: string | undefined;
    isObsolete?: boolean;
    order?: number;
}

export class EnumValueSetDto extends BaseDto implements IEnumValueSetDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    values?: EnumValueDefinitionDto[] | undefined;
    isObsolete?: boolean;

    constructor(data?: IEnumValueSetDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(EnumValueDefinitionDto.fromJS(item));
            }
            this.isObsolete = _data["isObsolete"];
        }
    }

    static fromJS(data: any): EnumValueSetDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueSetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["isObsolete"] = this.isObsolete;
        super.toJSON(data);
        return data;
    }

    clone(): EnumValueSetDto {
        const json = this.toJSON();
        let result = new EnumValueSetDto();
        result.init(json);
        return result;
    }
}

export interface IEnumValueSetDto extends IBaseDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    values?: EnumValueDefinitionDto[] | undefined;
    isObsolete?: boolean;
}

export class EnumValueSetCreateDto implements IEnumValueSetCreateDto {
    studyDefinitionId!: string;
    identifier!: string;
    displayKey!: string;
    values!: EnumValueDefinitionCreateDto[];
    isObsolete?: boolean;

    constructor(data?: IEnumValueSetCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(EnumValueDefinitionCreateDto.fromJS(item));
            }
            this.isObsolete = _data["isObsolete"];
        }
    }

    static fromJS(data: any): EnumValueSetCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueSetCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["isObsolete"] = this.isObsolete;
        return data;
    }

    clone(): EnumValueSetCreateDto {
        const json = this.toJSON();
        let result = new EnumValueSetCreateDto();
        result.init(json);
        return result;
    }
}

export interface IEnumValueSetCreateDto {
    studyDefinitionId: string;
    identifier: string;
    displayKey: string;
    values: EnumValueDefinitionCreateDto[];
    isObsolete?: boolean;
}

export class EnumValueDefinitionCreateDto implements IEnumValueDefinitionCreateDto {
    code?: string | undefined;
    displayKey?: string | undefined;
    isObsolete?: boolean;

    constructor(data?: IEnumValueDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.displayKey = _data["displayKey"];
            this.isObsolete = _data["isObsolete"];
        }
    }

    static fromJS(data: any): EnumValueDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayKey"] = this.displayKey;
        data["isObsolete"] = this.isObsolete;
        return data;
    }

    clone(): EnumValueDefinitionCreateDto {
        const json = this.toJSON();
        let result = new EnumValueDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IEnumValueDefinitionCreateDto {
    code?: string | undefined;
    displayKey?: string | undefined;
    isObsolete?: boolean;
}

export class EnumValueSetUpdateDto extends BaseIdDto implements IEnumValueSetUpdateDto {
    studyDefinitionId!: string;
    identifier!: string;
    displayKey!: string;
    values!: EnumValueDefinitionDto[];
    isObsolete?: boolean;

    constructor(data?: IEnumValueSetUpdateDto) {
        super(data);
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(EnumValueDefinitionDto.fromJS(item));
            }
            this.isObsolete = _data["isObsolete"];
        }
    }

    static fromJS(data: any): EnumValueSetUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueSetUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["isObsolete"] = this.isObsolete;
        super.toJSON(data);
        return data;
    }

    clone(): EnumValueSetUpdateDto {
        const json = this.toJSON();
        let result = new EnumValueSetUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEnumValueSetUpdateDto extends IBaseIdDto {
    studyDefinitionId: string;
    identifier: string;
    displayKey: string;
    values: EnumValueDefinitionDto[];
    isObsolete?: boolean;
}

export class EventReportSignatureResultDto implements IEventReportSignatureResultDto {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IEventReportSignatureResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): EventReportSignatureResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportSignatureResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }

    clone(): EventReportSignatureResultDto {
        const json = this.toJSON();
        let result = new EventReportSignatureResultDto();
        result.init(json);
        return result;
    }
}

export interface IEventReportSignatureResultDto {
    success?: boolean;
    message?: string | undefined;
}

export class EventReportSignatureDto implements IEventReportSignatureDto {
    reason?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IEventReportSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): EventReportSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }

    clone(): EventReportSignatureDto {
        const json = this.toJSON();
        let result = new EventReportSignatureDto();
        result.init(json);
        return result;
    }
}

export interface IEventReportSignatureDto {
    reason?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class EventReportDeactivationResultDto implements IEventReportDeactivationResultDto {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IEventReportDeactivationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): EventReportDeactivationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportDeactivationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }

    clone(): EventReportDeactivationResultDto {
        const json = this.toJSON();
        let result = new EventReportDeactivationResultDto();
        result.init(json);
        return result;
    }
}

export interface IEventReportDeactivationResultDto {
    success?: boolean;
    message?: string | undefined;
}

export class EventReportDeactivationDto implements IEventReportDeactivationDto {
    reason?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IEventReportDeactivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventReportDeactivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportDeactivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        return data;
    }

    clone(): EventReportDeactivationDto {
        const json = this.toJSON();
        let result = new EventReportDeactivationDto();
        result.init(json);
        return result;
    }
}

export interface IEventReportDeactivationDto {
    reason?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class EventReportFieldDto implements IEventReportFieldDto {
    id?: string;
    referenceType?: string | undefined;
    referenceId?: string;
    parentFieldId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    displayName?: string | undefined;
    values?: any | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;
    order?: number;
    tags?: any | undefined;

    constructor(data?: IEventReportFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.parentFieldId = _data["parentFieldId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.displayName = _data["displayName"];
            this.values = _data["values"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            this.order = _data["order"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): EventReportFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["parentFieldId"] = this.parentFieldId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["displayName"] = this.displayName;
        data["values"] = this.values;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        data["order"] = this.order;
        data["tags"] = this.tags;
        return data;
    }

    clone(): EventReportFieldDto {
        const json = this.toJSON();
        let result = new EventReportFieldDto();
        result.init(json);
        return result;
    }
}

export interface IEventReportFieldDto {
    id?: string;
    referenceType?: string | undefined;
    referenceId?: string;
    parentFieldId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    displayName?: string | undefined;
    values?: any | undefined;
    definitionType?: string | undefined;
    definition?: any | undefined;
    order?: number;
    tags?: any | undefined;
}

export class QueryShortDto extends BaseDto implements IQueryShortDto {
    creationDate?: Date | undefined;
    changeDate?: Date | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    referenceDefinitionId?: string | undefined;
    text?: string | undefined;
    queryTypeId?: string;
    queryTypeDefinitionType?: string | undefined;
    sequenceId?: string | undefined;
    stageState?: string | undefined;
    priorityState?: string | undefined;
    referenceState?: string | undefined;
    lockedState?: string | undefined;
    closedReason?: string | undefined;
    instrumentId?: string;
    instrumentIdentifier?: string | undefined;
    instrumentDisplayKey?: string | undefined;
    visitId?: string;
    visitIdentifier?: string | undefined;
    visitDisplayKey?: string | undefined;
    lastComment?: QueryMessageDto | undefined;

    constructor(data?: IQueryShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.referenceDefinitionId = _data["referenceDefinitionId"];
            this.text = _data["text"];
            this.queryTypeId = _data["queryTypeId"];
            this.queryTypeDefinitionType = _data["queryTypeDefinitionType"];
            this.sequenceId = _data["sequenceId"];
            this.stageState = _data["stageState"];
            this.priorityState = _data["priorityState"];
            this.referenceState = _data["referenceState"];
            this.lockedState = _data["lockedState"];
            this.closedReason = _data["closedReason"];
            this.instrumentId = _data["instrumentId"];
            this.instrumentIdentifier = _data["instrumentIdentifier"];
            this.instrumentDisplayKey = _data["instrumentDisplayKey"];
            this.visitId = _data["visitId"];
            this.visitIdentifier = _data["visitIdentifier"];
            this.visitDisplayKey = _data["visitDisplayKey"];
            this.lastComment = _data["lastComment"] ? QueryMessageDto.fromJS(_data["lastComment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QueryShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["referenceDefinitionId"] = this.referenceDefinitionId;
        data["text"] = this.text;
        data["queryTypeId"] = this.queryTypeId;
        data["queryTypeDefinitionType"] = this.queryTypeDefinitionType;
        data["sequenceId"] = this.sequenceId;
        data["stageState"] = this.stageState;
        data["priorityState"] = this.priorityState;
        data["referenceState"] = this.referenceState;
        data["lockedState"] = this.lockedState;
        data["closedReason"] = this.closedReason;
        data["instrumentId"] = this.instrumentId;
        data["instrumentIdentifier"] = this.instrumentIdentifier;
        data["instrumentDisplayKey"] = this.instrumentDisplayKey;
        data["visitId"] = this.visitId;
        data["visitIdentifier"] = this.visitIdentifier;
        data["visitDisplayKey"] = this.visitDisplayKey;
        data["lastComment"] = this.lastComment ? this.lastComment.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): QueryShortDto {
        const json = this.toJSON();
        let result = new QueryShortDto();
        result.init(json);
        return result;
    }
}

export interface IQueryShortDto extends IBaseDto {
    creationDate?: Date | undefined;
    changeDate?: Date | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    referenceDefinitionId?: string | undefined;
    text?: string | undefined;
    queryTypeId?: string;
    queryTypeDefinitionType?: string | undefined;
    sequenceId?: string | undefined;
    stageState?: string | undefined;
    priorityState?: string | undefined;
    referenceState?: string | undefined;
    lockedState?: string | undefined;
    closedReason?: string | undefined;
    instrumentId?: string;
    instrumentIdentifier?: string | undefined;
    instrumentDisplayKey?: string | undefined;
    visitId?: string;
    visitIdentifier?: string | undefined;
    visitDisplayKey?: string | undefined;
    lastComment?: QueryMessageDto | undefined;
}

export class QueryMessageDto extends BaseDto implements IQueryMessageDto {
    messageType?: string | undefined;
    message?: any | undefined;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    creatingUserUserName?: string | undefined;
    creatingUserDisplayName?: string | undefined;
    creatingUserRoleIdentifier?: string | undefined;
    creatingUserRoleDisplayName?: string | undefined;

    constructor(data?: IQueryMessageDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messageType = _data["messageType"];
            this.message = _data["message"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUserId = _data["creatingUserId"];
            this.creatingUserUserName = _data["creatingUserUserName"];
            this.creatingUserDisplayName = _data["creatingUserDisplayName"];
            this.creatingUserRoleIdentifier = _data["creatingUserRoleIdentifier"];
            this.creatingUserRoleDisplayName = _data["creatingUserRoleDisplayName"];
        }
    }

    static fromJS(data: any): QueryMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["message"] = this.message;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUserId"] = this.creatingUserId;
        data["creatingUserUserName"] = this.creatingUserUserName;
        data["creatingUserDisplayName"] = this.creatingUserDisplayName;
        data["creatingUserRoleIdentifier"] = this.creatingUserRoleIdentifier;
        data["creatingUserRoleDisplayName"] = this.creatingUserRoleDisplayName;
        super.toJSON(data);
        return data;
    }

    clone(): QueryMessageDto {
        const json = this.toJSON();
        let result = new QueryMessageDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMessageDto extends IBaseDto {
    messageType?: string | undefined;
    message?: any | undefined;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    creatingUserUserName?: string | undefined;
    creatingUserDisplayName?: string | undefined;
    creatingUserRoleIdentifier?: string | undefined;
    creatingUserRoleDisplayName?: string | undefined;
}

export class FinalExportRequestDto implements IFinalExportRequestDto {
    studyId?: string;
    languageIdentifier?: string | undefined;
    studyInstitutes?: string[] | undefined;

    constructor(data?: IFinalExportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.languageIdentifier = _data["languageIdentifier"];
            if (Array.isArray(_data["studyInstitutes"])) {
                this.studyInstitutes = [] as any;
                for (let item of _data["studyInstitutes"])
                    this.studyInstitutes!.push(item);
            }
        }
    }

    static fromJS(data: any): FinalExportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinalExportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["languageIdentifier"] = this.languageIdentifier;
        if (Array.isArray(this.studyInstitutes)) {
            data["studyInstitutes"] = [];
            for (let item of this.studyInstitutes)
                data["studyInstitutes"].push(item);
        }
        return data;
    }

    clone(): FinalExportRequestDto {
        const json = this.toJSON();
        let result = new FinalExportRequestDto();
        result.init(json);
        return result;
    }
}

export interface IFinalExportRequestDto {
    studyId?: string;
    languageIdentifier?: string | undefined;
    studyInstitutes?: string[] | undefined;
}

export class HtmlDocumentShortDto extends BaseDto implements IHtmlDocumentShortDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;

    constructor(data?: IHtmlDocumentShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): HtmlDocumentShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlDocumentShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): HtmlDocumentShortDto {
        const json = this.toJSON();
        let result = new HtmlDocumentShortDto();
        result.init(json);
        return result;
    }
}

export interface IHtmlDocumentShortDto extends IBaseDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;
}

export class HtmlDocumentDto extends BaseIdDto implements IHtmlDocumentDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;
    content?: string | undefined;
    tags?: any | undefined;

    constructor(data?: IHtmlDocumentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.order = _data["order"];
            this.content = _data["content"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): HtmlDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["order"] = this.order;
        data["content"] = this.content;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): HtmlDocumentDto {
        const json = this.toJSON();
        let result = new HtmlDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IHtmlDocumentDto extends IBaseIdDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;
    content?: string | undefined;
    tags?: any | undefined;
}

export class HtmlDocumentCreateDto implements IHtmlDocumentCreateDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;
    content?: string | undefined;
    tags?: any | undefined;

    constructor(data?: IHtmlDocumentCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.order = _data["order"];
            this.content = _data["content"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): HtmlDocumentCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlDocumentCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["order"] = this.order;
        data["content"] = this.content;
        data["tags"] = this.tags;
        return data;
    }

    clone(): HtmlDocumentCreateDto {
        const json = this.toJSON();
        let result = new HtmlDocumentCreateDto();
        result.init(json);
        return result;
    }
}

export interface IHtmlDocumentCreateDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;
    content?: string | undefined;
    tags?: any | undefined;
}

export class HtmlDocumentUpdateDto extends BaseIdDto implements IHtmlDocumentUpdateDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;
    content?: string | undefined;
    tags?: any | undefined;

    constructor(data?: IHtmlDocumentUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.order = _data["order"];
            this.content = _data["content"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): HtmlDocumentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlDocumentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["order"] = this.order;
        data["content"] = this.content;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): HtmlDocumentUpdateDto {
        const json = this.toJSON();
        let result = new HtmlDocumentUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IHtmlDocumentUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    title?: string | undefined;
    order?: number;
    content?: string | undefined;
    tags?: any | undefined;
}

export class InstrumentShortDto extends BaseDto implements IInstrumentShortDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    locked?: boolean;

    constructor(data?: IInstrumentShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.visitId = _data["visitId"];
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.locked = _data["locked"];
        }
    }

    static fromJS(data: any): InstrumentShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["visitId"] = this.visitId;
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["locked"] = this.locked;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentShortDto {
        const json = this.toJSON();
        let result = new InstrumentShortDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentShortDto extends IBaseDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    locked?: boolean;
}

export class InstrumentDto extends BaseDto implements IInstrumentDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: DataFieldDto[] | undefined;
    order?: number;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    validationMessages?: ValidationMessageDto[] | undefined;
    canSave?: boolean;

    constructor(data?: IInstrumentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.visitId = _data["visitId"];
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDto.fromJS(item));
            }
            this.order = _data["order"];
            this.locked = _data["locked"];
            this.lockDate = _data["lockDate"] ? new Date(_data["lockDate"].toString()) : <any>undefined;
            this.lockedManually = _data["lockedManually"];
            this.lockedAutomatically = _data["lockedAutomatically"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUser = _data["creatingUser"] ? UserInfoDto.fromJS(_data["creatingUser"]) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changingUser = _data["changingUser"] ? UserInfoDto.fromJS(_data["changingUser"]) : <any>undefined;
            this.tags = _data["tags"];
            if (Array.isArray(_data["validationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["validationMessages"])
                    this.validationMessages!.push(ValidationMessageDto.fromJS(item));
            }
            this.canSave = _data["canSave"];
        }
    }

    static fromJS(data: any): InstrumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["visitId"] = this.visitId;
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["locked"] = this.locked;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : <any>undefined;
        data["lockedManually"] = this.lockedManually;
        data["lockedAutomatically"] = this.lockedAutomatically;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUser"] = this.creatingUser ? this.creatingUser.toJSON() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changingUser"] = this.changingUser ? this.changingUser.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        if (Array.isArray(this.validationMessages)) {
            data["validationMessages"] = [];
            for (let item of this.validationMessages)
                data["validationMessages"].push(item.toJSON());
        }
        data["canSave"] = this.canSave;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentDto {
        const json = this.toJSON();
        let result = new InstrumentDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDto extends IBaseDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: DataFieldDto[] | undefined;
    order?: number;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    validationMessages?: ValidationMessageDto[] | undefined;
    canSave?: boolean;
}

export class DataFieldDto extends BaseIdDto implements IDataFieldDto {
    isDeleted?: boolean;
    definitionId?: string;
    values?: any | undefined;
    childFields?: DataFieldDto[] | undefined;
    isVisible?: boolean;
    order?: number;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;

    constructor(data?: IDataFieldDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDeleted = _data["isDeleted"];
            this.definitionId = _data["definitionId"];
            this.values = _data["values"];
            if (Array.isArray(_data["childFields"])) {
                this.childFields = [] as any;
                for (let item of _data["childFields"])
                    this.childFields!.push(DataFieldDto.fromJS(item));
            }
            this.isVisible = _data["isVisible"];
            this.order = _data["order"];
            this.locked = _data["locked"];
            this.lockDate = _data["lockDate"] ? new Date(_data["lockDate"].toString()) : <any>undefined;
            this.lockedManually = _data["lockedManually"];
            this.lockedAutomatically = _data["lockedAutomatically"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUser = _data["creatingUser"] ? UserInfoDto.fromJS(_data["creatingUser"]) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changingUser = _data["changingUser"] ? UserInfoDto.fromJS(_data["changingUser"]) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): DataFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["definitionId"] = this.definitionId;
        data["values"] = this.values;
        if (Array.isArray(this.childFields)) {
            data["childFields"] = [];
            for (let item of this.childFields)
                data["childFields"].push(item.toJSON());
        }
        data["isVisible"] = this.isVisible;
        data["order"] = this.order;
        data["locked"] = this.locked;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : <any>undefined;
        data["lockedManually"] = this.lockedManually;
        data["lockedAutomatically"] = this.lockedAutomatically;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUser"] = this.creatingUser ? this.creatingUser.toJSON() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changingUser"] = this.changingUser ? this.changingUser.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): DataFieldDto {
        const json = this.toJSON();
        let result = new DataFieldDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldDto extends IBaseIdDto {
    isDeleted?: boolean;
    definitionId?: string;
    values?: any | undefined;
    childFields?: DataFieldDto[] | undefined;
    isVisible?: boolean;
    order?: number;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
}

export class UserInfoDto extends BaseIdDto implements IUserInfoDto {
    displayName?: string | undefined;

    constructor(data?: IUserInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): UserInfoDto {
        const json = this.toJSON();
        let result = new UserInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserInfoDto extends IBaseIdDto {
    displayName?: string | undefined;
}

export class ValidationMessageDto implements IValidationMessageDto {
    dataFieldId?: string;
    ruleId?: string;
    message?: string | undefined;
    messageType?: string | undefined;
    parameters?: { [key: string]: string; } | undefined;

    constructor(data?: IValidationMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataFieldId = _data["dataFieldId"];
            this.ruleId = _data["ruleId"];
            this.message = _data["message"];
            this.messageType = _data["messageType"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
        }
    }

    static fromJS(data: any): ValidationMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataFieldId"] = this.dataFieldId;
        data["ruleId"] = this.ruleId;
        data["message"] = this.message;
        data["messageType"] = this.messageType;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        return data;
    }

    clone(): ValidationMessageDto {
        const json = this.toJSON();
        let result = new ValidationMessageDto();
        result.init(json);
        return result;
    }
}

export interface IValidationMessageDto {
    dataFieldId?: string;
    ruleId?: string;
    message?: string | undefined;
    messageType?: string | undefined;
    parameters?: { [key: string]: string; } | undefined;
}

export class InstrumentCreateDto implements IInstrumentCreateDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldCreateDto[] | undefined;

    constructor(data?: IInstrumentCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.visitId = _data["visitId"];
            this.definitionId = _data["definitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.lockedManually = _data["lockedManually"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["visitId"] = this.visitId;
        data["definitionId"] = this.definitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["lockedManually"] = this.lockedManually;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }

    clone(): InstrumentCreateDto {
        const json = this.toJSON();
        let result = new InstrumentCreateDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentCreateDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldCreateDto[] | undefined;
}

export class DataFieldCreateDto implements IDataFieldCreateDto {
    definitionId!: string;
    values?: any | undefined;
    childFields?: DataFieldCreateDto[] | undefined;
    isVisible?: boolean;
    order?: number;
    lockedManually?: boolean;
    tags?: any | undefined;

    constructor(data?: IDataFieldCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.values = _data["values"];
            if (Array.isArray(_data["childFields"])) {
                this.childFields = [] as any;
                for (let item of _data["childFields"])
                    this.childFields!.push(DataFieldCreateDto.fromJS(item));
            }
            this.isVisible = _data["isVisible"];
            this.order = _data["order"];
            this.lockedManually = _data["lockedManually"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): DataFieldCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["values"] = this.values;
        if (Array.isArray(this.childFields)) {
            data["childFields"] = [];
            for (let item of this.childFields)
                data["childFields"].push(item.toJSON());
        }
        data["isVisible"] = this.isVisible;
        data["order"] = this.order;
        data["lockedManually"] = this.lockedManually;
        data["tags"] = this.tags;
        return data;
    }

    clone(): DataFieldCreateDto {
        const json = this.toJSON();
        let result = new DataFieldCreateDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldCreateDto {
    definitionId: string;
    values?: any | undefined;
    childFields?: DataFieldCreateDto[] | undefined;
    isVisible?: boolean;
    order?: number;
    lockedManually?: boolean;
    tags?: any | undefined;
}

export class InstrumentUpdateDto extends BaseIdDto implements IInstrumentUpdateDto {
    visitId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldUpdateDto[] | undefined;
    deletedFields?: DataFieldUpdateDto[] | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IInstrumentUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.visitId = _data["visitId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.lockedManually = _data["lockedManually"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldUpdateDto.fromJS(item));
            }
            if (Array.isArray(_data["deletedFields"])) {
                this.deletedFields = [] as any;
                for (let item of _data["deletedFields"])
                    this.deletedFields!.push(DataFieldUpdateDto.fromJS(item));
            }
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstrumentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitId"] = this.visitId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["lockedManually"] = this.lockedManually;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedFields)) {
            data["deletedFields"] = [];
            for (let item of this.deletedFields)
                data["deletedFields"].push(item.toJSON());
        }
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentUpdateDto {
        const json = this.toJSON();
        let result = new InstrumentUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentUpdateDto extends IBaseIdDto {
    visitId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldUpdateDto[] | undefined;
    deletedFields?: DataFieldUpdateDto[] | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class DataFieldUpdateDto implements IDataFieldUpdateDto {
    id?: string | undefined;
    definitionId!: string;
    values?: any | undefined;
    childFields?: DataFieldUpdateDto[] | undefined;
    isVisible?: boolean;
    lockedManually?: boolean;
    order?: number;
    tags?: any | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IDataFieldUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.definitionId = _data["definitionId"];
            this.values = _data["values"];
            if (Array.isArray(_data["childFields"])) {
                this.childFields = [] as any;
                for (let item of _data["childFields"])
                    this.childFields!.push(DataFieldUpdateDto.fromJS(item));
            }
            this.isVisible = _data["isVisible"];
            this.lockedManually = _data["lockedManually"];
            this.order = _data["order"];
            this.tags = _data["tags"];
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataFieldUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["definitionId"] = this.definitionId;
        data["values"] = this.values;
        if (Array.isArray(this.childFields)) {
            data["childFields"] = [];
            for (let item of this.childFields)
                data["childFields"].push(item.toJSON());
        }
        data["isVisible"] = this.isVisible;
        data["lockedManually"] = this.lockedManually;
        data["order"] = this.order;
        data["tags"] = this.tags;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        return data;
    }

    clone(): DataFieldUpdateDto {
        const json = this.toJSON();
        let result = new DataFieldUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldUpdateDto {
    id?: string | undefined;
    definitionId: string;
    values?: any | undefined;
    childFields?: DataFieldUpdateDto[] | undefined;
    isVisible?: boolean;
    lockedManually?: boolean;
    order?: number;
    tags?: any | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class InstrumentDeleteDto extends BaseIdDto implements IInstrumentDeleteDto {
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IInstrumentDeleteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstrumentDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentDeleteDto {
        const json = this.toJSON();
        let result = new InstrumentDeleteDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDeleteDto extends IBaseIdDto {
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class TemporaryInstrumentResponseDto implements ITemporaryInstrumentResponseDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: TemporaryDataFieldDto[] | undefined;
    order?: number;
    tags?: any | undefined;

    constructor(data?: ITemporaryInstrumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.visitId = _data["visitId"];
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(TemporaryDataFieldDto.fromJS(item));
            }
            this.order = _data["order"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): TemporaryInstrumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporaryInstrumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["visitId"] = this.visitId;
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["tags"] = this.tags;
        return data;
    }

    clone(): TemporaryInstrumentResponseDto {
        const json = this.toJSON();
        let result = new TemporaryInstrumentResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITemporaryInstrumentResponseDto {
    patientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: TemporaryDataFieldDto[] | undefined;
    order?: number;
    tags?: any | undefined;
}

export class TemporaryDataFieldDto implements ITemporaryDataFieldDto {
    definitionId?: string;
    value?: any | undefined;
    tags?: any | undefined;
    childFields?: TemporaryDataFieldDto[] | undefined;
    isVisible?: boolean;
    order?: number;

    constructor(data?: ITemporaryDataFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.value = _data["value"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["childFields"])) {
                this.childFields = [] as any;
                for (let item of _data["childFields"])
                    this.childFields!.push(TemporaryDataFieldDto.fromJS(item));
            }
            this.isVisible = _data["isVisible"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TemporaryDataFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporaryDataFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["value"] = this.value;
        data["tags"] = this.tags;
        if (Array.isArray(this.childFields)) {
            data["childFields"] = [];
            for (let item of this.childFields)
                data["childFields"].push(item.toJSON());
        }
        data["isVisible"] = this.isVisible;
        data["order"] = this.order;
        return data;
    }

    clone(): TemporaryDataFieldDto {
        const json = this.toJSON();
        let result = new TemporaryDataFieldDto();
        result.init(json);
        return result;
    }
}

export interface ITemporaryDataFieldDto {
    definitionId?: string;
    value?: any | undefined;
    tags?: any | undefined;
    childFields?: TemporaryDataFieldDto[] | undefined;
    isVisible?: boolean;
    order?: number;
}

export class InstrumentDataFieldCreateDto implements IInstrumentDataFieldCreateDto {
    studyPatientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    parentFieldId?: string;
    field?: DataFieldUpdateDto | undefined;

    constructor(data?: IInstrumentDataFieldCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyPatientId = _data["studyPatientId"];
            this.visitId = _data["visitId"];
            this.definitionId = _data["definitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.lockedManually = _data["lockedManually"];
            this.parentFieldId = _data["parentFieldId"];
            this.field = _data["field"] ? DataFieldUpdateDto.fromJS(_data["field"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstrumentDataFieldCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDataFieldCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyPatientId"] = this.studyPatientId;
        data["visitId"] = this.visitId;
        data["definitionId"] = this.definitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["lockedManually"] = this.lockedManually;
        data["parentFieldId"] = this.parentFieldId;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        return data;
    }

    clone(): InstrumentDataFieldCreateDto {
        const json = this.toJSON();
        let result = new InstrumentDataFieldCreateDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDataFieldCreateDto {
    studyPatientId?: string;
    visitId?: string | undefined;
    definitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    parentFieldId?: string;
    field?: DataFieldUpdateDto | undefined;
}

export class InstrumentDataFieldUpdateDto extends BaseIdDto implements IInstrumentDataFieldUpdateDto {
    visitId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    parentFieldId?: string;
    field?: DataFieldUpdateDto | undefined;
    deletedFields?: DataFieldUpdateDto[] | undefined;

    constructor(data?: IInstrumentDataFieldUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.visitId = _data["visitId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.lockedManually = _data["lockedManually"];
            this.parentFieldId = _data["parentFieldId"];
            this.field = _data["field"] ? DataFieldUpdateDto.fromJS(_data["field"]) : <any>undefined;
            if (Array.isArray(_data["deletedFields"])) {
                this.deletedFields = [] as any;
                for (let item of _data["deletedFields"])
                    this.deletedFields!.push(DataFieldUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentDataFieldUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDataFieldUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitId"] = this.visitId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["lockedManually"] = this.lockedManually;
        data["parentFieldId"] = this.parentFieldId;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        if (Array.isArray(this.deletedFields)) {
            data["deletedFields"] = [];
            for (let item of this.deletedFields)
                data["deletedFields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentDataFieldUpdateDto {
        const json = this.toJSON();
        let result = new InstrumentDataFieldUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDataFieldUpdateDto extends IBaseIdDto {
    visitId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    parentFieldId?: string;
    field?: DataFieldUpdateDto | undefined;
    deletedFields?: DataFieldUpdateDto[] | undefined;
}

export class InstrumentDataFieldDeleteDto extends BaseIdDto implements IInstrumentDataFieldDeleteDto {
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IInstrumentDataFieldDeleteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstrumentDataFieldDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDataFieldDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentDataFieldDeleteDto {
        const json = this.toJSON();
        let result = new InstrumentDataFieldDeleteDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDataFieldDeleteDto extends IBaseIdDto {
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class InstrumentDefinitionShortDto extends BaseDto implements IInstrumentDefinitionShortDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;

    constructor(data?: IInstrumentDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
        }
    }

    static fromJS(data: any): InstrumentDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentDefinitionShortDto {
        const json = this.toJSON();
        let result = new InstrumentDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDefinitionShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
}

export class InstrumentDefinitionDto extends BaseDto implements IInstrumentDefinitionDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionDto[] | undefined;

    constructor(data?: IInstrumentDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentDefinitionDto {
        const json = this.toJSON();
        let result = new InstrumentDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDefinitionDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionDto[] | undefined;
}

export class InstrumentDefinitionCreateDto implements IInstrumentDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionCreateDto[] | undefined;

    constructor(data?: IInstrumentDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDefinitionCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }

    clone(): InstrumentDefinitionCreateDto {
        const json = this.toJSON();
        let result = new InstrumentDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionCreateDto[] | undefined;
}

export class InstrumentDefinitionUpdateDto extends BaseIdDto implements IInstrumentDefinitionUpdateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionUpdateDto[] | undefined;

    constructor(data?: IInstrumentDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDefinitionUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new InstrumentDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentDefinitionUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionUpdateDto[] | undefined;
}

export class LanguageShortDto extends BaseDto implements ILanguageShortDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;

    constructor(data?: ILanguageShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
        }
    }

    static fromJS(data: any): LanguageShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        super.toJSON(data);
        return data;
    }

    clone(): LanguageShortDto {
        const json = this.toJSON();
        let result = new LanguageShortDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageShortDto extends IBaseDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
}

export class LanguageDto extends BaseDto implements ILanguageDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    entries?: LanguageEntryDto[] | undefined;

    constructor(data?: ILanguageDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(LanguageEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageDto extends IBaseDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    entries?: LanguageEntryDto[] | undefined;
}

export class LanguageEntryDto extends BaseDto implements ILanguageEntryDto {
    languageId?: string;
    displayKey?: string | undefined;
    scope?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ILanguageEntryDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.displayKey = _data["displayKey"];
            this.scope = _data["scope"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): LanguageEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["displayKey"] = this.displayKey;
        data["scope"] = this.scope;
        data["displayValue"] = this.displayValue;
        super.toJSON(data);
        return data;
    }

    clone(): LanguageEntryDto {
        const json = this.toJSON();
        let result = new LanguageEntryDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageEntryDto extends IBaseDto {
    languageId?: string;
    displayKey?: string | undefined;
    scope?: string | undefined;
    displayValue?: string | undefined;
}

export class LanguageCreateDto implements ILanguageCreateDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    entries?: LanguageEntryChangeDto[] | undefined;

    constructor(data?: ILanguageCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(LanguageEntryChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }

    clone(): LanguageCreateDto {
        const json = this.toJSON();
        let result = new LanguageCreateDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageCreateDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    entries?: LanguageEntryChangeDto[] | undefined;
}

export class LanguageEntryChangeDto implements ILanguageEntryChangeDto {
    displayKey!: string;
    scope?: string | undefined;
    displayValue!: string;

    constructor(data?: ILanguageEntryChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayKey = _data["displayKey"];
            this.scope = _data["scope"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): LanguageEntryChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageEntryChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayKey"] = this.displayKey;
        data["scope"] = this.scope;
        data["displayValue"] = this.displayValue;
        return data;
    }

    clone(): LanguageEntryChangeDto {
        const json = this.toJSON();
        let result = new LanguageEntryChangeDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageEntryChangeDto {
    displayKey: string;
    scope?: string | undefined;
    displayValue: string;
}

export class LanguageUpdateDto extends BaseIdDto implements ILanguageUpdateDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    entries?: LanguageEntryChangeDto[] | undefined;

    constructor(data?: ILanguageUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(LanguageEntryChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): LanguageUpdateDto {
        const json = this.toJSON();
        let result = new LanguageUpdateDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageUpdateDto extends IBaseIdDto {
    studyDefinitionId?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    entries?: LanguageEntryChangeDto[] | undefined;
}

export class LanguageEntryShortDto extends BaseDto implements ILanguageEntryShortDto {
    languageId?: string;
    displayKey?: string | undefined;
    scope?: string | undefined;

    constructor(data?: ILanguageEntryShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.displayKey = _data["displayKey"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): LanguageEntryShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageEntryShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["displayKey"] = this.displayKey;
        data["scope"] = this.scope;
        super.toJSON(data);
        return data;
    }

    clone(): LanguageEntryShortDto {
        const json = this.toJSON();
        let result = new LanguageEntryShortDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageEntryShortDto extends IBaseDto {
    languageId?: string;
    displayKey?: string | undefined;
    scope?: string | undefined;
}

export class LanguageEntryCreateDto implements ILanguageEntryCreateDto {
    languageId!: string;
    displayKey!: string;
    displayValue!: string;
    scope?: string | undefined;

    constructor(data?: ILanguageEntryCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.displayKey = _data["displayKey"];
            this.displayValue = _data["displayValue"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): LanguageEntryCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageEntryCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["displayKey"] = this.displayKey;
        data["displayValue"] = this.displayValue;
        data["scope"] = this.scope;
        return data;
    }

    clone(): LanguageEntryCreateDto {
        const json = this.toJSON();
        let result = new LanguageEntryCreateDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageEntryCreateDto {
    languageId: string;
    displayKey: string;
    displayValue: string;
    scope?: string | undefined;
}

export class LanguageEntryUpdateDto extends BaseIdDto implements ILanguageEntryUpdateDto {
    displayKey!: string;
    displayValue!: string;
    scope?: string | undefined;

    constructor(data?: ILanguageEntryUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayKey = _data["displayKey"];
            this.displayValue = _data["displayValue"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): LanguageEntryUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageEntryUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayKey"] = this.displayKey;
        data["displayValue"] = this.displayValue;
        data["scope"] = this.scope;
        super.toJSON(data);
        return data;
    }

    clone(): LanguageEntryUpdateDto {
        const json = this.toJSON();
        let result = new LanguageEntryUpdateDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageEntryUpdateDto extends IBaseIdDto {
    displayKey: string;
    displayValue: string;
    scope?: string | undefined;
}

export class PatientDefinitionShortDto extends BaseDto implements IPatientDefinitionShortDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    studyDefinitionId?: string;
    definitionType?: string | undefined;

    constructor(data?: IPatientDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
        }
    }

    static fromJS(data: any): PatientDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        super.toJSON(data);
        return data;
    }

    clone(): PatientDefinitionShortDto {
        const json = this.toJSON();
        let result = new PatientDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDefinitionShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
}

export class PatientDefinitionDto extends BaseDto implements IPatientDefinitionDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionDto[] | undefined;

    constructor(data?: IPatientDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): PatientDefinitionDto {
        const json = this.toJSON();
        let result = new PatientDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDefinitionDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionDto[] | undefined;
}

export class PatientDefinitionUpdateDto extends BaseIdDto implements IPatientDefinitionUpdateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionUpdateDto[] | undefined;

    constructor(data?: IPatientDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDefinitionUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): PatientDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new PatientDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDefinitionUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionUpdateDto[] | undefined;
}

export class QueryListResponse implements IQueryListResponse {
    items?: QueryShortDto[] | undefined;
    itemsTotal?: number;
    itemsNew?: number;
    itemsPending?: number;
    itemsClosed?: number;
    itemsAnswered?: number;
    itemsRenewed?: number;
    itemsInvisible?: number;
    itemsNoLongerRelevant?: number;

    constructor(data?: IQueryListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QueryShortDto.fromJS(item));
            }
            this.itemsTotal = _data["itemsTotal"];
            this.itemsNew = _data["itemsNew"];
            this.itemsPending = _data["itemsPending"];
            this.itemsClosed = _data["itemsClosed"];
            this.itemsAnswered = _data["itemsAnswered"];
            this.itemsRenewed = _data["itemsRenewed"];
            this.itemsInvisible = _data["itemsInvisible"];
            this.itemsNoLongerRelevant = _data["itemsNoLongerRelevant"];
        }
    }

    static fromJS(data: any): QueryListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QueryListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["itemsTotal"] = this.itemsTotal;
        data["itemsNew"] = this.itemsNew;
        data["itemsPending"] = this.itemsPending;
        data["itemsClosed"] = this.itemsClosed;
        data["itemsAnswered"] = this.itemsAnswered;
        data["itemsRenewed"] = this.itemsRenewed;
        data["itemsInvisible"] = this.itemsInvisible;
        data["itemsNoLongerRelevant"] = this.itemsNoLongerRelevant;
        return data;
    }

    clone(): QueryListResponse {
        const json = this.toJSON();
        let result = new QueryListResponse();
        result.init(json);
        return result;
    }
}

export interface IQueryListResponse {
    items?: QueryShortDto[] | undefined;
    itemsTotal?: number;
    itemsNew?: number;
    itemsPending?: number;
    itemsClosed?: number;
    itemsAnswered?: number;
    itemsRenewed?: number;
    itemsInvisible?: number;
    itemsNoLongerRelevant?: number;
}

export class VisitQueryStates implements IVisitQueryStates {
    visitId?: string;
    hasOpenQueries?: boolean;
    visitQueries?: number[] | undefined;
    instrumentQueries?: number[] | undefined;
    visitFieldQueries?: number[] | undefined;
    instrumentFieldQueries?: number[] | undefined;

    constructor(data?: IVisitQueryStates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitId = _data["visitId"];
            this.hasOpenQueries = _data["hasOpenQueries"];
            if (Array.isArray(_data["visitQueries"])) {
                this.visitQueries = [] as any;
                for (let item of _data["visitQueries"])
                    this.visitQueries!.push(item);
            }
            if (Array.isArray(_data["instrumentQueries"])) {
                this.instrumentQueries = [] as any;
                for (let item of _data["instrumentQueries"])
                    this.instrumentQueries!.push(item);
            }
            if (Array.isArray(_data["visitFieldQueries"])) {
                this.visitFieldQueries = [] as any;
                for (let item of _data["visitFieldQueries"])
                    this.visitFieldQueries!.push(item);
            }
            if (Array.isArray(_data["instrumentFieldQueries"])) {
                this.instrumentFieldQueries = [] as any;
                for (let item of _data["instrumentFieldQueries"])
                    this.instrumentFieldQueries!.push(item);
            }
        }
    }

    static fromJS(data: any): VisitQueryStates {
        data = typeof data === 'object' ? data : {};
        let result = new VisitQueryStates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitId"] = this.visitId;
        data["hasOpenQueries"] = this.hasOpenQueries;
        if (Array.isArray(this.visitQueries)) {
            data["visitQueries"] = [];
            for (let item of this.visitQueries)
                data["visitQueries"].push(item);
        }
        if (Array.isArray(this.instrumentQueries)) {
            data["instrumentQueries"] = [];
            for (let item of this.instrumentQueries)
                data["instrumentQueries"].push(item);
        }
        if (Array.isArray(this.visitFieldQueries)) {
            data["visitFieldQueries"] = [];
            for (let item of this.visitFieldQueries)
                data["visitFieldQueries"].push(item);
        }
        if (Array.isArray(this.instrumentFieldQueries)) {
            data["instrumentFieldQueries"] = [];
            for (let item of this.instrumentFieldQueries)
                data["instrumentFieldQueries"].push(item);
        }
        return data;
    }

    clone(): VisitQueryStates {
        const json = this.toJSON();
        let result = new VisitQueryStates();
        result.init(json);
        return result;
    }
}

export interface IVisitQueryStates {
    visitId?: string;
    hasOpenQueries?: boolean;
    visitQueries?: number[] | undefined;
    instrumentQueries?: number[] | undefined;
    visitFieldQueries?: number[] | undefined;
    instrumentFieldQueries?: number[] | undefined;
}

export class QueryDto extends QueryShortDto implements IQueryDto {
    creatingUserUserName?: string | undefined;
    creatingUserDisplayName?: string | undefined;
    creatingUserRoleIdentifier?: string | undefined;
    creatingUserRoleDisplayName?: string | undefined;
    patientId?: string;
    patientPatientIdentifier?: string | undefined;
    studyInstituteId?: string;
    studyInstituteIdentifier?: string | undefined;
    studyInstituteDisplayName?: string | undefined;
    messages?: QueryMessageDto[] | undefined;
    queryTypeDefinition?: any | undefined;

    constructor(data?: IQueryDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.creatingUserUserName = _data["creatingUserUserName"];
            this.creatingUserDisplayName = _data["creatingUserDisplayName"];
            this.creatingUserRoleIdentifier = _data["creatingUserRoleIdentifier"];
            this.creatingUserRoleDisplayName = _data["creatingUserRoleDisplayName"];
            this.patientId = _data["patientId"];
            this.patientPatientIdentifier = _data["patientPatientIdentifier"];
            this.studyInstituteId = _data["studyInstituteId"];
            this.studyInstituteIdentifier = _data["studyInstituteIdentifier"];
            this.studyInstituteDisplayName = _data["studyInstituteDisplayName"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(QueryMessageDto.fromJS(item));
            }
            this.queryTypeDefinition = _data["queryTypeDefinition"];
        }
    }

    static fromJS(data: any): QueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatingUserUserName"] = this.creatingUserUserName;
        data["creatingUserDisplayName"] = this.creatingUserDisplayName;
        data["creatingUserRoleIdentifier"] = this.creatingUserRoleIdentifier;
        data["creatingUserRoleDisplayName"] = this.creatingUserRoleDisplayName;
        data["patientId"] = this.patientId;
        data["patientPatientIdentifier"] = this.patientPatientIdentifier;
        data["studyInstituteId"] = this.studyInstituteId;
        data["studyInstituteIdentifier"] = this.studyInstituteIdentifier;
        data["studyInstituteDisplayName"] = this.studyInstituteDisplayName;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["queryTypeDefinition"] = this.queryTypeDefinition;
        super.toJSON(data);
        return data;
    }

    clone(): QueryDto {
        const json = this.toJSON();
        let result = new QueryDto();
        result.init(json);
        return result;
    }
}

export interface IQueryDto extends IQueryShortDto {
    creatingUserUserName?: string | undefined;
    creatingUserDisplayName?: string | undefined;
    creatingUserRoleIdentifier?: string | undefined;
    creatingUserRoleDisplayName?: string | undefined;
    patientId?: string;
    patientPatientIdentifier?: string | undefined;
    studyInstituteId?: string;
    studyInstituteIdentifier?: string | undefined;
    studyInstituteDisplayName?: string | undefined;
    messages?: QueryMessageDto[] | undefined;
    queryTypeDefinition?: any | undefined;
}

export class QueryOverviewResponse implements IQueryOverviewResponse {
    items?: QueryOverviewShortDto[] | undefined;
    itemsTotal?: number;

    constructor(data?: IQueryOverviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QueryOverviewShortDto.fromJS(item));
            }
            this.itemsTotal = _data["itemsTotal"];
        }
    }

    static fromJS(data: any): QueryOverviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QueryOverviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["itemsTotal"] = this.itemsTotal;
        return data;
    }

    clone(): QueryOverviewResponse {
        const json = this.toJSON();
        let result = new QueryOverviewResponse();
        result.init(json);
        return result;
    }
}

export interface IQueryOverviewResponse {
    items?: QueryOverviewShortDto[] | undefined;
    itemsTotal?: number;
}

export class QueryOverviewShortDto extends QueryShortDto implements IQueryOverviewShortDto {
    patientId?: string | undefined;
    patientIdentifier?: string | undefined;
    studyInstituteId?: string | undefined;
    studyInstituteIdentifier?: string | undefined;
    creatingUserUserName?: string | undefined;
    creatingUserDisplayName?: string | undefined;

    constructor(data?: IQueryOverviewShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.patientIdentifier = _data["patientIdentifier"];
            this.studyInstituteId = _data["studyInstituteId"];
            this.studyInstituteIdentifier = _data["studyInstituteIdentifier"];
            this.creatingUserUserName = _data["creatingUserUserName"];
            this.creatingUserDisplayName = _data["creatingUserDisplayName"];
        }
    }

    static fromJS(data: any): QueryOverviewShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryOverviewShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["patientIdentifier"] = this.patientIdentifier;
        data["studyInstituteId"] = this.studyInstituteId;
        data["studyInstituteIdentifier"] = this.studyInstituteIdentifier;
        data["creatingUserUserName"] = this.creatingUserUserName;
        data["creatingUserDisplayName"] = this.creatingUserDisplayName;
        super.toJSON(data);
        return data;
    }

    clone(): QueryOverviewShortDto {
        const json = this.toJSON();
        let result = new QueryOverviewShortDto();
        result.init(json);
        return result;
    }
}

export interface IQueryOverviewShortDto extends IQueryShortDto {
    patientId?: string | undefined;
    patientIdentifier?: string | undefined;
    studyInstituteId?: string | undefined;
    studyInstituteIdentifier?: string | undefined;
    creatingUserUserName?: string | undefined;
    creatingUserDisplayName?: string | undefined;
}

export class QueryCreateDto implements IQueryCreateDto {
    text?: string | undefined;
    referenceId!: string;
    queryTypeId!: string;
    studyDefinitionId!: string;
    priority?: Priority;

    constructor(data?: IQueryCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.referenceId = _data["referenceId"];
            this.queryTypeId = _data["queryTypeId"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): QueryCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["referenceId"] = this.referenceId;
        data["queryTypeId"] = this.queryTypeId;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["priority"] = this.priority;
        return data;
    }

    clone(): QueryCreateDto {
        const json = this.toJSON();
        let result = new QueryCreateDto();
        result.init(json);
        return result;
    }
}

export interface IQueryCreateDto {
    text?: string | undefined;
    referenceId: string;
    queryTypeId: string;
    studyDefinitionId: string;
    priority?: Priority;
}

export enum Priority {
    NORMAL = "NORMAL",
    HIGH = "HIGH",
}

export class QueryEditDto extends BaseIdDto implements IQueryEditDto {
    text?: string | undefined;

    constructor(data?: IQueryEditDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): QueryEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        super.toJSON(data);
        return data;
    }

    clone(): QueryEditDto {
        const json = this.toJSON();
        let result = new QueryEditDto();
        result.init(json);
        return result;
    }
}

export interface IQueryEditDto extends IBaseIdDto {
    text?: string | undefined;
}

export class QueryAnswerDto extends BaseIdDto implements IQueryAnswerDto {
    message?: string | undefined;

    constructor(data?: IQueryAnswerDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): QueryAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }

    clone(): QueryAnswerDto {
        const json = this.toJSON();
        let result = new QueryAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IQueryAnswerDto extends IBaseIdDto {
    message?: string | undefined;
}

export class QueryRevokeDto extends BaseIdDto implements IQueryRevokeDto {
    revoke!: boolean;

    constructor(data?: IQueryRevokeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.revoke = _data["revoke"];
        }
    }

    static fromJS(data: any): QueryRevokeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryRevokeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revoke"] = this.revoke;
        super.toJSON(data);
        return data;
    }

    clone(): QueryRevokeDto {
        const json = this.toJSON();
        let result = new QueryRevokeDto();
        result.init(json);
        return result;
    }
}

export interface IQueryRevokeDto extends IBaseIdDto {
    revoke: boolean;
}

export class QueryAcceptDto extends BaseIdDto implements IQueryAcceptDto {
    accept!: boolean;

    constructor(data?: IQueryAcceptDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accept = _data["accept"];
        }
    }

    static fromJS(data: any): QueryAcceptDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryAcceptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accept"] = this.accept;
        super.toJSON(data);
        return data;
    }

    clone(): QueryAcceptDto {
        const json = this.toJSON();
        let result = new QueryAcceptDto();
        result.init(json);
        return result;
    }
}

export interface IQueryAcceptDto extends IBaseIdDto {
    accept: boolean;
}

export class QuerySolveDto extends BaseIdDto implements IQuerySolveDto {
    solve!: boolean;

    constructor(data?: IQuerySolveDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.solve = _data["solve"];
        }
    }

    static fromJS(data: any): QuerySolveDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySolveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solve"] = this.solve;
        super.toJSON(data);
        return data;
    }

    clone(): QuerySolveDto {
        const json = this.toJSON();
        let result = new QuerySolveDto();
        result.init(json);
        return result;
    }
}

export interface IQuerySolveDto extends IBaseIdDto {
    solve: boolean;
}

export class QueryDeferDto extends BaseIdDto implements IQueryDeferDto {
    pending!: boolean;

    constructor(data?: IQueryDeferDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pending = _data["pending"];
        }
    }

    static fromJS(data: any): QueryDeferDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryDeferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pending"] = this.pending;
        super.toJSON(data);
        return data;
    }

    clone(): QueryDeferDto {
        const json = this.toJSON();
        let result = new QueryDeferDto();
        result.init(json);
        return result;
    }
}

export interface IQueryDeferDto extends IBaseIdDto {
    pending: boolean;
}

export class QueryTypeDefinitionShortDto extends BaseDto implements IQueryTypeDefinitionShortDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;

    constructor(data?: IQueryTypeDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
        }
    }

    static fromJS(data: any): QueryTypeDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTypeDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        super.toJSON(data);
        return data;
    }

    clone(): QueryTypeDefinitionShortDto {
        const json = this.toJSON();
        let result = new QueryTypeDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IQueryTypeDefinitionShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
}

export class QueryTypeDefinitionDto extends BaseDto implements IQueryTypeDefinitionDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IQueryTypeDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): QueryTypeDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTypeDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): QueryTypeDefinitionDto {
        const json = this.toJSON();
        let result = new QueryTypeDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IQueryTypeDefinitionDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class QueryTypeDefinitionCreateDto implements IQueryTypeDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IQueryTypeDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): QueryTypeDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTypeDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        return data;
    }

    clone(): QueryTypeDefinitionCreateDto {
        const json = this.toJSON();
        let result = new QueryTypeDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IQueryTypeDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class QueryTypeDefinitionUpdateDto extends BaseIdDto implements IQueryTypeDefinitionUpdateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IQueryTypeDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): QueryTypeDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTypeDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): QueryTypeDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new QueryTypeDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IQueryTypeDefinitionUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class RuleDefinitionShortDto extends BaseDto implements IRuleDefinitionShortDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    order?: number;

    constructor(data?: IRuleDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): RuleDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): RuleDefinitionShortDto {
        const json = this.toJSON();
        let result = new RuleDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IRuleDefinitionShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    order?: number;
}

export class RuleDefinitionUpdateDto extends BaseIdDto implements IRuleDefinitionUpdateDto {
    identifier!: string;
    displayKey!: string;
    referenceType!: string;
    referenceId!: string;
    studyDefinitionId!: string;
    definitionType!: string;
    definition?: any | undefined;
    constraintExpression?: ConstraintExpression | undefined;
    order?: number;

    constructor(data?: IRuleDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            this.constraintExpression = _data["constraintExpression"] ? ConstraintExpression.fromJS(_data["constraintExpression"]) : <any>undefined;
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): RuleDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        data["constraintExpression"] = this.constraintExpression ? this.constraintExpression.toJSON() : <any>undefined;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): RuleDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new RuleDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IRuleDefinitionUpdateDto extends IBaseIdDto {
    identifier: string;
    displayKey: string;
    referenceType: string;
    referenceId: string;
    studyDefinitionId: string;
    definitionType: string;
    definition?: any | undefined;
    constraintExpression?: ConstraintExpression | undefined;
    order?: number;
}

export class SafetyReportResponseDto implements ISafetyReportResponseDto {
    entries?: SafetyReportEntry[] | undefined;
    xlsxExport?: MemoryStream | undefined;

    constructor(data?: ISafetyReportResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(SafetyReportEntry.fromJS(item));
            }
            this.xlsxExport = _data["xlsxExport"] ? MemoryStream.fromJS(_data["xlsxExport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SafetyReportResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyReportResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["xlsxExport"] = this.xlsxExport ? this.xlsxExport.toJSON() : <any>undefined;
        return data;
    }

    clone(): SafetyReportResponseDto {
        const json = this.toJSON();
        let result = new SafetyReportResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISafetyReportResponseDto {
    entries?: SafetyReportEntry[] | undefined;
    xlsxExport?: MemoryStream | undefined;
}

export class SafetyReportEntry implements ISafetyReportEntry {
    fieldId?: string;
    fieldDisplayKey?: string | undefined;
    fieldName?: string | undefined;
    fieldType?: string | undefined;
    patientId?: string;
    patientName?: string | undefined;
    fieldValue?: string | undefined;
    fieldChangedDate?: Date | undefined;
    fieldCreatedDate?: Date | undefined;
    fieldChangingUserName?: string | undefined;
    visitId?: string | undefined;
    visitIdentifier?: string | undefined;
    visitDisplayKey?: string | undefined;
    instrumentId?: string;
    instrumentIdentifier?: string | undefined;
    instrumentDisplayKey?: string | undefined;
    isInitialValue?: boolean;

    constructor(data?: ISafetyReportEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.fieldDisplayKey = _data["fieldDisplayKey"];
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
            this.patientId = _data["patientId"];
            this.patientName = _data["patientName"];
            this.fieldValue = _data["fieldValue"];
            this.fieldChangedDate = _data["fieldChangedDate"] ? new Date(_data["fieldChangedDate"].toString()) : <any>undefined;
            this.fieldCreatedDate = _data["fieldCreatedDate"] ? new Date(_data["fieldCreatedDate"].toString()) : <any>undefined;
            this.fieldChangingUserName = _data["fieldChangingUserName"];
            this.visitId = _data["visitId"];
            this.visitIdentifier = _data["visitIdentifier"];
            this.visitDisplayKey = _data["visitDisplayKey"];
            this.instrumentId = _data["instrumentId"];
            this.instrumentIdentifier = _data["instrumentIdentifier"];
            this.instrumentDisplayKey = _data["instrumentDisplayKey"];
            this.isInitialValue = _data["isInitialValue"];
        }
    }

    static fromJS(data: any): SafetyReportEntry {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyReportEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["fieldDisplayKey"] = this.fieldDisplayKey;
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        data["patientId"] = this.patientId;
        data["patientName"] = this.patientName;
        data["fieldValue"] = this.fieldValue;
        data["fieldChangedDate"] = this.fieldChangedDate ? this.fieldChangedDate.toISOString() : <any>undefined;
        data["fieldCreatedDate"] = this.fieldCreatedDate ? this.fieldCreatedDate.toISOString() : <any>undefined;
        data["fieldChangingUserName"] = this.fieldChangingUserName;
        data["visitId"] = this.visitId;
        data["visitIdentifier"] = this.visitIdentifier;
        data["visitDisplayKey"] = this.visitDisplayKey;
        data["instrumentId"] = this.instrumentId;
        data["instrumentIdentifier"] = this.instrumentIdentifier;
        data["instrumentDisplayKey"] = this.instrumentDisplayKey;
        data["isInitialValue"] = this.isInitialValue;
        return data;
    }

    clone(): SafetyReportEntry {
        const json = this.toJSON();
        let result = new SafetyReportEntry();
        result.init(json);
        return result;
    }
}

export interface ISafetyReportEntry {
    fieldId?: string;
    fieldDisplayKey?: string | undefined;
    fieldName?: string | undefined;
    fieldType?: string | undefined;
    patientId?: string;
    patientName?: string | undefined;
    fieldValue?: string | undefined;
    fieldChangedDate?: Date | undefined;
    fieldCreatedDate?: Date | undefined;
    fieldChangingUserName?: string | undefined;
    visitId?: string | undefined;
    visitIdentifier?: string | undefined;
    visitDisplayKey?: string | undefined;
    instrumentId?: string;
    instrumentIdentifier?: string | undefined;
    instrumentDisplayKey?: string | undefined;
    isInitialValue?: boolean;
}

export abstract class MarshalByRefObject implements IMarshalByRefObject {

    constructor(data?: IMarshalByRefObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarshalByRefObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): MarshalByRefObject {
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }
}

export interface IMarshalByRefObject {
}

export abstract class Stream extends MarshalByRefObject implements IStream {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canRead = _data["canRead"];
            this.canWrite = _data["canWrite"];
            this.canSeek = _data["canSeek"];
            this.canTimeout = _data["canTimeout"];
            this.length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        super.toJSON(data);
        return data;
    }

    clone(): Stream {
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }
}

export interface IStream extends IMarshalByRefObject {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export class MemoryStream extends Stream implements IMemoryStream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    capacity?: number;
    length?: number;
    position?: number;

    constructor(data?: IMemoryStream) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canRead = _data["canRead"];
            this.canSeek = _data["canSeek"];
            this.canWrite = _data["canWrite"];
            this.capacity = _data["capacity"];
            this.length = _data["length"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): MemoryStream {
        data = typeof data === 'object' ? data : {};
        let result = new MemoryStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["capacity"] = this.capacity;
        data["length"] = this.length;
        data["position"] = this.position;
        super.toJSON(data);
        return data;
    }

    clone(): MemoryStream {
        const json = this.toJSON();
        let result = new MemoryStream();
        result.init(json);
        return result;
    }
}

export interface IMemoryStream extends IStream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    capacity?: number;
    length?: number;
    position?: number;
}

export class SafetyReportConfigurationDto implements ISafetyReportConfigurationDto {
    studyPatientFieldsConfiguration?: SafetyReportConfigurationEntry[] | undefined;
    visitFieldsConfiguration?: SafetyReportConfigurationEntry[] | undefined;
    instrumentFieldsConfiguration?: SafetyReportConfigurationEntry[] | undefined;

    constructor(data?: ISafetyReportConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyPatientFieldsConfiguration"])) {
                this.studyPatientFieldsConfiguration = [] as any;
                for (let item of _data["studyPatientFieldsConfiguration"])
                    this.studyPatientFieldsConfiguration!.push(SafetyReportConfigurationEntry.fromJS(item));
            }
            if (Array.isArray(_data["visitFieldsConfiguration"])) {
                this.visitFieldsConfiguration = [] as any;
                for (let item of _data["visitFieldsConfiguration"])
                    this.visitFieldsConfiguration!.push(SafetyReportConfigurationEntry.fromJS(item));
            }
            if (Array.isArray(_data["instrumentFieldsConfiguration"])) {
                this.instrumentFieldsConfiguration = [] as any;
                for (let item of _data["instrumentFieldsConfiguration"])
                    this.instrumentFieldsConfiguration!.push(SafetyReportConfigurationEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafetyReportConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyReportConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyPatientFieldsConfiguration)) {
            data["studyPatientFieldsConfiguration"] = [];
            for (let item of this.studyPatientFieldsConfiguration)
                data["studyPatientFieldsConfiguration"].push(item.toJSON());
        }
        if (Array.isArray(this.visitFieldsConfiguration)) {
            data["visitFieldsConfiguration"] = [];
            for (let item of this.visitFieldsConfiguration)
                data["visitFieldsConfiguration"].push(item.toJSON());
        }
        if (Array.isArray(this.instrumentFieldsConfiguration)) {
            data["instrumentFieldsConfiguration"] = [];
            for (let item of this.instrumentFieldsConfiguration)
                data["instrumentFieldsConfiguration"].push(item.toJSON());
        }
        return data;
    }

    clone(): SafetyReportConfigurationDto {
        const json = this.toJSON();
        let result = new SafetyReportConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface ISafetyReportConfigurationDto {
    studyPatientFieldsConfiguration?: SafetyReportConfigurationEntry[] | undefined;
    visitFieldsConfiguration?: SafetyReportConfigurationEntry[] | undefined;
    instrumentFieldsConfiguration?: SafetyReportConfigurationEntry[] | undefined;
}

export class SafetyReportConfigurationEntry implements ISafetyReportConfigurationEntry {
    fieldDefinitionId?: string;
    fieldIdentifier?: string | undefined;
    fieldDisplayKey?: string | undefined;
    fieldDefinitionType?: string | undefined;
    parentGroupingFieldIdentifier?: string | undefined;
    parentGroupingFieldDisplayKey?: string | undefined;
    isSelected?: boolean;
    referenceIdentifier?: string | undefined;
    referenceDisplayKey?: string | undefined;
    isStandaloneInstrument?: boolean;
    order?: number;

    constructor(data?: ISafetyReportConfigurationEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldDefinitionId = _data["fieldDefinitionId"];
            this.fieldIdentifier = _data["fieldIdentifier"];
            this.fieldDisplayKey = _data["fieldDisplayKey"];
            this.fieldDefinitionType = _data["fieldDefinitionType"];
            this.parentGroupingFieldIdentifier = _data["parentGroupingFieldIdentifier"];
            this.parentGroupingFieldDisplayKey = _data["parentGroupingFieldDisplayKey"];
            this.isSelected = _data["isSelected"];
            this.referenceIdentifier = _data["referenceIdentifier"];
            this.referenceDisplayKey = _data["referenceDisplayKey"];
            this.isStandaloneInstrument = _data["isStandaloneInstrument"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SafetyReportConfigurationEntry {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyReportConfigurationEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldDefinitionId"] = this.fieldDefinitionId;
        data["fieldIdentifier"] = this.fieldIdentifier;
        data["fieldDisplayKey"] = this.fieldDisplayKey;
        data["fieldDefinitionType"] = this.fieldDefinitionType;
        data["parentGroupingFieldIdentifier"] = this.parentGroupingFieldIdentifier;
        data["parentGroupingFieldDisplayKey"] = this.parentGroupingFieldDisplayKey;
        data["isSelected"] = this.isSelected;
        data["referenceIdentifier"] = this.referenceIdentifier;
        data["referenceDisplayKey"] = this.referenceDisplayKey;
        data["isStandaloneInstrument"] = this.isStandaloneInstrument;
        data["order"] = this.order;
        return data;
    }

    clone(): SafetyReportConfigurationEntry {
        const json = this.toJSON();
        let result = new SafetyReportConfigurationEntry();
        result.init(json);
        return result;
    }
}

export interface ISafetyReportConfigurationEntry {
    fieldDefinitionId?: string;
    fieldIdentifier?: string | undefined;
    fieldDisplayKey?: string | undefined;
    fieldDefinitionType?: string | undefined;
    parentGroupingFieldIdentifier?: string | undefined;
    parentGroupingFieldDisplayKey?: string | undefined;
    isSelected?: boolean;
    referenceIdentifier?: string | undefined;
    referenceDisplayKey?: string | undefined;
    isStandaloneInstrument?: boolean;
    order?: number;
}

export class SafetyReportConfigurationUpdateDto implements ISafetyReportConfigurationUpdateDto {
    fieldDefinitionIds?: SafetyReportConfigurationUpdateEntry[] | undefined;

    constructor(data?: ISafetyReportConfigurationUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fieldDefinitionIds"])) {
                this.fieldDefinitionIds = [] as any;
                for (let item of _data["fieldDefinitionIds"])
                    this.fieldDefinitionIds!.push(SafetyReportConfigurationUpdateEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafetyReportConfigurationUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyReportConfigurationUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldDefinitionIds)) {
            data["fieldDefinitionIds"] = [];
            for (let item of this.fieldDefinitionIds)
                data["fieldDefinitionIds"].push(item.toJSON());
        }
        return data;
    }

    clone(): SafetyReportConfigurationUpdateDto {
        const json = this.toJSON();
        let result = new SafetyReportConfigurationUpdateDto();
        result.init(json);
        return result;
    }
}

export interface ISafetyReportConfigurationUpdateDto {
    fieldDefinitionIds?: SafetyReportConfigurationUpdateEntry[] | undefined;
}

export class SafetyReportConfigurationUpdateEntry implements ISafetyReportConfigurationUpdateEntry {
    fieldDefinitionId?: string;

    constructor(data?: ISafetyReportConfigurationUpdateEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldDefinitionId = _data["fieldDefinitionId"];
        }
    }

    static fromJS(data: any): SafetyReportConfigurationUpdateEntry {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyReportConfigurationUpdateEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldDefinitionId"] = this.fieldDefinitionId;
        return data;
    }

    clone(): SafetyReportConfigurationUpdateEntry {
        const json = this.toJSON();
        let result = new SafetyReportConfigurationUpdateEntry();
        result.init(json);
        return result;
    }
}

export interface ISafetyReportConfigurationUpdateEntry {
    fieldDefinitionId?: string;
}

export class EventReportOverviewDto implements IEventReportOverviewDto {
    institutes?: StudyPatientInstituteDto[] | undefined;
    studyPatients?: StudyPatientShortDto[] | undefined;
    eventReports?: EventReportItemDto[] | undefined;

    constructor(data?: IEventReportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["institutes"])) {
                this.institutes = [] as any;
                for (let item of _data["institutes"])
                    this.institutes!.push(StudyPatientInstituteDto.fromJS(item));
            }
            if (Array.isArray(_data["studyPatients"])) {
                this.studyPatients = [] as any;
                for (let item of _data["studyPatients"])
                    this.studyPatients!.push(StudyPatientShortDto.fromJS(item));
            }
            if (Array.isArray(_data["eventReports"])) {
                this.eventReports = [] as any;
                for (let item of _data["eventReports"])
                    this.eventReports!.push(EventReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventReportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.institutes)) {
            data["institutes"] = [];
            for (let item of this.institutes)
                data["institutes"].push(item.toJSON());
        }
        if (Array.isArray(this.studyPatients)) {
            data["studyPatients"] = [];
            for (let item of this.studyPatients)
                data["studyPatients"].push(item.toJSON());
        }
        if (Array.isArray(this.eventReports)) {
            data["eventReports"] = [];
            for (let item of this.eventReports)
                data["eventReports"].push(item.toJSON());
        }
        return data;
    }

    clone(): EventReportOverviewDto {
        const json = this.toJSON();
        let result = new EventReportOverviewDto();
        result.init(json);
        return result;
    }
}

export interface IEventReportOverviewDto {
    institutes?: StudyPatientInstituteDto[] | undefined;
    studyPatients?: StudyPatientShortDto[] | undefined;
    eventReports?: EventReportItemDto[] | undefined;
}

export class StudyPatientInstituteDto extends BaseIdDto implements IStudyPatientInstituteDto {
    identifier?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IStudyPatientInstituteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StudyPatientInstituteDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientInstituteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): StudyPatientInstituteDto {
        const json = this.toJSON();
        let result = new StudyPatientInstituteDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientInstituteDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
}

export class StudyPatientShortDto extends BaseDto implements IStudyPatientShortDto {
    patientId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    locked?: boolean;
    registrationDate?: Date | undefined;
    studyInstitute?: StudyPatientInstituteDto | undefined;
    tags?: any | undefined;

    constructor(data?: IStudyPatientShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.locked = _data["locked"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.studyInstitute = _data["studyInstitute"] ? StudyPatientInstituteDto.fromJS(_data["studyInstitute"]) : <any>undefined;
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): StudyPatientShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["locked"] = this.locked;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["studyInstitute"] = this.studyInstitute ? this.studyInstitute.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): StudyPatientShortDto {
        const json = this.toJSON();
        let result = new StudyPatientShortDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientShortDto extends IBaseDto {
    patientId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    locked?: boolean;
    registrationDate?: Date | undefined;
    studyInstitute?: StudyPatientInstituteDto | undefined;
    tags?: any | undefined;
}

export class EventReportItemDto implements IEventReportItemDto {
    reportId?: string;
    instituteId?: string;
    studyPatientId?: string;
    identifier?: string | undefined;
    eventName?: string | undefined;
    reportNumber?: number;
    referenceId?: string;
    creationDate?: Date | undefined;
    sendDate?: Date | undefined;
    isActive?: boolean;
    isDeactivated?: boolean;
    deactivationUserName?: string | undefined;
    deactivationUserDisplayName?: string | undefined;
    deactivationDate?: Date | undefined;
    deactivationReason?: string | undefined;
    isSigned?: boolean;
    signature?: SignatureDataDto | undefined;
    instrumentId?: string;
    instrumentDefinitionId?: string;
    instrumentFieldDeleted?: boolean;
    tags?: any | undefined;

    constructor(data?: IEventReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.instituteId = _data["instituteId"];
            this.studyPatientId = _data["studyPatientId"];
            this.identifier = _data["identifier"];
            this.eventName = _data["eventName"];
            this.reportNumber = _data["reportNumber"];
            this.referenceId = _data["referenceId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeactivated = _data["isDeactivated"];
            this.deactivationUserName = _data["deactivationUserName"];
            this.deactivationUserDisplayName = _data["deactivationUserDisplayName"];
            this.deactivationDate = _data["deactivationDate"] ? new Date(_data["deactivationDate"].toString()) : <any>undefined;
            this.deactivationReason = _data["deactivationReason"];
            this.isSigned = _data["isSigned"];
            this.signature = _data["signature"] ? SignatureDataDto.fromJS(_data["signature"]) : <any>undefined;
            this.instrumentId = _data["instrumentId"];
            this.instrumentDefinitionId = _data["instrumentDefinitionId"];
            this.instrumentFieldDeleted = _data["instrumentFieldDeleted"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): EventReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["instituteId"] = this.instituteId;
        data["studyPatientId"] = this.studyPatientId;
        data["identifier"] = this.identifier;
        data["eventName"] = this.eventName;
        data["reportNumber"] = this.reportNumber;
        data["referenceId"] = this.referenceId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeactivated"] = this.isDeactivated;
        data["deactivationUserName"] = this.deactivationUserName;
        data["deactivationUserDisplayName"] = this.deactivationUserDisplayName;
        data["deactivationDate"] = this.deactivationDate ? this.deactivationDate.toISOString() : <any>undefined;
        data["deactivationReason"] = this.deactivationReason;
        data["isSigned"] = this.isSigned;
        data["signature"] = this.signature ? this.signature.toJSON() : <any>undefined;
        data["instrumentId"] = this.instrumentId;
        data["instrumentDefinitionId"] = this.instrumentDefinitionId;
        data["instrumentFieldDeleted"] = this.instrumentFieldDeleted;
        data["tags"] = this.tags;
        return data;
    }

    clone(): EventReportItemDto {
        const json = this.toJSON();
        let result = new EventReportItemDto();
        result.init(json);
        return result;
    }
}

export interface IEventReportItemDto {
    reportId?: string;
    instituteId?: string;
    studyPatientId?: string;
    identifier?: string | undefined;
    eventName?: string | undefined;
    reportNumber?: number;
    referenceId?: string;
    creationDate?: Date | undefined;
    sendDate?: Date | undefined;
    isActive?: boolean;
    isDeactivated?: boolean;
    deactivationUserName?: string | undefined;
    deactivationUserDisplayName?: string | undefined;
    deactivationDate?: Date | undefined;
    deactivationReason?: string | undefined;
    isSigned?: boolean;
    signature?: SignatureDataDto | undefined;
    instrumentId?: string;
    instrumentDefinitionId?: string;
    instrumentFieldDeleted?: boolean;
    tags?: any | undefined;
}

export class SignatureDataDto extends BaseIdDto implements ISignatureDataDto {
    referenceId?: string;
    referenceType?: string | undefined;
    timeStamp?: Date;
    reason?: string | undefined;
    signature?: string | undefined;
    signingUserId?: string;
    signingUserName?: string | undefined;
    signingUserDisplayName?: string | undefined;

    constructor(data?: ISignatureDataDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.referenceType = _data["referenceType"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.signature = _data["signature"];
            this.signingUserId = _data["signingUserId"];
            this.signingUserName = _data["signingUserName"];
            this.signingUserDisplayName = _data["signingUserDisplayName"];
        }
    }

    static fromJS(data: any): SignatureDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["referenceType"] = this.referenceType;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["signature"] = this.signature;
        data["signingUserId"] = this.signingUserId;
        data["signingUserName"] = this.signingUserName;
        data["signingUserDisplayName"] = this.signingUserDisplayName;
        super.toJSON(data);
        return data;
    }

    clone(): SignatureDataDto {
        const json = this.toJSON();
        let result = new SignatureDataDto();
        result.init(json);
        return result;
    }
}

export interface ISignatureDataDto extends IBaseIdDto {
    referenceId?: string;
    referenceType?: string | undefined;
    timeStamp?: Date;
    reason?: string | undefined;
    signature?: string | undefined;
    signingUserId?: string;
    signingUserName?: string | undefined;
    signingUserDisplayName?: string | undefined;
}

export class StudyShortDto extends BaseDto implements IStudyShortDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IStudyShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StudyShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): StudyShortDto {
        const json = this.toJSON();
        let result = new StudyShortDto();
        result.init(json);
        return result;
    }
}

export interface IStudyShortDto extends IBaseDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
}

export class StudyDto extends BaseDto implements IStudyDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IStudyDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): StudyDto {
        const json = this.toJSON();
        let result = new StudyDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDto extends IBaseDto {
    studyDefinitionId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
}

export class StudyCreateDto implements IStudyCreateDto {
    studyDefinitionId!: string;
    identifier!: string;
    displayName!: string;

    constructor(data?: IStudyCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StudyCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): StudyCreateDto {
        const json = this.toJSON();
        let result = new StudyCreateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyCreateDto {
    studyDefinitionId: string;
    identifier: string;
    displayName: string;
}

export class StudyUpdateDto extends BaseIdDto implements IStudyUpdateDto {
    identifier!: string;
    displayName!: string;

    constructor(data?: IStudyUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StudyUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): StudyUpdateDto {
        const json = this.toJSON();
        let result = new StudyUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyUpdateDto extends IBaseIdDto {
    identifier: string;
    displayName: string;
}

export class StudyDefinitionShortDto extends BaseDto implements IStudyDefinitionShortDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    patient?: PatientDefinitionShortDto | undefined;

    constructor(data?: IStudyDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.patient = _data["patient"] ? PatientDefinitionShortDto.fromJS(_data["patient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StudyDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): StudyDefinitionShortDto {
        const json = this.toJSON();
        let result = new StudyDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    patient?: PatientDefinitionShortDto | undefined;
}

export class StudyDefinitionDto extends BaseDto implements IStudyDefinitionDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    version?: string | undefined;
    ethicDate?: Date | undefined;
    goLiveDate?: Date | undefined;
    patient?: PatientDefinitionDto | undefined;
    instruments?: InstrumentDefinitionDto[] | undefined;
    verificationFlagTypes?: VerificationFlagTypeDefinitionDto[] | undefined;
    visits?: VisitDefinitionDto[] | undefined;
    queryTypes?: QueryTypeDefinitionDto[] | undefined;
    constraints?: ConstraintDefinitionDto[] | undefined;
    enumValueSets?: EnumValueSetDto[] | undefined;
    standaloneInstruments?: StudyDefinitionStandaloneInstrumentDto[] | undefined;
    standaloneInstrumentGroups?: InstrumentGroupDefinitionDto[] | undefined;

    constructor(data?: IStudyDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.version = _data["version"];
            this.ethicDate = _data["ethicDate"] ? new Date(_data["ethicDate"].toString()) : <any>undefined;
            this.goLiveDate = _data["goLiveDate"] ? new Date(_data["goLiveDate"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? PatientDefinitionDto.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["instruments"])
                    this.instruments!.push(InstrumentDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["verificationFlagTypes"])) {
                this.verificationFlagTypes = [] as any;
                for (let item of _data["verificationFlagTypes"])
                    this.verificationFlagTypes!.push(VerificationFlagTypeDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["visits"])) {
                this.visits = [] as any;
                for (let item of _data["visits"])
                    this.visits!.push(VisitDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["queryTypes"])) {
                this.queryTypes = [] as any;
                for (let item of _data["queryTypes"])
                    this.queryTypes!.push(QueryTypeDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["constraints"])) {
                this.constraints = [] as any;
                for (let item of _data["constraints"])
                    this.constraints!.push(ConstraintDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["enumValueSets"])) {
                this.enumValueSets = [] as any;
                for (let item of _data["enumValueSets"])
                    this.enumValueSets!.push(EnumValueSetDto.fromJS(item));
            }
            if (Array.isArray(_data["standaloneInstruments"])) {
                this.standaloneInstruments = [] as any;
                for (let item of _data["standaloneInstruments"])
                    this.standaloneInstruments!.push(StudyDefinitionStandaloneInstrumentDto.fromJS(item));
            }
            if (Array.isArray(_data["standaloneInstrumentGroups"])) {
                this.standaloneInstrumentGroups = [] as any;
                for (let item of _data["standaloneInstrumentGroups"])
                    this.standaloneInstrumentGroups!.push(InstrumentGroupDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["version"] = this.version;
        data["ethicDate"] = this.ethicDate ? this.ethicDate.toISOString() : <any>undefined;
        data["goLiveDate"] = this.goLiveDate ? this.goLiveDate.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.instruments)) {
            data["instruments"] = [];
            for (let item of this.instruments)
                data["instruments"].push(item.toJSON());
        }
        if (Array.isArray(this.verificationFlagTypes)) {
            data["verificationFlagTypes"] = [];
            for (let item of this.verificationFlagTypes)
                data["verificationFlagTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.visits)) {
            data["visits"] = [];
            for (let item of this.visits)
                data["visits"].push(item.toJSON());
        }
        if (Array.isArray(this.queryTypes)) {
            data["queryTypes"] = [];
            for (let item of this.queryTypes)
                data["queryTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.constraints)) {
            data["constraints"] = [];
            for (let item of this.constraints)
                data["constraints"].push(item.toJSON());
        }
        if (Array.isArray(this.enumValueSets)) {
            data["enumValueSets"] = [];
            for (let item of this.enumValueSets)
                data["enumValueSets"].push(item.toJSON());
        }
        if (Array.isArray(this.standaloneInstruments)) {
            data["standaloneInstruments"] = [];
            for (let item of this.standaloneInstruments)
                data["standaloneInstruments"].push(item.toJSON());
        }
        if (Array.isArray(this.standaloneInstrumentGroups)) {
            data["standaloneInstrumentGroups"] = [];
            for (let item of this.standaloneInstrumentGroups)
                data["standaloneInstrumentGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): StudyDefinitionDto {
        const json = this.toJSON();
        let result = new StudyDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    version?: string | undefined;
    ethicDate?: Date | undefined;
    goLiveDate?: Date | undefined;
    patient?: PatientDefinitionDto | undefined;
    instruments?: InstrumentDefinitionDto[] | undefined;
    verificationFlagTypes?: VerificationFlagTypeDefinitionDto[] | undefined;
    visits?: VisitDefinitionDto[] | undefined;
    queryTypes?: QueryTypeDefinitionDto[] | undefined;
    constraints?: ConstraintDefinitionDto[] | undefined;
    enumValueSets?: EnumValueSetDto[] | undefined;
    standaloneInstruments?: StudyDefinitionStandaloneInstrumentDto[] | undefined;
    standaloneInstrumentGroups?: InstrumentGroupDefinitionDto[] | undefined;
}

export class VerificationFlagTypeDefinitionDto extends BaseIdDto implements IVerificationFlagTypeDefinitionDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fieldDefinitionIds?: string[] | undefined;
    visitDefinitionIds?: string[] | undefined;
    isDeleted?: boolean;

    constructor(data?: IVerificationFlagTypeDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fieldDefinitionIds"])) {
                this.fieldDefinitionIds = [] as any;
                for (let item of _data["fieldDefinitionIds"])
                    this.fieldDefinitionIds!.push(item);
            }
            if (Array.isArray(_data["visitDefinitionIds"])) {
                this.visitDefinitionIds = [] as any;
                for (let item of _data["visitDefinitionIds"])
                    this.visitDefinitionIds!.push(item);
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): VerificationFlagTypeDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagTypeDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fieldDefinitionIds)) {
            data["fieldDefinitionIds"] = [];
            for (let item of this.fieldDefinitionIds)
                data["fieldDefinitionIds"].push(item);
        }
        if (Array.isArray(this.visitDefinitionIds)) {
            data["visitDefinitionIds"] = [];
            for (let item of this.visitDefinitionIds)
                data["visitDefinitionIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }

    clone(): VerificationFlagTypeDefinitionDto {
        const json = this.toJSON();
        let result = new VerificationFlagTypeDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagTypeDefinitionDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fieldDefinitionIds?: string[] | undefined;
    visitDefinitionIds?: string[] | undefined;
    isDeleted?: boolean;
}

export class VisitDefinitionDto extends BaseDto implements IVisitDefinitionDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    fields?: DataFieldDefinitionDto[] | undefined;
    instruments?: VisitInstrumentDefinitionDto[] | undefined;
    instrumentGroups?: InstrumentGroupDefinitionDto[] | undefined;

    constructor(data?: IVisitDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["instruments"])
                    this.instruments!.push(VisitInstrumentDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["instrumentGroups"])) {
                this.instrumentGroups = [] as any;
                for (let item of _data["instrumentGroups"])
                    this.instrumentGroups!.push(InstrumentGroupDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisitDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.instruments)) {
            data["instruments"] = [];
            for (let item of this.instruments)
                data["instruments"].push(item.toJSON());
        }
        if (Array.isArray(this.instrumentGroups)) {
            data["instrumentGroups"] = [];
            for (let item of this.instrumentGroups)
                data["instrumentGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): VisitDefinitionDto {
        const json = this.toJSON();
        let result = new VisitDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IVisitDefinitionDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    fields?: DataFieldDefinitionDto[] | undefined;
    instruments?: VisitInstrumentDefinitionDto[] | undefined;
    instrumentGroups?: InstrumentGroupDefinitionDto[] | undefined;
}

export class VisitInstrumentDefinitionDto extends BaseDto implements IVisitInstrumentDefinitionDto {
    instrumentDefinitionId!: string;
    definitionType!: string;
    definition?: any | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;

    constructor(data?: IVisitInstrumentDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instrumentDefinitionId = _data["instrumentDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionDto.fromJS(item));
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): VisitInstrumentDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitInstrumentDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instrumentDefinitionId"] = this.instrumentDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): VisitInstrumentDefinitionDto {
        const json = this.toJSON();
        let result = new VisitInstrumentDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IVisitInstrumentDefinitionDto extends IBaseDto {
    instrumentDefinitionId: string;
    definitionType: string;
    definition?: any | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;
}

export class InstrumentGroupDefinitionDto extends BaseDto implements IInstrumentGroupDefinitionDto {
    identifier!: string;
    displayKey!: string;
    definitionType!: string;
    definition?: any | undefined;
    parentInstrumentGroupId?: string | undefined;
    order?: number;

    constructor(data?: IInstrumentGroupDefinitionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            this.parentInstrumentGroupId = _data["parentInstrumentGroupId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InstrumentGroupDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentGroupDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        data["parentInstrumentGroupId"] = this.parentInstrumentGroupId;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentGroupDefinitionDto {
        const json = this.toJSON();
        let result = new InstrumentGroupDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentGroupDefinitionDto extends IBaseDto {
    identifier: string;
    displayKey: string;
    definitionType: string;
    definition?: any | undefined;
    parentInstrumentGroupId?: string | undefined;
    order?: number;
}

export class StudyDefinitionStandaloneInstrumentDto extends BaseDto implements IStudyDefinitionStandaloneInstrumentDto {
    instrumentDefinitionId!: string;
    definitionType!: string;
    definition?: any | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;

    constructor(data?: IStudyDefinitionStandaloneInstrumentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instrumentDefinitionId = _data["instrumentDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionDto.fromJS(item));
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): StudyDefinitionStandaloneInstrumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionStandaloneInstrumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instrumentDefinitionId"] = this.instrumentDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): StudyDefinitionStandaloneInstrumentDto {
        const json = this.toJSON();
        let result = new StudyDefinitionStandaloneInstrumentDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionStandaloneInstrumentDto extends IBaseDto {
    instrumentDefinitionId: string;
    definitionType: string;
    definition?: any | undefined;
    rules?: RuleDefinitionDto[] | undefined;
    order?: number;
}

export class StudyDefinitionCreateDto extends BaseIdDto implements IStudyDefinitionCreateDto {
    identifier!: string;
    displayKey!: string;
    version!: string;
    ethicDate!: Date;
    goLiveDate!: Date;
    patient!: StudyDefinitionPatientChangeDto;
    instruments?: StudyDefinitionInstrumentChangeDto[] | undefined;
    verificationFlagTypes?: StudyDefinitionVerificationFlagTypeChangeDto[] | undefined;
    visits?: StudyDefinitionVisitChangeDto[] | undefined;
    standaloneInstruments?: StudyDefinitionStandaloneInstrumentChangeDto[] | undefined;
    standaloneInstrumentGroups?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;
    queryTypes?: StudyDefinitionQueryTypeChangeDto[] | undefined;
    rules?: RuleDefinitionCreateDto[] | undefined;
    constraints?: StudyDefinitionConstraintChangeDto[] | undefined;
    enumValueSets?: StudyDefinitionEnumValueSetChangeDto[] | undefined;

    constructor(data?: IStudyDefinitionCreateDto) {
        super(data);
        if (!data) {
            this.patient = new StudyDefinitionPatientChangeDto();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.version = _data["version"];
            this.ethicDate = _data["ethicDate"] ? new Date(_data["ethicDate"].toString()) : <any>undefined;
            this.goLiveDate = _data["goLiveDate"] ? new Date(_data["goLiveDate"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? StudyDefinitionPatientChangeDto.fromJS(_data["patient"]) : new StudyDefinitionPatientChangeDto();
            if (Array.isArray(_data["instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["instruments"])
                    this.instruments!.push(StudyDefinitionInstrumentChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["verificationFlagTypes"])) {
                this.verificationFlagTypes = [] as any;
                for (let item of _data["verificationFlagTypes"])
                    this.verificationFlagTypes!.push(StudyDefinitionVerificationFlagTypeChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["visits"])) {
                this.visits = [] as any;
                for (let item of _data["visits"])
                    this.visits!.push(StudyDefinitionVisitChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["standaloneInstruments"])) {
                this.standaloneInstruments = [] as any;
                for (let item of _data["standaloneInstruments"])
                    this.standaloneInstruments!.push(StudyDefinitionStandaloneInstrumentChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["standaloneInstrumentGroups"])) {
                this.standaloneInstrumentGroups = [] as any;
                for (let item of _data["standaloneInstrumentGroups"])
                    this.standaloneInstrumentGroups!.push(StudyDefinitionInstrumentGroupChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["queryTypes"])) {
                this.queryTypes = [] as any;
                for (let item of _data["queryTypes"])
                    this.queryTypes!.push(StudyDefinitionQueryTypeChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionCreateDto.fromJS(item));
            }
            if (Array.isArray(_data["constraints"])) {
                this.constraints = [] as any;
                for (let item of _data["constraints"])
                    this.constraints!.push(StudyDefinitionConstraintChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["enumValueSets"])) {
                this.enumValueSets = [] as any;
                for (let item of _data["enumValueSets"])
                    this.enumValueSets!.push(StudyDefinitionEnumValueSetChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["version"] = this.version;
        data["ethicDate"] = this.ethicDate ? this.ethicDate.toISOString() : <any>undefined;
        data["goLiveDate"] = this.goLiveDate ? this.goLiveDate.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.instruments)) {
            data["instruments"] = [];
            for (let item of this.instruments)
                data["instruments"].push(item.toJSON());
        }
        if (Array.isArray(this.verificationFlagTypes)) {
            data["verificationFlagTypes"] = [];
            for (let item of this.verificationFlagTypes)
                data["verificationFlagTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.visits)) {
            data["visits"] = [];
            for (let item of this.visits)
                data["visits"].push(item.toJSON());
        }
        if (Array.isArray(this.standaloneInstruments)) {
            data["standaloneInstruments"] = [];
            for (let item of this.standaloneInstruments)
                data["standaloneInstruments"].push(item.toJSON());
        }
        if (Array.isArray(this.standaloneInstrumentGroups)) {
            data["standaloneInstrumentGroups"] = [];
            for (let item of this.standaloneInstrumentGroups)
                data["standaloneInstrumentGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.queryTypes)) {
            data["queryTypes"] = [];
            for (let item of this.queryTypes)
                data["queryTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.constraints)) {
            data["constraints"] = [];
            for (let item of this.constraints)
                data["constraints"].push(item.toJSON());
        }
        if (Array.isArray(this.enumValueSets)) {
            data["enumValueSets"] = [];
            for (let item of this.enumValueSets)
                data["enumValueSets"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): StudyDefinitionCreateDto {
        const json = this.toJSON();
        let result = new StudyDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionCreateDto extends IBaseIdDto {
    identifier: string;
    displayKey: string;
    version: string;
    ethicDate: Date;
    goLiveDate: Date;
    patient: StudyDefinitionPatientChangeDto;
    instruments?: StudyDefinitionInstrumentChangeDto[] | undefined;
    verificationFlagTypes?: StudyDefinitionVerificationFlagTypeChangeDto[] | undefined;
    visits?: StudyDefinitionVisitChangeDto[] | undefined;
    standaloneInstruments?: StudyDefinitionStandaloneInstrumentChangeDto[] | undefined;
    standaloneInstrumentGroups?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;
    queryTypes?: StudyDefinitionQueryTypeChangeDto[] | undefined;
    rules?: RuleDefinitionCreateDto[] | undefined;
    constraints?: StudyDefinitionConstraintChangeDto[] | undefined;
    enumValueSets?: StudyDefinitionEnumValueSetChangeDto[] | undefined;
}

export class StudyDefinitionPatientChangeDto implements IStudyDefinitionPatientChangeDto {
    id!: string;
    definitionType!: string;
    definition?: any | undefined;
    fields?: StudyDefinitionDataFieldChangeDto[] | undefined;
    identifier!: string;
    displayKey!: string;

    constructor(data?: IStudyDefinitionPatientChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(StudyDefinitionDataFieldChangeDto.fromJS(item));
            }
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
        }
    }

    static fromJS(data: any): StudyDefinitionPatientChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionPatientChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        return data;
    }

    clone(): StudyDefinitionPatientChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionPatientChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionPatientChangeDto {
    id: string;
    definitionType: string;
    definition?: any | undefined;
    fields?: StudyDefinitionDataFieldChangeDto[] | undefined;
    identifier: string;
    displayKey: string;
}

export class StudyDefinitionDataFieldChangeDto implements IStudyDefinitionDataFieldChangeDto {
    id!: string;
    identifier!: string;
    displayKey!: string;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    childDataFieldDefinitions?: StudyDefinitionDataFieldChangeDto[] | undefined;
    order!: number;
    definitionType!: string;
    definition?: any | undefined;

    constructor(data?: IStudyDefinitionDataFieldChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(StudyDefinitionRuleChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["childDataFieldDefinitions"])) {
                this.childDataFieldDefinitions = [] as any;
                for (let item of _data["childDataFieldDefinitions"])
                    this.childDataFieldDefinitions!.push(StudyDefinitionDataFieldChangeDto.fromJS(item));
            }
            this.order = _data["order"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): StudyDefinitionDataFieldChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionDataFieldChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.childDataFieldDefinitions)) {
            data["childDataFieldDefinitions"] = [];
            for (let item of this.childDataFieldDefinitions)
                data["childDataFieldDefinitions"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        return data;
    }

    clone(): StudyDefinitionDataFieldChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionDataFieldChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionDataFieldChangeDto {
    id: string;
    identifier: string;
    displayKey: string;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    childDataFieldDefinitions?: StudyDefinitionDataFieldChangeDto[] | undefined;
    order: number;
    definitionType: string;
    definition?: any | undefined;
}

export class StudyDefinitionRuleChangeDto implements IStudyDefinitionRuleChangeDto {
    definitionType!: string;
    definition?: any | undefined;
    constraintExpression?: StudyDefinitionConstraintExpressionChangeDto | undefined;
    order?: number;
    identifier!: string;
    displayKey!: string;

    constructor(data?: IStudyDefinitionRuleChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            this.constraintExpression = _data["constraintExpression"] ? StudyDefinitionConstraintExpressionChangeDto.fromJS(_data["constraintExpression"]) : <any>undefined;
            this.order = _data["order"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
        }
    }

    static fromJS(data: any): StudyDefinitionRuleChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionRuleChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        data["constraintExpression"] = this.constraintExpression ? this.constraintExpression.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        return data;
    }

    clone(): StudyDefinitionRuleChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionRuleChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionRuleChangeDto {
    definitionType: string;
    definition?: any | undefined;
    constraintExpression?: StudyDefinitionConstraintExpressionChangeDto | undefined;
    order?: number;
    identifier: string;
    displayKey: string;
}

export class StudyDefinitionConstraintExpressionChangeDto implements IStudyDefinitionConstraintExpressionChangeDto {
    operator!: ConstrainOperator;
    constraintDefinitionIdentifier?: string | undefined;
    expressions?: StudyDefinitionConstraintExpressionChangeDto[] | undefined;

    constructor(data?: IStudyDefinitionConstraintExpressionChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.constraintDefinitionIdentifier = _data["constraintDefinitionIdentifier"];
            if (Array.isArray(_data["expressions"])) {
                this.expressions = [] as any;
                for (let item of _data["expressions"])
                    this.expressions!.push(StudyDefinitionConstraintExpressionChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyDefinitionConstraintExpressionChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionConstraintExpressionChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["constraintDefinitionIdentifier"] = this.constraintDefinitionIdentifier;
        if (Array.isArray(this.expressions)) {
            data["expressions"] = [];
            for (let item of this.expressions)
                data["expressions"].push(item.toJSON());
        }
        return data;
    }

    clone(): StudyDefinitionConstraintExpressionChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionConstraintExpressionChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionConstraintExpressionChangeDto {
    operator: ConstrainOperator;
    constraintDefinitionIdentifier?: string | undefined;
    expressions?: StudyDefinitionConstraintExpressionChangeDto[] | undefined;
}

export class StudyDefinitionInstrumentChangeDto implements IStudyDefinitionInstrumentChangeDto {
    id!: string;
    order?: number;
    definitionType!: string;
    definition?: any | undefined;
    fields?: StudyDefinitionDataFieldChangeDto[] | undefined;
    identifier!: string;
    displayKey!: string;

    constructor(data?: IStudyDefinitionInstrumentChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(StudyDefinitionDataFieldChangeDto.fromJS(item));
            }
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
        }
    }

    static fromJS(data: any): StudyDefinitionInstrumentChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionInstrumentChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        return data;
    }

    clone(): StudyDefinitionInstrumentChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionInstrumentChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionInstrumentChangeDto {
    id: string;
    order?: number;
    definitionType: string;
    definition?: any | undefined;
    fields?: StudyDefinitionDataFieldChangeDto[] | undefined;
    identifier: string;
    displayKey: string;
}

export class StudyDefinitionVerificationFlagTypeChangeDto implements IStudyDefinitionVerificationFlagTypeChangeDto {
    id!: string;
    definitionType!: string;
    identifier!: string;
    displayKey!: string;
    order?: number;
    definition?: any | undefined;

    constructor(data?: IStudyDefinitionVerificationFlagTypeChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.definitionType = _data["definitionType"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): StudyDefinitionVerificationFlagTypeChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionVerificationFlagTypeChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["definitionType"] = this.definitionType;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["definition"] = this.definition;
        return data;
    }

    clone(): StudyDefinitionVerificationFlagTypeChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionVerificationFlagTypeChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionVerificationFlagTypeChangeDto {
    id: string;
    definitionType: string;
    identifier: string;
    displayKey: string;
    order?: number;
    definition?: any | undefined;
}

export class StudyDefinitionVisitChangeDto implements IStudyDefinitionVisitChangeDto {
    id!: string;
    order?: number;
    definitionType!: string;
    definition?: any | undefined;
    instruments?: StudyDefinitionVisitInstrumentChangeDto[] | undefined;
    instrumentGroups?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    fields?: StudyDefinitionDataFieldChangeDto[] | undefined;
    identifier!: string;
    displayKey!: string;

    constructor(data?: IStudyDefinitionVisitChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["instruments"])
                    this.instruments!.push(StudyDefinitionVisitInstrumentChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["instrumentGroups"])) {
                this.instrumentGroups = [] as any;
                for (let item of _data["instrumentGroups"])
                    this.instrumentGroups!.push(StudyDefinitionInstrumentGroupChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(StudyDefinitionRuleChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(StudyDefinitionDataFieldChangeDto.fromJS(item));
            }
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
        }
    }

    static fromJS(data: any): StudyDefinitionVisitChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionVisitChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.instruments)) {
            data["instruments"] = [];
            for (let item of this.instruments)
                data["instruments"].push(item.toJSON());
        }
        if (Array.isArray(this.instrumentGroups)) {
            data["instrumentGroups"] = [];
            for (let item of this.instrumentGroups)
                data["instrumentGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        return data;
    }

    clone(): StudyDefinitionVisitChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionVisitChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionVisitChangeDto {
    id: string;
    order?: number;
    definitionType: string;
    definition?: any | undefined;
    instruments?: StudyDefinitionVisitInstrumentChangeDto[] | undefined;
    instrumentGroups?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    fields?: StudyDefinitionDataFieldChangeDto[] | undefined;
    identifier: string;
    displayKey: string;
}

export class StudyDefinitionVisitInstrumentChangeDto extends BaseIdDto implements IStudyDefinitionVisitInstrumentChangeDto {
    instrumentIdentifier!: string;
    definitionType!: string;
    definition?: any | undefined;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    order?: number;

    constructor(data?: IStudyDefinitionVisitInstrumentChangeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instrumentIdentifier = _data["instrumentIdentifier"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(StudyDefinitionRuleChangeDto.fromJS(item));
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): StudyDefinitionVisitInstrumentChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionVisitInstrumentChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instrumentIdentifier"] = this.instrumentIdentifier;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): StudyDefinitionVisitInstrumentChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionVisitInstrumentChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionVisitInstrumentChangeDto extends IBaseIdDto {
    instrumentIdentifier: string;
    definitionType: string;
    definition?: any | undefined;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    order?: number;
}

export class StudyDefinitionInstrumentGroupChangeDto implements IStudyDefinitionInstrumentGroupChangeDto {
    id!: string;
    identifier!: string;
    displayKey!: string;
    order?: number;
    definitionType!: string;
    definition?: any | undefined;
    children?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;

    constructor(data?: IStudyDefinitionInstrumentGroupChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(StudyDefinitionInstrumentGroupChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyDefinitionInstrumentGroupChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionInstrumentGroupChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): StudyDefinitionInstrumentGroupChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionInstrumentGroupChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionInstrumentGroupChangeDto {
    id: string;
    identifier: string;
    displayKey: string;
    order?: number;
    definitionType: string;
    definition?: any | undefined;
    children?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;
}

export class StudyDefinitionStandaloneInstrumentChangeDto extends BaseIdDto implements IStudyDefinitionStandaloneInstrumentChangeDto {
    instrumentIdentifier!: string;
    definitionType!: string;
    definition?: any | undefined;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    order?: number;

    constructor(data?: IStudyDefinitionStandaloneInstrumentChangeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instrumentIdentifier = _data["instrumentIdentifier"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(StudyDefinitionRuleChangeDto.fromJS(item));
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): StudyDefinitionStandaloneInstrumentChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionStandaloneInstrumentChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instrumentIdentifier"] = this.instrumentIdentifier;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }

    clone(): StudyDefinitionStandaloneInstrumentChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionStandaloneInstrumentChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionStandaloneInstrumentChangeDto extends IBaseIdDto {
    instrumentIdentifier: string;
    definitionType: string;
    definition?: any | undefined;
    rules?: StudyDefinitionRuleChangeDto[] | undefined;
    order?: number;
}

export class StudyDefinitionQueryTypeChangeDto implements IStudyDefinitionQueryTypeChangeDto {
    id!: string;
    definitionType!: string;
    identifier!: string;
    displayKey!: string;
    order?: number;
    definition?: any | undefined;

    constructor(data?: IStudyDefinitionQueryTypeChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.definitionType = _data["definitionType"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): StudyDefinitionQueryTypeChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionQueryTypeChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["definitionType"] = this.definitionType;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["definition"] = this.definition;
        return data;
    }

    clone(): StudyDefinitionQueryTypeChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionQueryTypeChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionQueryTypeChangeDto {
    id: string;
    definitionType: string;
    identifier: string;
    displayKey: string;
    order?: number;
    definition?: any | undefined;
}

export class StudyDefinitionConstraintChangeDto implements IStudyDefinitionConstraintChangeDto {
    definitionType!: string;
    definition?: any | undefined;
    identifier!: string;
    displayKey!: string;

    constructor(data?: IStudyDefinitionConstraintChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
        }
    }

    static fromJS(data: any): StudyDefinitionConstraintChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionConstraintChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        return data;
    }

    clone(): StudyDefinitionConstraintChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionConstraintChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionConstraintChangeDto {
    definitionType: string;
    definition?: any | undefined;
    identifier: string;
    displayKey: string;
}

export class StudyDefinitionEnumValueSetChangeDto implements IStudyDefinitionEnumValueSetChangeDto {
    values?: StudyDefinitionEnumValueChangeDto[] | undefined;
    isObsolete?: boolean;
    identifier!: string;
    displayKey!: string;

    constructor(data?: IStudyDefinitionEnumValueSetChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(StudyDefinitionEnumValueChangeDto.fromJS(item));
            }
            this.isObsolete = _data["isObsolete"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
        }
    }

    static fromJS(data: any): StudyDefinitionEnumValueSetChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionEnumValueSetChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["isObsolete"] = this.isObsolete;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        return data;
    }

    clone(): StudyDefinitionEnumValueSetChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionEnumValueSetChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionEnumValueSetChangeDto {
    values?: StudyDefinitionEnumValueChangeDto[] | undefined;
    isObsolete?: boolean;
    identifier: string;
    displayKey: string;
}

export class StudyDefinitionEnumValueChangeDto implements IStudyDefinitionEnumValueChangeDto {
    code!: string;
    displayKey!: string;
    isObsolete?: boolean;
    order?: number;

    constructor(data?: IStudyDefinitionEnumValueChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.displayKey = _data["displayKey"];
            this.isObsolete = _data["isObsolete"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): StudyDefinitionEnumValueChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionEnumValueChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayKey"] = this.displayKey;
        data["isObsolete"] = this.isObsolete;
        data["order"] = this.order;
        return data;
    }

    clone(): StudyDefinitionEnumValueChangeDto {
        const json = this.toJSON();
        let result = new StudyDefinitionEnumValueChangeDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionEnumValueChangeDto {
    code: string;
    displayKey: string;
    isObsolete?: boolean;
    order?: number;
}

export class StudyDefinitionUpdateDto extends BaseIdDto implements IStudyDefinitionUpdateDto {
    identifier!: string;
    displayKey!: string;
    version!: string;
    ethicDate!: Date;
    goLiveDate!: Date;
    patient!: StudyDefinitionPatientChangeDto;
    instruments?: StudyDefinitionInstrumentChangeDto[] | undefined;
    verificationFlagTypes?: StudyDefinitionVerificationFlagTypeChangeDto[] | undefined;
    visits?: StudyDefinitionVisitChangeDto[] | undefined;
    standaloneInstruments?: StudyDefinitionStandaloneInstrumentChangeDto[] | undefined;
    standaloneInstrumentGroups?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;
    queryTypes?: StudyDefinitionQueryTypeChangeDto[] | undefined;
    rules?: RuleDefinitionCreateDto[] | undefined;
    constraints?: StudyDefinitionConstraintChangeDto[] | undefined;
    enumValueSets?: StudyDefinitionEnumValueSetChangeDto[] | undefined;

    constructor(data?: IStudyDefinitionUpdateDto) {
        super(data);
        if (!data) {
            this.patient = new StudyDefinitionPatientChangeDto();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.version = _data["version"];
            this.ethicDate = _data["ethicDate"] ? new Date(_data["ethicDate"].toString()) : <any>undefined;
            this.goLiveDate = _data["goLiveDate"] ? new Date(_data["goLiveDate"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? StudyDefinitionPatientChangeDto.fromJS(_data["patient"]) : new StudyDefinitionPatientChangeDto();
            if (Array.isArray(_data["instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["instruments"])
                    this.instruments!.push(StudyDefinitionInstrumentChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["verificationFlagTypes"])) {
                this.verificationFlagTypes = [] as any;
                for (let item of _data["verificationFlagTypes"])
                    this.verificationFlagTypes!.push(StudyDefinitionVerificationFlagTypeChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["visits"])) {
                this.visits = [] as any;
                for (let item of _data["visits"])
                    this.visits!.push(StudyDefinitionVisitChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["standaloneInstruments"])) {
                this.standaloneInstruments = [] as any;
                for (let item of _data["standaloneInstruments"])
                    this.standaloneInstruments!.push(StudyDefinitionStandaloneInstrumentChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["standaloneInstrumentGroups"])) {
                this.standaloneInstrumentGroups = [] as any;
                for (let item of _data["standaloneInstrumentGroups"])
                    this.standaloneInstrumentGroups!.push(StudyDefinitionInstrumentGroupChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["queryTypes"])) {
                this.queryTypes = [] as any;
                for (let item of _data["queryTypes"])
                    this.queryTypes!.push(StudyDefinitionQueryTypeChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDefinitionCreateDto.fromJS(item));
            }
            if (Array.isArray(_data["constraints"])) {
                this.constraints = [] as any;
                for (let item of _data["constraints"])
                    this.constraints!.push(StudyDefinitionConstraintChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["enumValueSets"])) {
                this.enumValueSets = [] as any;
                for (let item of _data["enumValueSets"])
                    this.enumValueSets!.push(StudyDefinitionEnumValueSetChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["version"] = this.version;
        data["ethicDate"] = this.ethicDate ? this.ethicDate.toISOString() : <any>undefined;
        data["goLiveDate"] = this.goLiveDate ? this.goLiveDate.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.instruments)) {
            data["instruments"] = [];
            for (let item of this.instruments)
                data["instruments"].push(item.toJSON());
        }
        if (Array.isArray(this.verificationFlagTypes)) {
            data["verificationFlagTypes"] = [];
            for (let item of this.verificationFlagTypes)
                data["verificationFlagTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.visits)) {
            data["visits"] = [];
            for (let item of this.visits)
                data["visits"].push(item.toJSON());
        }
        if (Array.isArray(this.standaloneInstruments)) {
            data["standaloneInstruments"] = [];
            for (let item of this.standaloneInstruments)
                data["standaloneInstruments"].push(item.toJSON());
        }
        if (Array.isArray(this.standaloneInstrumentGroups)) {
            data["standaloneInstrumentGroups"] = [];
            for (let item of this.standaloneInstrumentGroups)
                data["standaloneInstrumentGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.queryTypes)) {
            data["queryTypes"] = [];
            for (let item of this.queryTypes)
                data["queryTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.constraints)) {
            data["constraints"] = [];
            for (let item of this.constraints)
                data["constraints"].push(item.toJSON());
        }
        if (Array.isArray(this.enumValueSets)) {
            data["enumValueSets"] = [];
            for (let item of this.enumValueSets)
                data["enumValueSets"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): StudyDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new StudyDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionUpdateDto extends IBaseIdDto {
    identifier: string;
    displayKey: string;
    version: string;
    ethicDate: Date;
    goLiveDate: Date;
    patient: StudyDefinitionPatientChangeDto;
    instruments?: StudyDefinitionInstrumentChangeDto[] | undefined;
    verificationFlagTypes?: StudyDefinitionVerificationFlagTypeChangeDto[] | undefined;
    visits?: StudyDefinitionVisitChangeDto[] | undefined;
    standaloneInstruments?: StudyDefinitionStandaloneInstrumentChangeDto[] | undefined;
    standaloneInstrumentGroups?: StudyDefinitionInstrumentGroupChangeDto[] | undefined;
    queryTypes?: StudyDefinitionQueryTypeChangeDto[] | undefined;
    rules?: RuleDefinitionCreateDto[] | undefined;
    constraints?: StudyDefinitionConstraintChangeDto[] | undefined;
    enumValueSets?: StudyDefinitionEnumValueSetChangeDto[] | undefined;
}

export class StudyDefinitionDatesUpdateDto implements IStudyDefinitionDatesUpdateDto {
    ethicDate?: Date | undefined;
    goLiveDate?: Date | undefined;

    constructor(data?: IStudyDefinitionDatesUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ethicDate = _data["ethicDate"] ? new Date(_data["ethicDate"].toString()) : <any>undefined;
            this.goLiveDate = _data["goLiveDate"] ? new Date(_data["goLiveDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StudyDefinitionDatesUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionDatesUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ethicDate"] = this.ethicDate ? this.ethicDate.toISOString() : <any>undefined;
        data["goLiveDate"] = this.goLiveDate ? this.goLiveDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): StudyDefinitionDatesUpdateDto {
        const json = this.toJSON();
        let result = new StudyDefinitionDatesUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionDatesUpdateDto {
    ethicDate?: Date | undefined;
    goLiveDate?: Date | undefined;
}

export class StudyDefinitionImportReportDto implements IStudyDefinitionImportReportDto {
    studyDefinitionId?: string;
    success?: boolean;
    errorMessage?: string | undefined;
    validationReport?: StudyDefinitionValidationReportDto | undefined;
    skipped?: boolean;
    previousVersion?: string | undefined;
    dataImpact?: StudyDefinitionImportDataChangeReport | undefined;
    impactReportFile?: string | undefined;
    validationReportFile?: string | undefined;
    definitionReportFile?: string | undefined;

    constructor(data?: IStudyDefinitionImportReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.validationReport = _data["validationReport"] ? StudyDefinitionValidationReportDto.fromJS(_data["validationReport"]) : <any>undefined;
            this.skipped = _data["skipped"];
            this.previousVersion = _data["previousVersion"];
            this.dataImpact = _data["dataImpact"] ? StudyDefinitionImportDataChangeReport.fromJS(_data["dataImpact"]) : <any>undefined;
            this.impactReportFile = _data["impactReportFile"];
            this.validationReportFile = _data["validationReportFile"];
            this.definitionReportFile = _data["definitionReportFile"];
        }
    }

    static fromJS(data: any): StudyDefinitionImportReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionImportReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["validationReport"] = this.validationReport ? this.validationReport.toJSON() : <any>undefined;
        data["skipped"] = this.skipped;
        data["previousVersion"] = this.previousVersion;
        data["dataImpact"] = this.dataImpact ? this.dataImpact.toJSON() : <any>undefined;
        data["impactReportFile"] = this.impactReportFile;
        data["validationReportFile"] = this.validationReportFile;
        data["definitionReportFile"] = this.definitionReportFile;
        return data;
    }

    clone(): StudyDefinitionImportReportDto {
        const json = this.toJSON();
        let result = new StudyDefinitionImportReportDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionImportReportDto {
    studyDefinitionId?: string;
    success?: boolean;
    errorMessage?: string | undefined;
    validationReport?: StudyDefinitionValidationReportDto | undefined;
    skipped?: boolean;
    previousVersion?: string | undefined;
    dataImpact?: StudyDefinitionImportDataChangeReport | undefined;
    impactReportFile?: string | undefined;
    validationReportFile?: string | undefined;
    definitionReportFile?: string | undefined;
}

export class StudyDefinitionValidationReportDto implements IStudyDefinitionValidationReportDto {
    success?: boolean;
    entries?: StudyDefinitionValidationReportEntryDto[] | undefined;

    constructor(data?: IStudyDefinitionValidationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(StudyDefinitionValidationReportEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyDefinitionValidationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionValidationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }

    clone(): StudyDefinitionValidationReportDto {
        const json = this.toJSON();
        let result = new StudyDefinitionValidationReportDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionValidationReportDto {
    success?: boolean;
    entries?: StudyDefinitionValidationReportEntryDto[] | undefined;
}

export class StudyDefinitionValidationReportEntryDto implements IStudyDefinitionValidationReportEntryDto {
    id?: string;
    definitionType?: string | undefined;
    reportType?: StudyDefinitionValidationReportType;
    message?: string | undefined;

    constructor(data?: IStudyDefinitionValidationReportEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.definitionType = _data["definitionType"];
            this.reportType = _data["reportType"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): StudyDefinitionValidationReportEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionValidationReportEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["definitionType"] = this.definitionType;
        data["reportType"] = this.reportType;
        data["message"] = this.message;
        return data;
    }

    clone(): StudyDefinitionValidationReportEntryDto {
        const json = this.toJSON();
        let result = new StudyDefinitionValidationReportEntryDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionValidationReportEntryDto {
    id?: string;
    definitionType?: string | undefined;
    reportType?: StudyDefinitionValidationReportType;
    message?: string | undefined;
}

export enum StudyDefinitionValidationReportType {
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export class StudyDefinitionImportDataChangeReport implements IStudyDefinitionImportDataChangeReport {
    dataDeletedVisits?: DeletionEntry[] | undefined;
    dataDeletedInstruments?: DeletionEntry[] | undefined;
    dataDeletedInstrumentFields?: DeletionEntry[] | undefined;
    dataDeletedVisitFields?: DeletionEntry[] | undefined;
    dataDeletedPatientFields?: DeletionEntry[] | undefined;
    dataDeletedVerificationFlags?: DeletionEntry[] | undefined;
    dataDeletedQueries?: DeletionEntry[] | undefined;
    dataMigrationNeeded?: MigrationNeededEntry[] | undefined;
    dataChecksNeeded?: MigrationCheckNeededEntry[] | undefined;
    definitionChanges?: DefinitionChangeEntry[] | undefined;

    constructor(data?: IStudyDefinitionImportDataChangeReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataDeletedVisits"])) {
                this.dataDeletedVisits = [] as any;
                for (let item of _data["dataDeletedVisits"])
                    this.dataDeletedVisits!.push(DeletionEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataDeletedInstruments"])) {
                this.dataDeletedInstruments = [] as any;
                for (let item of _data["dataDeletedInstruments"])
                    this.dataDeletedInstruments!.push(DeletionEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataDeletedInstrumentFields"])) {
                this.dataDeletedInstrumentFields = [] as any;
                for (let item of _data["dataDeletedInstrumentFields"])
                    this.dataDeletedInstrumentFields!.push(DeletionEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataDeletedVisitFields"])) {
                this.dataDeletedVisitFields = [] as any;
                for (let item of _data["dataDeletedVisitFields"])
                    this.dataDeletedVisitFields!.push(DeletionEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataDeletedPatientFields"])) {
                this.dataDeletedPatientFields = [] as any;
                for (let item of _data["dataDeletedPatientFields"])
                    this.dataDeletedPatientFields!.push(DeletionEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataDeletedVerificationFlags"])) {
                this.dataDeletedVerificationFlags = [] as any;
                for (let item of _data["dataDeletedVerificationFlags"])
                    this.dataDeletedVerificationFlags!.push(DeletionEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataDeletedQueries"])) {
                this.dataDeletedQueries = [] as any;
                for (let item of _data["dataDeletedQueries"])
                    this.dataDeletedQueries!.push(DeletionEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataMigrationNeeded"])) {
                this.dataMigrationNeeded = [] as any;
                for (let item of _data["dataMigrationNeeded"])
                    this.dataMigrationNeeded!.push(MigrationNeededEntry.fromJS(item));
            }
            if (Array.isArray(_data["dataChecksNeeded"])) {
                this.dataChecksNeeded = [] as any;
                for (let item of _data["dataChecksNeeded"])
                    this.dataChecksNeeded!.push(MigrationCheckNeededEntry.fromJS(item));
            }
            if (Array.isArray(_data["definitionChanges"])) {
                this.definitionChanges = [] as any;
                for (let item of _data["definitionChanges"])
                    this.definitionChanges!.push(DefinitionChangeEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyDefinitionImportDataChangeReport {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionImportDataChangeReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataDeletedVisits)) {
            data["dataDeletedVisits"] = [];
            for (let item of this.dataDeletedVisits)
                data["dataDeletedVisits"].push(item.toJSON());
        }
        if (Array.isArray(this.dataDeletedInstruments)) {
            data["dataDeletedInstruments"] = [];
            for (let item of this.dataDeletedInstruments)
                data["dataDeletedInstruments"].push(item.toJSON());
        }
        if (Array.isArray(this.dataDeletedInstrumentFields)) {
            data["dataDeletedInstrumentFields"] = [];
            for (let item of this.dataDeletedInstrumentFields)
                data["dataDeletedInstrumentFields"].push(item.toJSON());
        }
        if (Array.isArray(this.dataDeletedVisitFields)) {
            data["dataDeletedVisitFields"] = [];
            for (let item of this.dataDeletedVisitFields)
                data["dataDeletedVisitFields"].push(item.toJSON());
        }
        if (Array.isArray(this.dataDeletedPatientFields)) {
            data["dataDeletedPatientFields"] = [];
            for (let item of this.dataDeletedPatientFields)
                data["dataDeletedPatientFields"].push(item.toJSON());
        }
        if (Array.isArray(this.dataDeletedVerificationFlags)) {
            data["dataDeletedVerificationFlags"] = [];
            for (let item of this.dataDeletedVerificationFlags)
                data["dataDeletedVerificationFlags"].push(item.toJSON());
        }
        if (Array.isArray(this.dataDeletedQueries)) {
            data["dataDeletedQueries"] = [];
            for (let item of this.dataDeletedQueries)
                data["dataDeletedQueries"].push(item.toJSON());
        }
        if (Array.isArray(this.dataMigrationNeeded)) {
            data["dataMigrationNeeded"] = [];
            for (let item of this.dataMigrationNeeded)
                data["dataMigrationNeeded"].push(item.toJSON());
        }
        if (Array.isArray(this.dataChecksNeeded)) {
            data["dataChecksNeeded"] = [];
            for (let item of this.dataChecksNeeded)
                data["dataChecksNeeded"].push(item.toJSON());
        }
        if (Array.isArray(this.definitionChanges)) {
            data["definitionChanges"] = [];
            for (let item of this.definitionChanges)
                data["definitionChanges"].push(item.toJSON());
        }
        return data;
    }

    clone(): StudyDefinitionImportDataChangeReport {
        const json = this.toJSON();
        let result = new StudyDefinitionImportDataChangeReport();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionImportDataChangeReport {
    dataDeletedVisits?: DeletionEntry[] | undefined;
    dataDeletedInstruments?: DeletionEntry[] | undefined;
    dataDeletedInstrumentFields?: DeletionEntry[] | undefined;
    dataDeletedVisitFields?: DeletionEntry[] | undefined;
    dataDeletedPatientFields?: DeletionEntry[] | undefined;
    dataDeletedVerificationFlags?: DeletionEntry[] | undefined;
    dataDeletedQueries?: DeletionEntry[] | undefined;
    dataMigrationNeeded?: MigrationNeededEntry[] | undefined;
    dataChecksNeeded?: MigrationCheckNeededEntry[] | undefined;
    definitionChanges?: DefinitionChangeEntry[] | undefined;
}

export class DeletionEntry implements IDeletionEntry {
    definitionId?: string;
    definitionIdentifier?: string | undefined;
    count?: number;
    ids?: string[] | undefined;

    constructor(data?: IDeletionEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.definitionIdentifier = _data["definitionIdentifier"];
            this.count = _data["count"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeletionEntry {
        data = typeof data === 'object' ? data : {};
        let result = new DeletionEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["definitionIdentifier"] = this.definitionIdentifier;
        data["count"] = this.count;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }

    clone(): DeletionEntry {
        const json = this.toJSON();
        let result = new DeletionEntry();
        result.init(json);
        return result;
    }
}

export interface IDeletionEntry {
    definitionId?: string;
    definitionIdentifier?: string | undefined;
    count?: number;
    ids?: string[] | undefined;
}

export class MigrationNeededEntry implements IMigrationNeededEntry {
    definitionId?: string;
    definitionIdentifier?: string | undefined;
    objectType?: string | undefined;
    reason?: string | undefined;
    affectedCount?: number;
    ids?: string[] | undefined;
    oldType?: string | undefined;
    newType?: string | undefined;

    constructor(data?: IMigrationNeededEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.definitionIdentifier = _data["definitionIdentifier"];
            this.objectType = _data["objectType"];
            this.reason = _data["reason"];
            this.affectedCount = _data["affectedCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.oldType = _data["oldType"];
            this.newType = _data["newType"];
        }
    }

    static fromJS(data: any): MigrationNeededEntry {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationNeededEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["definitionIdentifier"] = this.definitionIdentifier;
        data["objectType"] = this.objectType;
        data["reason"] = this.reason;
        data["affectedCount"] = this.affectedCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["oldType"] = this.oldType;
        data["newType"] = this.newType;
        return data;
    }

    clone(): MigrationNeededEntry {
        const json = this.toJSON();
        let result = new MigrationNeededEntry();
        result.init(json);
        return result;
    }
}

export interface IMigrationNeededEntry {
    definitionId?: string;
    definitionIdentifier?: string | undefined;
    objectType?: string | undefined;
    reason?: string | undefined;
    affectedCount?: number;
    ids?: string[] | undefined;
    oldType?: string | undefined;
    newType?: string | undefined;
}

export class MigrationCheckNeededEntry implements IMigrationCheckNeededEntry {
    definitionId?: string;
    definitionIdentifier?: string | undefined;
    objectType?: string | undefined;
    trigger?: string | undefined;
    aspect?: string | undefined;
    detail?: string | undefined;
    affectedCount?: number;
    ids?: string[] | undefined;

    constructor(data?: IMigrationCheckNeededEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.definitionIdentifier = _data["definitionIdentifier"];
            this.objectType = _data["objectType"];
            this.trigger = _data["trigger"];
            this.aspect = _data["aspect"];
            this.detail = _data["detail"];
            this.affectedCount = _data["affectedCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): MigrationCheckNeededEntry {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationCheckNeededEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["definitionIdentifier"] = this.definitionIdentifier;
        data["objectType"] = this.objectType;
        data["trigger"] = this.trigger;
        data["aspect"] = this.aspect;
        data["detail"] = this.detail;
        data["affectedCount"] = this.affectedCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }

    clone(): MigrationCheckNeededEntry {
        const json = this.toJSON();
        let result = new MigrationCheckNeededEntry();
        result.init(json);
        return result;
    }
}

export interface IMigrationCheckNeededEntry {
    definitionId?: string;
    definitionIdentifier?: string | undefined;
    objectType?: string | undefined;
    trigger?: string | undefined;
    aspect?: string | undefined;
    detail?: string | undefined;
    affectedCount?: number;
    ids?: string[] | undefined;
}

export class DefinitionChangeEntry implements IDefinitionChangeEntry {
    objectType?: string | undefined;
    change?: DefinitionChangeType;
    identifier?: string | undefined;
    id?: string;
    context?: string | undefined;
    detail?: string | undefined;

    constructor(data?: IDefinitionChangeEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectType = _data["objectType"];
            this.change = _data["change"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
            this.context = _data["context"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): DefinitionChangeEntry {
        data = typeof data === 'object' ? data : {};
        let result = new DefinitionChangeEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType;
        data["change"] = this.change;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        data["context"] = this.context;
        data["detail"] = this.detail;
        return data;
    }

    clone(): DefinitionChangeEntry {
        const json = this.toJSON();
        let result = new DefinitionChangeEntry();
        result.init(json);
        return result;
    }
}

export interface IDefinitionChangeEntry {
    objectType?: string | undefined;
    change?: DefinitionChangeType;
    identifier?: string | undefined;
    id?: string;
    context?: string | undefined;
    detail?: string | undefined;
}

export enum DefinitionChangeType {
    Added = "Added",
    Updated = "Updated",
    Deleted = "Deleted",
    Restored = "Restored",
}

export class SeededStudyDefinitionVersionDto implements ISeededStudyDefinitionVersionDto {
    identifier?: string | undefined;
    fileVersion?: string | undefined;

    constructor(data?: ISeededStudyDefinitionVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.fileVersion = _data["fileVersion"];
        }
    }

    static fromJS(data: any): SeededStudyDefinitionVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeededStudyDefinitionVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["fileVersion"] = this.fileVersion;
        return data;
    }

    clone(): SeededStudyDefinitionVersionDto {
        const json = this.toJSON();
        let result = new SeededStudyDefinitionVersionDto();
        result.init(json);
        return result;
    }
}

export interface ISeededStudyDefinitionVersionDto {
    identifier?: string | undefined;
    fileVersion?: string | undefined;
}

export class StudyDefinitionHistoryEntryDto implements IStudyDefinitionHistoryEntryDto {
    id?: number;
    action?: string | undefined;
    category?: string | undefined;
    message?: string | undefined;
    parameters?: any | undefined;
    result?: any | undefined;
    reportFile?: string | undefined;
    validationReportFile?: string | undefined;
    definitionReportFile?: string | undefined;
    snapshotFile?: string | undefined;
    timeStamp?: Date;
    userId?: string;
    userName?: string | undefined;
    userDisplayName?: string | undefined;

    constructor(data?: IStudyDefinitionHistoryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.category = _data["category"];
            this.message = _data["message"];
            this.parameters = _data["parameters"];
            this.result = _data["result"];
            this.reportFile = _data["reportFile"];
            this.validationReportFile = _data["validationReportFile"];
            this.definitionReportFile = _data["definitionReportFile"];
            this.snapshotFile = _data["snapshotFile"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userDisplayName = _data["userDisplayName"];
        }
    }

    static fromJS(data: any): StudyDefinitionHistoryEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionHistoryEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["category"] = this.category;
        data["message"] = this.message;
        data["parameters"] = this.parameters;
        data["result"] = this.result;
        data["reportFile"] = this.reportFile;
        data["validationReportFile"] = this.validationReportFile;
        data["definitionReportFile"] = this.definitionReportFile;
        data["snapshotFile"] = this.snapshotFile;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userDisplayName"] = this.userDisplayName;
        return data;
    }

    clone(): StudyDefinitionHistoryEntryDto {
        const json = this.toJSON();
        let result = new StudyDefinitionHistoryEntryDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionHistoryEntryDto {
    id?: number;
    action?: string | undefined;
    category?: string | undefined;
    message?: string | undefined;
    parameters?: any | undefined;
    result?: any | undefined;
    reportFile?: string | undefined;
    validationReportFile?: string | undefined;
    definitionReportFile?: string | undefined;
    snapshotFile?: string | undefined;
    timeStamp?: Date;
    userId?: string;
    userName?: string | undefined;
    userDisplayName?: string | undefined;
}

export class StudyDefinitionImportRequestDto implements IStudyDefinitionImportRequestDto {
    studyDefinition?: StudyDefinitionDto | undefined;
    languages?: LanguageDto[] | undefined;
    testRun?: boolean;

    constructor(data?: IStudyDefinitionImportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyDefinition = _data["studyDefinition"] ? StudyDefinitionDto.fromJS(_data["studyDefinition"]) : <any>undefined;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
            this.testRun = _data["testRun"];
        }
    }

    static fromJS(data: any): StudyDefinitionImportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDefinitionImportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyDefinition"] = this.studyDefinition ? this.studyDefinition.toJSON() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["testRun"] = this.testRun;
        return data;
    }

    clone(): StudyDefinitionImportRequestDto {
        const json = this.toJSON();
        let result = new StudyDefinitionImportRequestDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDefinitionImportRequestDto {
    studyDefinition?: StudyDefinitionDto | undefined;
    languages?: LanguageDto[] | undefined;
    testRun?: boolean;
}

export class StudyInstituteOverviewDto extends BaseDto implements IStudyInstituteOverviewDto {
    instituteId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    locked?: boolean;
    investigatorName?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    eMail?: string | undefined;
    assignedUsers?: ShortUserDto[] | undefined;
    patients?: StudyPatientShortDto[] | undefined;
    currentUserIsAssigned?: boolean;

    constructor(data?: IStudyInstituteOverviewDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instituteId = _data["instituteId"];
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.maxPatientsCount = _data["maxPatientsCount"];
            this.locked = _data["locked"];
            this.investigatorName = _data["investigatorName"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.eMail = _data["eMail"];
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(ShortUserDto.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(StudyPatientShortDto.fromJS(item));
            }
            this.currentUserIsAssigned = _data["currentUserIsAssigned"];
        }
    }

    static fromJS(data: any): StudyInstituteOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyInstituteOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instituteId"] = this.instituteId;
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["maxPatientsCount"] = this.maxPatientsCount;
        data["locked"] = this.locked;
        data["investigatorName"] = this.investigatorName;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["eMail"] = this.eMail;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        data["currentUserIsAssigned"] = this.currentUserIsAssigned;
        super.toJSON(data);
        return data;
    }

    clone(): StudyInstituteOverviewDto {
        const json = this.toJSON();
        let result = new StudyInstituteOverviewDto();
        result.init(json);
        return result;
    }
}

export interface IStudyInstituteOverviewDto extends IBaseDto {
    instituteId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    locked?: boolean;
    investigatorName?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    eMail?: string | undefined;
    assignedUsers?: ShortUserDto[] | undefined;
    patients?: StudyPatientShortDto[] | undefined;
    currentUserIsAssigned?: boolean;
}

export class StudyInstituteDto extends BaseDto implements IStudyInstituteDto {
    instituteId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    patients?: StudyInstitutePatientDto[] | undefined;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUserId?: string;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    additionalInfo?: any | undefined;
    investigatorUserId?: string | undefined;
    investigatorUser?: UserInfoDto | undefined;

    constructor(data?: IStudyInstituteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instituteId = _data["instituteId"];
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.maxPatientsCount = _data["maxPatientsCount"];
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(StudyInstitutePatientDto.fromJS(item));
            }
            this.locked = _data["locked"];
            this.lockDate = _data["lockDate"] ? new Date(_data["lockDate"].toString()) : <any>undefined;
            this.lockedManually = _data["lockedManually"];
            this.lockedAutomatically = _data["lockedAutomatically"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUserId = _data["creatingUserId"];
            this.creatingUser = _data["creatingUser"] ? UserInfoDto.fromJS(_data["creatingUser"]) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changingUserId = _data["changingUserId"];
            this.changingUser = _data["changingUser"] ? UserInfoDto.fromJS(_data["changingUser"]) : <any>undefined;
            this.tags = _data["tags"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.additionalInfo = _data["additionalInfo"];
            this.investigatorUserId = _data["investigatorUserId"];
            this.investigatorUser = _data["investigatorUser"] ? UserInfoDto.fromJS(_data["investigatorUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StudyInstituteDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyInstituteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instituteId"] = this.instituteId;
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["maxPatientsCount"] = this.maxPatientsCount;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        data["locked"] = this.locked;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : <any>undefined;
        data["lockedManually"] = this.lockedManually;
        data["lockedAutomatically"] = this.lockedAutomatically;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUserId"] = this.creatingUserId;
        data["creatingUser"] = this.creatingUser ? this.creatingUser.toJSON() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changingUserId"] = this.changingUserId;
        data["changingUser"] = this.changingUser ? this.changingUser.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["additionalInfo"] = this.additionalInfo;
        data["investigatorUserId"] = this.investigatorUserId;
        data["investigatorUser"] = this.investigatorUser ? this.investigatorUser.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): StudyInstituteDto {
        const json = this.toJSON();
        let result = new StudyInstituteDto();
        result.init(json);
        return result;
    }
}

export interface IStudyInstituteDto extends IBaseDto {
    instituteId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    patients?: StudyInstitutePatientDto[] | undefined;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUserId?: string;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    additionalInfo?: any | undefined;
    investigatorUserId?: string | undefined;
    investigatorUser?: UserInfoDto | undefined;
}

export class StudyInstitutePatientDto extends BaseIdDto implements IStudyInstitutePatientDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    locked?: boolean;

    constructor(data?: IStudyInstitutePatientDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.locked = _data["locked"];
        }
    }

    static fromJS(data: any): StudyInstitutePatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyInstitutePatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["locked"] = this.locked;
        super.toJSON(data);
        return data;
    }

    clone(): StudyInstitutePatientDto {
        const json = this.toJSON();
        let result = new StudyInstitutePatientDto();
        result.init(json);
        return result;
    }
}

export interface IStudyInstitutePatientDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    locked?: boolean;
}

export class StudyInstituteCreateDto implements IStudyInstituteCreateDto {
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    additionalInfo?: any | undefined;
    investigatorUserId?: string | undefined;

    constructor(data?: IStudyInstituteCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.maxPatientsCount = _data["maxPatientsCount"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.additionalInfo = _data["additionalInfo"];
            this.investigatorUserId = _data["investigatorUserId"];
        }
    }

    static fromJS(data: any): StudyInstituteCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyInstituteCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["maxPatientsCount"] = this.maxPatientsCount;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["additionalInfo"] = this.additionalInfo;
        data["investigatorUserId"] = this.investigatorUserId;
        return data;
    }

    clone(): StudyInstituteCreateDto {
        const json = this.toJSON();
        let result = new StudyInstituteCreateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyInstituteCreateDto {
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    additionalInfo?: any | undefined;
    investigatorUserId?: string | undefined;
}

export class StudyInstituteUpdateDto extends BaseIdDto implements IStudyInstituteUpdateDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    lockedManually?: boolean;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    additionalInfo?: any | undefined;
    investigatorUserId?: string | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IStudyInstituteUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.maxPatientsCount = _data["maxPatientsCount"];
            this.lockedManually = _data["lockedManually"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.additionalInfo = _data["additionalInfo"];
            this.investigatorUserId = _data["investigatorUserId"];
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StudyInstituteUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyInstituteUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["maxPatientsCount"] = this.maxPatientsCount;
        data["lockedManually"] = this.lockedManually;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["additionalInfo"] = this.additionalInfo;
        data["investigatorUserId"] = this.investigatorUserId;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): StudyInstituteUpdateDto {
        const json = this.toJSON();
        let result = new StudyInstituteUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyInstituteUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayName?: string | undefined;
    isActive?: boolean;
    maxPatientsCount?: number | undefined;
    lockedManually?: boolean;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    additionalInfo?: any | undefined;
    investigatorUserId?: string | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class StudyPatientDto extends BaseDto implements IStudyPatientDto {
    patientId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    fields?: DataFieldDto[] | undefined;
    isIncluded?: boolean;
    wasIncluded?: boolean;
    inclusionDate?: Date | undefined;
    isExcluded?: boolean;
    wasExcluded?: boolean;
    exclusionDate?: Date | undefined;
    registrationDate?: Date | undefined;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    studyInstitute?: StudyPatientInstituteDto | undefined;
    validationMessages?: ValidationMessageDto[] | undefined;
    canSave?: boolean;

    constructor(data?: IStudyPatientDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDto.fromJS(item));
            }
            this.isIncluded = _data["isIncluded"];
            this.wasIncluded = _data["wasIncluded"];
            this.inclusionDate = _data["inclusionDate"] ? new Date(_data["inclusionDate"].toString()) : <any>undefined;
            this.isExcluded = _data["isExcluded"];
            this.wasExcluded = _data["wasExcluded"];
            this.exclusionDate = _data["exclusionDate"] ? new Date(_data["exclusionDate"].toString()) : <any>undefined;
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.locked = _data["locked"];
            this.lockDate = _data["lockDate"] ? new Date(_data["lockDate"].toString()) : <any>undefined;
            this.lockedManually = _data["lockedManually"];
            this.lockedAutomatically = _data["lockedAutomatically"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUser = _data["creatingUser"] ? UserInfoDto.fromJS(_data["creatingUser"]) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changingUser = _data["changingUser"] ? UserInfoDto.fromJS(_data["changingUser"]) : <any>undefined;
            this.tags = _data["tags"];
            this.studyInstitute = _data["studyInstitute"] ? StudyPatientInstituteDto.fromJS(_data["studyInstitute"]) : <any>undefined;
            if (Array.isArray(_data["validationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["validationMessages"])
                    this.validationMessages!.push(ValidationMessageDto.fromJS(item));
            }
            this.canSave = _data["canSave"];
        }
    }

    static fromJS(data: any): StudyPatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["isIncluded"] = this.isIncluded;
        data["wasIncluded"] = this.wasIncluded;
        data["inclusionDate"] = this.inclusionDate ? this.inclusionDate.toISOString() : <any>undefined;
        data["isExcluded"] = this.isExcluded;
        data["wasExcluded"] = this.wasExcluded;
        data["exclusionDate"] = this.exclusionDate ? this.exclusionDate.toISOString() : <any>undefined;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["locked"] = this.locked;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : <any>undefined;
        data["lockedManually"] = this.lockedManually;
        data["lockedAutomatically"] = this.lockedAutomatically;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUser"] = this.creatingUser ? this.creatingUser.toJSON() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changingUser"] = this.changingUser ? this.changingUser.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        data["studyInstitute"] = this.studyInstitute ? this.studyInstitute.toJSON() : <any>undefined;
        if (Array.isArray(this.validationMessages)) {
            data["validationMessages"] = [];
            for (let item of this.validationMessages)
                data["validationMessages"].push(item.toJSON());
        }
        data["canSave"] = this.canSave;
        super.toJSON(data);
        return data;
    }

    clone(): StudyPatientDto {
        const json = this.toJSON();
        let result = new StudyPatientDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientDto extends IBaseDto {
    patientId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    fields?: DataFieldDto[] | undefined;
    isIncluded?: boolean;
    wasIncluded?: boolean;
    inclusionDate?: Date | undefined;
    isExcluded?: boolean;
    wasExcluded?: boolean;
    exclusionDate?: Date | undefined;
    registrationDate?: Date | undefined;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    studyInstitute?: StudyPatientInstituteDto | undefined;
    validationMessages?: ValidationMessageDto[] | undefined;
    canSave?: boolean;
}

export class StudyPatientContextDto extends BaseDto implements IStudyPatientContextDto {
    patientId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isIncluded?: boolean;
    wasIncluded?: boolean;
    inclusionDate?: Date | undefined;
    isExcluded?: boolean;
    wasExcluded?: boolean;
    exclusionDate?: Date | undefined;
    registrationDate?: Date | undefined;
    fields?: DataFieldShortDto[] | undefined;
    locked?: boolean;
    tags?: any | undefined;
    studyInstitute?: StudyPatientInstituteDto | undefined;
    visits?: VisitContextDto[] | undefined;
    standaloneInstruments?: InstrumentContextDto[] | undefined;
    dataVerificationFlags?: VerificationFlagDto[] | undefined;

    constructor(data?: IStudyPatientContextDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.isIncluded = _data["isIncluded"];
            this.wasIncluded = _data["wasIncluded"];
            this.inclusionDate = _data["inclusionDate"] ? new Date(_data["inclusionDate"].toString()) : <any>undefined;
            this.isExcluded = _data["isExcluded"];
            this.wasExcluded = _data["wasExcluded"];
            this.exclusionDate = _data["exclusionDate"] ? new Date(_data["exclusionDate"].toString()) : <any>undefined;
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldShortDto.fromJS(item));
            }
            this.locked = _data["locked"];
            this.tags = _data["tags"];
            this.studyInstitute = _data["studyInstitute"] ? StudyPatientInstituteDto.fromJS(_data["studyInstitute"]) : <any>undefined;
            if (Array.isArray(_data["visits"])) {
                this.visits = [] as any;
                for (let item of _data["visits"])
                    this.visits!.push(VisitContextDto.fromJS(item));
            }
            if (Array.isArray(_data["standaloneInstruments"])) {
                this.standaloneInstruments = [] as any;
                for (let item of _data["standaloneInstruments"])
                    this.standaloneInstruments!.push(InstrumentContextDto.fromJS(item));
            }
            if (Array.isArray(_data["dataVerificationFlags"])) {
                this.dataVerificationFlags = [] as any;
                for (let item of _data["dataVerificationFlags"])
                    this.dataVerificationFlags!.push(VerificationFlagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyPatientContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["isIncluded"] = this.isIncluded;
        data["wasIncluded"] = this.wasIncluded;
        data["inclusionDate"] = this.inclusionDate ? this.inclusionDate.toISOString() : <any>undefined;
        data["isExcluded"] = this.isExcluded;
        data["wasExcluded"] = this.wasExcluded;
        data["exclusionDate"] = this.exclusionDate ? this.exclusionDate.toISOString() : <any>undefined;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["locked"] = this.locked;
        data["tags"] = this.tags;
        data["studyInstitute"] = this.studyInstitute ? this.studyInstitute.toJSON() : <any>undefined;
        if (Array.isArray(this.visits)) {
            data["visits"] = [];
            for (let item of this.visits)
                data["visits"].push(item.toJSON());
        }
        if (Array.isArray(this.standaloneInstruments)) {
            data["standaloneInstruments"] = [];
            for (let item of this.standaloneInstruments)
                data["standaloneInstruments"].push(item.toJSON());
        }
        if (Array.isArray(this.dataVerificationFlags)) {
            data["dataVerificationFlags"] = [];
            for (let item of this.dataVerificationFlags)
                data["dataVerificationFlags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): StudyPatientContextDto {
        const json = this.toJSON();
        let result = new StudyPatientContextDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientContextDto extends IBaseDto {
    patientId?: string;
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    isIncluded?: boolean;
    wasIncluded?: boolean;
    inclusionDate?: Date | undefined;
    isExcluded?: boolean;
    wasExcluded?: boolean;
    exclusionDate?: Date | undefined;
    registrationDate?: Date | undefined;
    fields?: DataFieldShortDto[] | undefined;
    locked?: boolean;
    tags?: any | undefined;
    studyInstitute?: StudyPatientInstituteDto | undefined;
    visits?: VisitContextDto[] | undefined;
    standaloneInstruments?: InstrumentContextDto[] | undefined;
    dataVerificationFlags?: VerificationFlagDto[] | undefined;
}

export class DataFieldShortDto extends BaseDto implements IDataFieldShortDto {
    definitionId?: string;
    values?: any | undefined;
    childFields?: DataFieldShortDto[] | undefined;
    isVisible?: boolean;
    order?: number;
    locked?: boolean;
    tags?: any | undefined;

    constructor(data?: IDataFieldShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.values = _data["values"];
            if (Array.isArray(_data["childFields"])) {
                this.childFields = [] as any;
                for (let item of _data["childFields"])
                    this.childFields!.push(DataFieldShortDto.fromJS(item));
            }
            this.isVisible = _data["isVisible"];
            this.order = _data["order"];
            this.locked = _data["locked"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): DataFieldShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataFieldShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["values"] = this.values;
        if (Array.isArray(this.childFields)) {
            data["childFields"] = [];
            for (let item of this.childFields)
                data["childFields"].push(item.toJSON());
        }
        data["isVisible"] = this.isVisible;
        data["order"] = this.order;
        data["locked"] = this.locked;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): DataFieldShortDto {
        const json = this.toJSON();
        let result = new DataFieldShortDto();
        result.init(json);
        return result;
    }
}

export interface IDataFieldShortDto extends IBaseDto {
    definitionId?: string;
    values?: any | undefined;
    childFields?: DataFieldShortDto[] | undefined;
    isVisible?: boolean;
    order?: number;
    locked?: boolean;
    tags?: any | undefined;
}

export class VisitContextDto extends BaseDto implements IVisitContextDto {
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    visitDate?: Date | undefined;
    fields?: DataFieldShortDto[] | undefined;
    instruments?: InstrumentContextDto[] | undefined;
    order?: number;
    locked?: boolean;
    tags?: any | undefined;
    isSigned?: boolean;
    signatureData?: SignatureDataDto | undefined;

    constructor(data?: IVisitContextDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.visitDate = _data["visitDate"] ? new Date(_data["visitDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldShortDto.fromJS(item));
            }
            if (Array.isArray(_data["instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["instruments"])
                    this.instruments!.push(InstrumentContextDto.fromJS(item));
            }
            this.order = _data["order"];
            this.locked = _data["locked"];
            this.tags = _data["tags"];
            this.isSigned = _data["isSigned"];
            this.signatureData = _data["signatureData"] ? SignatureDataDto.fromJS(_data["signatureData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VisitContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.instruments)) {
            data["instruments"] = [];
            for (let item of this.instruments)
                data["instruments"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["locked"] = this.locked;
        data["tags"] = this.tags;
        data["isSigned"] = this.isSigned;
        data["signatureData"] = this.signatureData ? this.signatureData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): VisitContextDto {
        const json = this.toJSON();
        let result = new VisitContextDto();
        result.init(json);
        return result;
    }
}

export interface IVisitContextDto extends IBaseDto {
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    visitDate?: Date | undefined;
    fields?: DataFieldShortDto[] | undefined;
    instruments?: InstrumentContextDto[] | undefined;
    order?: number;
    locked?: boolean;
    tags?: any | undefined;
    isSigned?: boolean;
    signatureData?: SignatureDataDto | undefined;
}

export class InstrumentContextDto extends BaseDto implements IInstrumentContextDto {
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: DataFieldShortDto[] | undefined;
    order?: number;
    locked?: boolean;
    tags?: any | undefined;

    constructor(data?: IInstrumentContextDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldShortDto.fromJS(item));
            }
            this.order = _data["order"];
            this.locked = _data["locked"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): InstrumentContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["locked"] = this.locked;
        data["tags"] = this.tags;
        super.toJSON(data);
        return data;
    }

    clone(): InstrumentContextDto {
        const json = this.toJSON();
        let result = new InstrumentContextDto();
        result.init(json);
        return result;
    }
}

export interface IInstrumentContextDto extends IBaseDto {
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: DataFieldShortDto[] | undefined;
    order?: number;
    locked?: boolean;
    tags?: any | undefined;
}

export class VerificationFlagDto extends BaseDto implements IVerificationFlagDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    definitionId?: string;
    state?: VerificationFlagState;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    creatingUserName?: string | undefined;
    changeDate?: Date | undefined;
    changingUserId?: string;
    changingUserName?: string | undefined;
    definitionType?: string | undefined;
    fieldLockedWhileSet?: boolean;
    readRoles?: string[] | undefined;
    updateRoles?: string[] | undefined;
    createRoles?: string[] | undefined;

    constructor(data?: IVerificationFlagDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUserId = _data["creatingUserId"];
            this.creatingUserName = _data["creatingUserName"];
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changingUserId = _data["changingUserId"];
            this.changingUserName = _data["changingUserName"];
            this.definitionType = _data["definitionType"];
            this.fieldLockedWhileSet = _data["fieldLockedWhileSet"];
            if (Array.isArray(_data["readRoles"])) {
                this.readRoles = [] as any;
                for (let item of _data["readRoles"])
                    this.readRoles!.push(item);
            }
            if (Array.isArray(_data["updateRoles"])) {
                this.updateRoles = [] as any;
                for (let item of _data["updateRoles"])
                    this.updateRoles!.push(item);
            }
            if (Array.isArray(_data["createRoles"])) {
                this.createRoles = [] as any;
                for (let item of _data["createRoles"])
                    this.createRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): VerificationFlagDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUserId"] = this.creatingUserId;
        data["creatingUserName"] = this.creatingUserName;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changingUserId"] = this.changingUserId;
        data["changingUserName"] = this.changingUserName;
        data["definitionType"] = this.definitionType;
        data["fieldLockedWhileSet"] = this.fieldLockedWhileSet;
        if (Array.isArray(this.readRoles)) {
            data["readRoles"] = [];
            for (let item of this.readRoles)
                data["readRoles"].push(item);
        }
        if (Array.isArray(this.updateRoles)) {
            data["updateRoles"] = [];
            for (let item of this.updateRoles)
                data["updateRoles"].push(item);
        }
        if (Array.isArray(this.createRoles)) {
            data["createRoles"] = [];
            for (let item of this.createRoles)
                data["createRoles"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VerificationFlagDto {
        const json = this.toJSON();
        let result = new VerificationFlagDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    referenceType?: string | undefined;
    referenceId?: string;
    definitionId?: string;
    state?: VerificationFlagState;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    creatingUserName?: string | undefined;
    changeDate?: Date | undefined;
    changingUserId?: string;
    changingUserName?: string | undefined;
    definitionType?: string | undefined;
    fieldLockedWhileSet?: boolean;
    readRoles?: string[] | undefined;
    updateRoles?: string[] | undefined;
    createRoles?: string[] | undefined;
}

export enum VerificationFlagState {
    NOT_SET = "NOT_SET",
    SET = "SET",
    BROKEN = "BROKEN",
    OBSOLETE = "OBSOLETE",
}

export class StudyPatientCreateDto implements IStudyPatientCreateDto {
    studyId!: string;
    fields!: DataFieldCreateDto[];
    studyInstituteId!: string;

    constructor(data?: IStudyPatientCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldCreateDto.fromJS(item));
            }
            this.studyInstituteId = _data["studyInstituteId"];
        }
    }

    static fromJS(data: any): StudyPatientCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["studyInstituteId"] = this.studyInstituteId;
        return data;
    }

    clone(): StudyPatientCreateDto {
        const json = this.toJSON();
        let result = new StudyPatientCreateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientCreateDto {
    studyId: string;
    fields: DataFieldCreateDto[];
    studyInstituteId: string;
}

export class StudyPatientUpdateDto extends BaseIdDto implements IStudyPatientUpdateDto {
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    lockedManually?: boolean;
    fields?: DataFieldUpdateDto[] | undefined;
    instituteId?: string;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IStudyPatientUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyId = _data["studyId"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.lockedManually = _data["lockedManually"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldUpdateDto.fromJS(item));
            }
            this.instituteId = _data["instituteId"];
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StudyPatientUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["lockedManually"] = this.lockedManually;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["instituteId"] = this.instituteId;
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): StudyPatientUpdateDto {
        const json = this.toJSON();
        let result = new StudyPatientUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientUpdateDto extends IBaseIdDto {
    studyId?: string;
    identifier?: string | undefined;
    displayName?: string | undefined;
    lockedManually?: boolean;
    fields?: DataFieldUpdateDto[] | undefined;
    instituteId?: string;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class StudyPatientDeleteDto extends BaseIdDto implements IStudyPatientDeleteDto {
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IStudyPatientDeleteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StudyPatientDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): StudyPatientDeleteDto {
        const json = this.toJSON();
        let result = new StudyPatientDeleteDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientDeleteDto extends IBaseIdDto {
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class IdProviderSystemRegisterPatientResultDto implements IIdProviderSystemRegisterPatientResultDto {
    success?: boolean;
    reason?: string | undefined;

    constructor(data?: IIdProviderSystemRegisterPatientResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): IdProviderSystemRegisterPatientResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdProviderSystemRegisterPatientResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["reason"] = this.reason;
        return data;
    }

    clone(): IdProviderSystemRegisterPatientResultDto {
        const json = this.toJSON();
        let result = new IdProviderSystemRegisterPatientResultDto();
        result.init(json);
        return result;
    }
}

export interface IIdProviderSystemRegisterPatientResultDto {
    success?: boolean;
    reason?: string | undefined;
}

export class StudyPatientRegisterPortalDto implements IStudyPatientRegisterPortalDto {
    patientEMail?: string | undefined;

    constructor(data?: IStudyPatientRegisterPortalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientEMail = _data["patientEMail"];
        }
    }

    static fromJS(data: any): StudyPatientRegisterPortalDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyPatientRegisterPortalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientEMail"] = this.patientEMail;
        return data;
    }

    clone(): StudyPatientRegisterPortalDto {
        const json = this.toJSON();
        let result = new StudyPatientRegisterPortalDto();
        result.init(json);
        return result;
    }
}

export interface IStudyPatientRegisterPortalDto {
    patientEMail?: string | undefined;
}

export class SynQuestLoginResponseDto implements ISynQuestLoginResponseDto {
    baseUrl?: string | undefined;
    token?: TokenDto | undefined;

    constructor(data?: ISynQuestLoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseUrl = _data["baseUrl"];
            this.token = _data["token"] ? TokenDto.fromJS(_data["token"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SynQuestLoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynQuestLoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseUrl"] = this.baseUrl;
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        return data;
    }

    clone(): SynQuestLoginResponseDto {
        const json = this.toJSON();
        let result = new SynQuestLoginResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISynQuestLoginResponseDto {
    baseUrl?: string | undefined;
    token?: TokenDto | undefined;
}

export class SynQuestSystemAuthLoginUserDto implements ISynQuestSystemAuthLoginUserDto {
    userId!: string;
    userName!: string;

    constructor(data?: ISynQuestSystemAuthLoginUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): SynQuestSystemAuthLoginUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynQuestSystemAuthLoginUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }

    clone(): SynQuestSystemAuthLoginUserDto {
        const json = this.toJSON();
        let result = new SynQuestSystemAuthLoginUserDto();
        result.init(json);
        return result;
    }
}

export interface ISynQuestSystemAuthLoginUserDto {
    userId: string;
    userName: string;
}

export class SynQuestSystemAuthLoginPatientDto implements ISynQuestSystemAuthLoginPatientDto {
    patientId!: string;

    constructor(data?: ISynQuestSystemAuthLoginPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): SynQuestSystemAuthLoginPatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynQuestSystemAuthLoginPatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        return data;
    }

    clone(): SynQuestSystemAuthLoginPatientDto {
        const json = this.toJSON();
        let result = new SynQuestSystemAuthLoginPatientDto();
        result.init(json);
        return result;
    }
}

export interface ISynQuestSystemAuthLoginPatientDto {
    patientId: string;
}

export class SynQuestSystemShortInterviewDto extends BaseDto implements ISynQuestSystemShortInterviewDto {
    patientId?: string;
    patientDisplayName?: string | undefined;
    proposalId?: string | undefined;
    displayName?: string | undefined;
    creationDate?: Date | undefined;
    isCompleted?: boolean | undefined;
    completionDate?: Date | undefined;
    isLocked?: boolean;
    lockDate?: Date | undefined;
    isDeactivated?: boolean;
    questionnaires?: SynQuestSystemShortQuestionnaireDto[] | undefined;

    constructor(data?: ISynQuestSystemShortInterviewDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.patientDisplayName = _data["patientDisplayName"];
            this.proposalId = _data["proposalId"];
            this.displayName = _data["displayName"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.isCompleted = _data["isCompleted"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
            this.isLocked = _data["isLocked"];
            this.lockDate = _data["lockDate"] ? new Date(_data["lockDate"].toString()) : <any>undefined;
            this.isDeactivated = _data["isDeactivated"];
            if (Array.isArray(_data["questionnaires"])) {
                this.questionnaires = [] as any;
                for (let item of _data["questionnaires"])
                    this.questionnaires!.push(SynQuestSystemShortQuestionnaireDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynQuestSystemShortInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynQuestSystemShortInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["patientDisplayName"] = this.patientDisplayName;
        data["proposalId"] = this.proposalId;
        data["displayName"] = this.displayName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["isCompleted"] = this.isCompleted;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["isLocked"] = this.isLocked;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : <any>undefined;
        data["isDeactivated"] = this.isDeactivated;
        if (Array.isArray(this.questionnaires)) {
            data["questionnaires"] = [];
            for (let item of this.questionnaires)
                data["questionnaires"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): SynQuestSystemShortInterviewDto {
        const json = this.toJSON();
        let result = new SynQuestSystemShortInterviewDto();
        result.init(json);
        return result;
    }
}

export interface ISynQuestSystemShortInterviewDto extends IBaseDto {
    patientId?: string;
    patientDisplayName?: string | undefined;
    proposalId?: string | undefined;
    displayName?: string | undefined;
    creationDate?: Date | undefined;
    isCompleted?: boolean | undefined;
    completionDate?: Date | undefined;
    isLocked?: boolean;
    lockDate?: Date | undefined;
    isDeactivated?: boolean;
    questionnaires?: SynQuestSystemShortQuestionnaireDto[] | undefined;
}

export class SynQuestSystemShortQuestionnaireDto implements ISynQuestSystemShortQuestionnaireDto {
    id?: string | undefined;
    displayName?: string | undefined;
    definitionId?: string | undefined;
    startDate?: Date | undefined;
    completionDate?: Date | undefined;
    isCompleted?: boolean | undefined;
    isDeactivated?: boolean | undefined;

    constructor(data?: ISynQuestSystemShortQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.definitionId = _data["definitionId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
            this.isCompleted = _data["isCompleted"];
            this.isDeactivated = _data["isDeactivated"];
        }
    }

    static fromJS(data: any): SynQuestSystemShortQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynQuestSystemShortQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["definitionId"] = this.definitionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["isCompleted"] = this.isCompleted;
        data["isDeactivated"] = this.isDeactivated;
        return data;
    }

    clone(): SynQuestSystemShortQuestionnaireDto {
        const json = this.toJSON();
        let result = new SynQuestSystemShortQuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface ISynQuestSystemShortQuestionnaireDto {
    id?: string | undefined;
    displayName?: string | undefined;
    definitionId?: string | undefined;
    startDate?: Date | undefined;
    completionDate?: Date | undefined;
    isCompleted?: boolean | undefined;
    isDeactivated?: boolean | undefined;
}

export class UserActivityLogDto implements IUserActivityLogDto {
    identifier?: string | undefined;
    additionalInformation?: any | undefined;
    executionDate?: Date;
    executingUserId?: string;
    executingUserUserName?: string | undefined;

    constructor(data?: IUserActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.additionalInformation = _data["additionalInformation"];
            this.executionDate = _data["executionDate"] ? new Date(_data["executionDate"].toString()) : <any>undefined;
            this.executingUserId = _data["executingUserId"];
            this.executingUserUserName = _data["executingUserUserName"];
        }
    }

    static fromJS(data: any): UserActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["additionalInformation"] = this.additionalInformation;
        data["executionDate"] = this.executionDate ? this.executionDate.toISOString() : <any>undefined;
        data["executingUserId"] = this.executingUserId;
        data["executingUserUserName"] = this.executingUserUserName;
        return data;
    }

    clone(): UserActivityLogDto {
        const json = this.toJSON();
        let result = new UserActivityLogDto();
        result.init(json);
        return result;
    }
}

export interface IUserActivityLogDto {
    identifier?: string | undefined;
    additionalInformation?: any | undefined;
    executionDate?: Date;
    executingUserId?: string;
    executingUserUserName?: string | undefined;
}

export class VerificationFlagUpdateDto implements IVerificationFlagUpdateDto {
    state?: VerificationFlagState;

    constructor(data?: IVerificationFlagUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): VerificationFlagUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        return data;
    }

    clone(): VerificationFlagUpdateDto {
        const json = this.toJSON();
        let result = new VerificationFlagUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagUpdateDto {
    state?: VerificationFlagState;
}

export class VerificationFlagShortDto extends BaseDto implements IVerificationFlagShortDto {
    referenceId?: string;
    definitionId?: string;
    patientId?: string;
    state?: VerificationFlagState;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    changeDate?: Date | undefined;
    changingUserId?: string;

    constructor(data?: IVerificationFlagShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.definitionId = _data["definitionId"];
            this.patientId = _data["patientId"];
            this.state = _data["state"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUserId = _data["creatingUserId"];
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changingUserId = _data["changingUserId"];
        }
    }

    static fromJS(data: any): VerificationFlagShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["definitionId"] = this.definitionId;
        data["patientId"] = this.patientId;
        data["state"] = this.state;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUserId"] = this.creatingUserId;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changingUserId"] = this.changingUserId;
        super.toJSON(data);
        return data;
    }

    clone(): VerificationFlagShortDto {
        const json = this.toJSON();
        let result = new VerificationFlagShortDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagShortDto extends IBaseDto {
    referenceId?: string;
    definitionId?: string;
    patientId?: string;
    state?: VerificationFlagState;
    creationDate?: Date | undefined;
    creatingUserId?: string;
    changeDate?: Date | undefined;
    changingUserId?: string;
}

export class VerificationFlagSetDto implements IVerificationFlagSetDto {
    referenceId?: string;
    definitionId?: string;
    state?: VerificationFlagState;
    referenceType?: string | undefined;

    constructor(data?: IVerificationFlagSetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.referenceType = _data["referenceType"];
        }
    }

    static fromJS(data: any): VerificationFlagSetDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagSetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["referenceType"] = this.referenceType;
        return data;
    }

    clone(): VerificationFlagSetDto {
        const json = this.toJSON();
        let result = new VerificationFlagSetDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagSetDto {
    referenceId?: string;
    definitionId?: string;
    state?: VerificationFlagState;
    referenceType?: string | undefined;
}

export class VerificationFlagTypeDefinitionShortDto extends BaseDto implements IVerificationFlagTypeDefinitionShortDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;

    constructor(data?: IVerificationFlagTypeDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
        }
    }

    static fromJS(data: any): VerificationFlagTypeDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagTypeDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        super.toJSON(data);
        return data;
    }

    clone(): VerificationFlagTypeDefinitionShortDto {
        const json = this.toJSON();
        let result = new VerificationFlagTypeDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagTypeDefinitionShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
}

export class VerificationFlagTypeDefinitionCreateDto implements IVerificationFlagTypeDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IVerificationFlagTypeDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): VerificationFlagTypeDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagTypeDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        return data;
    }

    clone(): VerificationFlagTypeDefinitionCreateDto {
        const json = this.toJSON();
        let result = new VerificationFlagTypeDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagTypeDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class VerificationFlagTypeDefinitionUpdateDto extends BaseIdDto implements IVerificationFlagTypeDefinitionUpdateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IVerificationFlagTypeDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): VerificationFlagTypeDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationFlagTypeDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): VerificationFlagTypeDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new VerificationFlagTypeDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationFlagTypeDefinitionUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

export class VisitShortDto extends BaseDto implements IVisitShortDto {
    patientId?: string;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    locked?: boolean;

    constructor(data?: IVisitShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.locked = _data["locked"];
        }
    }

    static fromJS(data: any): VisitShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["locked"] = this.locked;
        super.toJSON(data);
        return data;
    }

    clone(): VisitShortDto {
        const json = this.toJSON();
        let result = new VisitShortDto();
        result.init(json);
        return result;
    }
}

export interface IVisitShortDto extends IBaseDto {
    patientId?: string;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    locked?: boolean;
}

export class VisitDto extends BaseDto implements IVisitDto {
    patientId?: string;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: DataFieldDto[] | undefined;
    order?: number;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    validationMessages?: ValidationMessageDto[] | undefined;
    canSave?: boolean;

    constructor(data?: IVisitDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.definitionId = _data["definitionId"];
            this.state = _data["state"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDto.fromJS(item));
            }
            this.order = _data["order"];
            this.locked = _data["locked"];
            this.lockDate = _data["lockDate"] ? new Date(_data["lockDate"].toString()) : <any>undefined;
            this.lockedManually = _data["lockedManually"];
            this.lockedAutomatically = _data["lockedAutomatically"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creatingUser = _data["creatingUser"] ? UserInfoDto.fromJS(_data["creatingUser"]) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changingUser = _data["changingUser"] ? UserInfoDto.fromJS(_data["changingUser"]) : <any>undefined;
            this.tags = _data["tags"];
            if (Array.isArray(_data["validationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["validationMessages"])
                    this.validationMessages!.push(ValidationMessageDto.fromJS(item));
            }
            this.canSave = _data["canSave"];
        }
    }

    static fromJS(data: any): VisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["definitionId"] = this.definitionId;
        data["state"] = this.state;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["order"] = this.order;
        data["locked"] = this.locked;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : <any>undefined;
        data["lockedManually"] = this.lockedManually;
        data["lockedAutomatically"] = this.lockedAutomatically;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creatingUser"] = this.creatingUser ? this.creatingUser.toJSON() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changingUser"] = this.changingUser ? this.changingUser.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        if (Array.isArray(this.validationMessages)) {
            data["validationMessages"] = [];
            for (let item of this.validationMessages)
                data["validationMessages"].push(item.toJSON());
        }
        data["canSave"] = this.canSave;
        super.toJSON(data);
        return data;
    }

    clone(): VisitDto {
        const json = this.toJSON();
        let result = new VisitDto();
        result.init(json);
        return result;
    }
}

export interface IVisitDto extends IBaseDto {
    patientId?: string;
    definitionId?: string;
    state?: string | undefined;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    fields?: DataFieldDto[] | undefined;
    order?: number;
    locked?: boolean;
    lockDate?: Date | undefined;
    lockedManually?: boolean;
    lockedAutomatically?: boolean;
    creationDate?: Date | undefined;
    creatingUser?: UserInfoDto | undefined;
    changeDate?: Date | undefined;
    changingUser?: UserInfoDto | undefined;
    tags?: any | undefined;
    validationMessages?: ValidationMessageDto[] | undefined;
    canSave?: boolean;
}

export class VisitCreateDto implements IVisitCreateDto {
    patientId?: string;
    definitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldCreateDto[] | undefined;

    constructor(data?: IVisitCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.definitionId = _data["definitionId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.lockedManually = _data["lockedManually"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisitCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["definitionId"] = this.definitionId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["lockedManually"] = this.lockedManually;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }

    clone(): VisitCreateDto {
        const json = this.toJSON();
        let result = new VisitCreateDto();
        result.init(json);
        return result;
    }
}

export interface IVisitCreateDto {
    patientId?: string;
    definitionId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldCreateDto[] | undefined;
}

export class VisitUpdateDto extends BaseIdDto implements IVisitUpdateDto {
    patientId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldUpdateDto[] | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;

    constructor(data?: IVisitUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.lockedManually = _data["lockedManually"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldUpdateDto.fromJS(item));
            }
            this.reasonOfChange = _data["reasonOfChange"] ? AuditReasonOfChangeDto.fromJS(_data["reasonOfChange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VisitUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["lockedManually"] = this.lockedManually;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["reasonOfChange"] = this.reasonOfChange ? this.reasonOfChange.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): VisitUpdateDto {
        const json = this.toJSON();
        let result = new VisitUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVisitUpdateDto extends IBaseIdDto {
    patientId?: string;
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    lockedManually?: boolean;
    fields?: DataFieldUpdateDto[] | undefined;
    reasonOfChange?: AuditReasonOfChangeDto | undefined;
}

export class VisitSignatureResult implements IVisitSignatureResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IVisitSignatureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VisitSignatureResult {
        data = typeof data === 'object' ? data : {};
        let result = new VisitSignatureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }

    clone(): VisitSignatureResult {
        const json = this.toJSON();
        let result = new VisitSignatureResult();
        result.init(json);
        return result;
    }
}

export interface IVisitSignatureResult {
    success?: boolean;
    message?: string | undefined;
}

export class VisitSignatureDto implements IVisitSignatureDto {
    reason?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IVisitSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): VisitSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }

    clone(): VisitSignatureDto {
        const json = this.toJSON();
        let result = new VisitSignatureDto();
        result.init(json);
        return result;
    }
}

export interface IVisitSignatureDto {
    reason?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
}

export class VisitDefinitionShortDto extends BaseDto implements IVisitDefinitionShortDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;

    constructor(data?: IVisitDefinitionShortDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
        }
    }

    static fromJS(data: any): VisitDefinitionShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDefinitionShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        super.toJSON(data);
        return data;
    }

    clone(): VisitDefinitionShortDto {
        const json = this.toJSON();
        let result = new VisitDefinitionShortDto();
        result.init(json);
        return result;
    }
}

export interface IVisitDefinitionShortDto extends IBaseDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
}

export class VisitDefinitionCreateDto implements IVisitDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionCreateDto[] | undefined;

    constructor(data?: IVisitDefinitionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DataFieldDefinitionCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisitDefinitionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDefinitionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }

    clone(): VisitDefinitionCreateDto {
        const json = this.toJSON();
        let result = new VisitDefinitionCreateDto();
        result.init(json);
        return result;
    }
}

export interface IVisitDefinitionCreateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
    fields?: DataFieldDefinitionCreateDto[] | undefined;
}

export class VisitDefinitionUpdateDto extends BaseIdDto implements IVisitDefinitionUpdateDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;

    constructor(data?: IVisitDefinitionUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayKey = _data["displayKey"];
            this.order = _data["order"];
            this.studyDefinitionId = _data["studyDefinitionId"];
            this.definitionType = _data["definitionType"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): VisitDefinitionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDefinitionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayKey"] = this.displayKey;
        data["order"] = this.order;
        data["studyDefinitionId"] = this.studyDefinitionId;
        data["definitionType"] = this.definitionType;
        data["definition"] = this.definition;
        super.toJSON(data);
        return data;
    }

    clone(): VisitDefinitionUpdateDto {
        const json = this.toJSON();
        let result = new VisitDefinitionUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVisitDefinitionUpdateDto extends IBaseIdDto {
    identifier?: string | undefined;
    displayKey?: string | undefined;
    order?: number;
    studyDefinitionId?: string;
    definitionType?: string | undefined;
    definition?: any | undefined;
}

/** Enumeration of all available rights */
export enum Rights {
    AssembliesGetAllCmd = 0,
    UtilityGetPasswordCmd = 1,
    UserCountCmd = 2,
    UserCreateCmd = 3,
    UserDeactivateCmd = 4,
    UserDeleteCmd = 5,
    UserGetAllCmd = 6,
    UserGetByIdCmd = 7,
    UserGetByIdCompleteCmd = 8,
    UserGetByUsernameCmd = 9,
    UserGetCurrentCmd = 10,
    UserPasswordChangeCmd = 11,
    UserPasswordChangeForCurrentUserCmd = 12,
    UserPasswordRecoveryCmd = 13,
    UserPasswordResetCmd = 14,
    UserRestoreCmd = 15,
    UserUpdateCmd = 16,
    InstituteSendCmd = 17,
    InstituteSyncCmd = 18,
    PatientSendCmd = 19,
    PatientSyncCmd = 20,
    UserSendCmd = 21,
    UserSyncCmd = 22,
    RoleCountCmd = 23,
    RoleCreateCmd = 24,
    RoleDeleteCmd = 25,
    RoleGetAllCmd = 26,
    RoleGetByIdCmd = 27,
    RoleGetByIdentifierCmd = 28,
    RoleUpdateCmd = 29,
    RightCreateCmd = 30,
    RightGetAllCmd = 31,
    RightGetByIdCmd = 32,
    RightGetByNameCmd = 33,
    RightsGetAllForCurrentUserCmd = 34,
    RightUpdateCmd = 35,
    PatientCreateCmd = 36,
    PatientDeleteCmd = 37,
    PatientGetAllCmd = 38,
    PatientGetCmd = 39,
    PatientGetMyCmd = 40,
    PatientLinkLoginUserCmd = 41,
    PatientUpdateCmd = 42,
    InstituteActivateCmd = 43,
    InstituteCountCmd = 44,
    InstituteCreateCmd = 45,
    InstituteDeactivateCmd = 46,
    InstituteDeleteCmd = 47,
    InstituteGetAllCmd = 48,
    InstituteGetAllCompleteCmd = 49,
    InstituteGetCmd = 50,
    InstituteGetMyCmd = 51,
    InstituteGetMyCompleteCmd = 52,
    InstituteUpdateCmd = 53,
    PatientsToInstituteAssignmentCmd = 54,
    PatientToInstitutesAssignmentCmd = 55,
    UsersToInstituteAssignmentCmd = 56,
    UserToInstitutesAssignmentCmd = 57,
    IdProviderCheckConnectivityCmd = 58,
    IdProviderInstituteSyncCmd = 59,
    IdProviderPatientSyncCmd = 60,
    IdProviderUserSyncCmd = 61,
    DocumentCreateCmd = 62,
    DocumentDeleteCmd = 63,
    DocumentGetAllCmd = 64,
    DocumentGetByIdentifierCmd = 65,
    DocumentGetByIdCmd = 66,
    DocumentGetContentVersionCmd = 67,
    DocumentGetLatestContentVersionCmd = 68,
    DocumentUpdateCmd = 69,
    DocumentUpdateWithContentCmd = 70,
    DataMigrationGetAllCmd = 71,
    DataMigrationRunAllCmd = 72,
    DataMigrationRunCmd = 73,
    CheckCredentialsCmd = 74,
    LoginCmd = 75,
    LogoutCmd = 76,
    RefreshTokenCmd = 77,
    AuditTrailCountCmd = 78,
    AuditTrailGetAllCmd = 79,
    AuditTrailGetByIdCmd = 80,
    AuditLogGetEntriesCmd = 81,
    GetAuditLogExportCmd = 82,
    VisitCreateCmd = 83,
    VisitDeleteCmd = 84,
    VisitGetAllCmd = 85,
    VisitGetByIdCmd = 86,
    VisitGetByStudyIdCmd = 87,
    VisitGetMyCmd = 88,
    VisitSignatureCmd = 89,
    VisitUpdateCmd = 90,
    VisitDefinitionCreateCmd = 91,
    VisitDefinitionDeleteCmd = 92,
    VisitDefinitionGetAllCmd = 93,
    VisitDefinitionGetByIdCmd = 94,
    VisitDefinitionUpdateCmd = 95,
    VerificationFlagTypeDefinitionCreateCmd = 96,
    VerificationFlagTypeDefinitionDeleteCmd = 97,
    VerificationFlagTypeDefinitionGetAllCmd = 98,
    VerificationFlagTypeDefinitionGetByIdCmd = 99,
    VerificationFlagTypeDefinitionUpdateCmd = 100,
    VerificationFlagGetForStudyPatientCmd = 101,
    VerificationFlagSetCmd = 102,
    VerificationFlagGetByIdCmd = 103,
    VerificationFlagUpdateCmd = 104,
    UserActivityLogGetCmd = 105,
    SystemVisitGetVisitDatesForPatientCmd = 106,
    SystemVisitGetVisitTimelinesCmd = 107,
    SynQuestSystemApiCreateInterviewCmd = 108,
    SynQuestSystemApiGetInterviewCmd = 109,
    SynQuestSystemApiPatientLoginCmd = 110,
    SynQuestSystemApiUserLoginCmd = 111,
    StudyCreateCmd = 112,
    StudyDeleteCmd = 113,
    StudyGetAllCmd = 114,
    StudyGetByIdCmd = 115,
    StudyGetMyCmd = 116,
    StudyUpdateCmd = 117,
    StudyPatientCreateCmd = 118,
    StudyPatientDeleteCmd = 119,
    StudyPatientGetAllCmd = 120,
    StudyPatientGetByIdCmd = 121,
    StudyPatientGetByStudyIdCmd = 122,
    StudyPatientGetContextByIdCmd = 123,
    StudyPatientGetMyCmd = 124,
    StudyPatientRegisterPortalCmd = 125,
    StudyPatientUpdateCmd = 126,
    StudyInstituteCreateCmd = 127,
    StudyInstituteDeleteCmd = 128,
    StudyInstituteGetAllCmd = 129,
    StudyInstituteGetByIdCmd = 130,
    StudyInstituteGetByStudyIdCmd = 131,
    StudyInstituteGetMyCmd = 132,
    StudyInstituteOverviewGetAllCmd = 133,
    StudyInstituteOverviewGetMyCmd = 134,
    StudyInstituteUpdateCmd = 135,
    StudyDefinitionSystemGetCmd = 136,
    StudyDefinitionSystemImportCmd = 137,
    ExportStudyDefinitionCmd = 138,
    ExportStudySeederDefinitionCmd = 139,
    ImportStudyDefinitionCmd = 140,
    SeededStudyDefinitionVersionsGetCmd = 141,
    StudyDefinitionCreateCmd = 142,
    StudyDefinitionDeleteCmd = 143,
    StudyDefinitionGetAllCmd = 144,
    StudyDefinitionGetByIdCmd = 145,
    StudyDefinitionHistoryGetEntriesCmd = 146,
    StudyDefinitionHistoryGetFileCmd = 147,
    StudyDefinitionUpdateCmd = 148,
    UpdateStudyDefinitionDatesCmd = 149,
    EventReportOverviewGetMyCmd = 150,
    SafetyReportCmd = 151,
    SafetyReportConfigurationGetCmd = 152,
    SafetyReportConfigurationPutCmd = 153,
    SafetyScreeningReportCmd = 154,
    SignatureGetByIdCmd = 155,
    SignatureGetByReferenceIdCmd = 156,
    RuleDefinitionCreateCmd = 157,
    RuleDefinitionDeleteCmd = 158,
    RuleDefinitionGetAllCmd = 159,
    RuleDefinitionGetByIdCmd = 160,
    RuleDefinitionUpdateCmd = 161,
    QueryTypeDefinitionCreateCmd = 162,
    QueryTypeDefinitionDeleteCmd = 163,
    QueryTypeDefinitionGetAllCmd = 164,
    QueryTypeDefinitionGetByIdCmd = 165,
    QueryTypeDefinitionUpdateCmd = 166,
    QueryAcceptCmd = 167,
    QueryAnswerCmd = 168,
    QueryCreateCmd = 169,
    QueryDeferCmd = 170,
    QueryEditCmd = 171,
    QueryGetAllCmd = 172,
    QueryGetAllForInstrumentCmd = 173,
    QueryGetAllForPatientCmd = 174,
    QueryGetAllForVisitCmd = 175,
    QueryGetByIdCmd = 176,
    QueryGetForInstituteCmd = 177,
    QueryGetForInstrumentCmd = 178,
    QueryGetForPatientCmd = 179,
    QueryGetForVisitCmd = 180,
    QueryGetMyCmd = 181,
    QueryGetMyForPatientCmd = 182,
    QueryGetOverviewCmd = 183,
    QueryGetVisitsStatesCmd = 184,
    QueryRevokeCmd = 185,
    QuerySolveCmd = 186,
    PatientDefinitionCreateCmd = 187,
    PatientDefinitionDeleteCmd = 188,
    PatientDefinitionGetAllCmd = 189,
    PatientDefinitionGetByIdCmd = 190,
    PatientDefinitionUpdateCmd = 191,
    NtdInstituteCreateCmd = 192,
    NtdInstituteDeleteCmd = 193,
    NtdInstituteGetAllCmd = 194,
    NtdInstituteGetMyCmd = 195,
    NtdInstituteUpdateCmd = 196,
    NtdPatientCreateForStudyPatientCmd = 197,
    NtdPatientCreateOrUpdateCmd = 198,
    NtdPatientGetForStudyPatientCmd = 199,
    NtdStatusCmd = 200,
    NtdUserCreateOrUpdateCmd = 201,
    NtdUserGetAllCmd = 202,
    LanguageCreateCmd = 203,
    LanguageDeleteCmd = 204,
    LanguageGetAllCmd = 205,
    LanguageGetByIdCmd = 206,
    LanguageUpdateCmd = 207,
    LanguageEntryCreateCmd = 208,
    LanguageEntryDeleteCmd = 209,
    LanguageEntryGetAllCmd = 210,
    LanguageEntryGetByIdCmd = 211,
    LanguageEntryUpdateCmd = 212,
    InstrumentCreateCmd = 213,
    InstrumentDataFieldCreateCmd = 214,
    InstrumentDataFieldDeleteCmd = 215,
    InstrumentDataFieldUpdateCmd = 216,
    InstrumentDeleteCmd = 217,
    InstrumentGetByIdCmd = 218,
    InstrumentGetByStudyIdCmd = 219,
    InstrumentGetTemporaryCmd = 220,
    InstrumentGetTemporaryDataFieldCmd = 221,
    InstrumentUpdateCmd = 222,
    InstrumentDefinitionCreateCmd = 223,
    InstrumentDefinitionDeleteCmd = 224,
    InstrumentDefinitionGetAllCmd = 225,
    InstrumentDefinitionGetByIdCmd = 226,
    InstrumentDefinitionUpdateCmd = 227,
    HtmlDocumentCreateCmd = 228,
    HtmlDocumentDeleteCmd = 229,
    HtmlDocumentGetAllCmd = 230,
    HtmlDocumentGetByIdCmd = 231,
    HtmlDocumentGetByIdentifierCmd = 232,
    HtmlDocumentUpdateCmd = 233,
    ExportGetCsvCmd = 234,
    FinalExportGetCmd = 235,
    SafetyScreeningExportGetFileCmd = 236,
    SafetyScreeningExportGetFilesCmd = 237,
    SasExportGetCmd = 238,
    SasExportGetFileCmd = 239,
    SasExportGetFilesCmd = 240,
    StudyCsvExportGetFileCmd = 241,
    StudyCsvExportGetFilesCmd = 242,
    QueriesExportGetCmd = 243,
    QueriesExportGetFileCmd = 244,
    QueriesExportGetFilesCmd = 245,
    QueriesOverviewExportGetCmd = 246,
    QueriesOverviewExportGetFileCmd = 247,
    QueriesOverviewExportGetFilesCmd = 248,
    UserQueriesExportGetCmd = 249,
    UserQueriesExportGetFileCmd = 250,
    UserQueriesExportGetFilesCmd = 251,
    PortalStatusExportCmd = 252,
    PortalStatusExportGetFileCmd = 253,
    PortalStatusExportGetFilesCmd = 254,
    InterviewsStatusExportCmd = 255,
    InterviewStatusExportGetFileCmd = 256,
    InterviewStatusExportGetFilesCmd = 257,
    ChangesExportCmd = 258,
    ChangesExportGetFileCmd = 259,
    ChangesExportGetFilesCmd = 260,
    FreeTextChangesExportCmd = 261,
    FreeTextChangesExportGetFileCmd = 262,
    FreeTextChangesExportGetFilesCmd = 263,
    EventReportDeactivationCmd = 264,
    EventReportFieldsGetCmd = 265,
    EventReportSignatureCmd = 266,
    EnumValueSetCreateCmd = 267,
    EnumValueSetDeleteCmd = 268,
    EnumValueSetGetAllCmd = 269,
    EnumValueSetGetByIdCmd = 270,
    EnumValueSetUpdateCmd = 271,
    ELearningDefinitionCreateCmd = 272,
    ELearningDefinitionDeleteCmd = 273,
    ELearningDefinitionGetAllCmd = 274,
    ELearningDefinitionGetByIdCmd = 275,
    ELearningDefinitionGetByStudyDefinitionCmd = 276,
    ELearningDefinitionUpdateCmd = 277,
    ELearningRequireForUserCmd = 278,
    ELearningResultGetAllCmd = 279,
    ELearningResultGetByIdCmd = 280,
    ELearningResultGetForUserCmd = 281,
    ELearningResultSubmitCmd = 282,
    DocumentationGetAnnotatedEcrfCmd = 283,
    DocumentationGetAnnotatedEcrfViewCmd = 284,
    DocumentationGetCompleteCmd = 285,
    DocumentationGetFunctionalDesignCmd = 286,
    DataQualityCheckGetAllCmd = 287,
    DataQualityCheckRunCmd = 288,
    DataFieldDefinitionCreateCmd = 289,
    DataFieldDefinitionDeleteCmd = 290,
    DataFieldDefinitionGetAllCmd = 291,
    DataFieldDefinitionGetByIdCmd = 292,
    DataFieldDefinitionUpdateCmd = 293,
    ConstraintDefinitionCreateCmd = 294,
    ConstraintDefinitionDeleteCmd = 295,
    ConstraintDefinitionGetAllCmd = 296,
    ConstraintDefinitionGetByIdCmd = 297,
    ConstraintDefinitionUpdateCmd = 298,
    AuditTrailGetInstrumentCmd = 299,
    AuditTrailGetQueryCmd = 300,
    AuditTrailGetStudyInstituteCmd = 301,
    AuditTrailGetStudyPatientCmd = 302,
    AuditTrailGetUserCmd = 303,
    AuditTrailGetVisitCmd = 304,
    AkromegalieReconciliationExportGetCmd = 305,
    AkromegalieReconciliationExportGetFileCmd = 306,
    AkromegalieReconciliationExportGetFilesCmd = 307,
    AkromegalieRewardExportGetCmd = 308,
    AkromegalieRewardExportGetFileCmd = 309,
    AkromegalieRewardExportGetFilesCmd = 310,
    AkromegalieStatusExportGetCmd = 311,
    AkromegalieStatusExportGetFileCmd = 312,
    AkromegalieStatusExportGetFilesCmd = 313,
    AkromegalieGetMyVisualizationDataCmd = 314,
    AkromegalieGetVisualizationDataCmd = 315,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

}
